/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * @vestwell-unified-api/hooks
 * hooks for interacting with vestwell-unified-api
 * OpenAPI spec version: 1.30.1
 */ import { faker } from "@faker-js/faker";
import { useMutation, useQuery } from "@tanstack/react-query";
import { http, HttpResponse } from "msw";
import { client } from "./client";
export const PortalMiddlewarePostOnboardingSchemaType = {
    digital_onboarding: 'digital_onboarding',
    esa_onboarding: 'esa_onboarding',
    jpm_conversion: 'jpm_conversion',
    state_conversion: 'state_conversion',
    state_onboarding: 'state_onboarding',
    voya_onboarding: 'voya_onboarding'
};
export const PortalMiddlewareGetOnboardingSchemaType = {
    digital_onboarding: 'digital_onboarding',
    esa_onboarding: 'esa_onboarding',
    jpm_conversion: 'jpm_conversion',
    state_conversion: 'state_conversion',
    state_onboarding: 'state_onboarding',
    voya_onboarding: 'voya_onboarding'
};
export const PortalMiddlewareGetAgeBasedModelType = {
    nli: 'nli',
    target: 'target'
};
export const PortalMiddlewareGetEmployeePendingTransactionsExcludeDistributionMethods = {
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER',
    FULL_CASH: 'FULL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_CASH: 'PARTIAL_CASH',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER'
};
export const PortalMiddlewareGetEmployeePerformanceExcludeDistributionMethods = {
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER',
    FULL_CASH: 'FULL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_CASH: 'PARTIAL_CASH',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER'
};
export const PortalMiddlewareGetEmployeeLoansExcludeDistributionMethods = {
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER',
    FULL_CASH: 'FULL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_CASH: 'PARTIAL_CASH',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER'
};
export const PortalMiddlewareGetEmployeeHoldingsExcludeDistributionMethods = {
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER',
    FULL_CASH: 'FULL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_CASH: 'PARTIAL_CASH',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER'
};
export const OnboardingDocumentGetSigningMappingsStatus = {
    pending: 'pending',
    signed: 'signed',
    void: 'void'
};
export const VssStatusStatus = {
    none: 'none',
    normal: 'normal',
    readOnly: 'readOnly',
    unknown: 'unknown'
};
export const VssPlanType = {
    able: 'able',
    collegeSavings: 'collegeSavings',
    secureChoice: 'secureChoice'
};
export const RolloverDeliveryDtoMailType = {
    Express_Mail: 'Express Mail',
    Normal_Mail: 'Normal Mail'
};
export const RecurringGiftParametersOccasion = {
    birthday: 'birthday',
    congratulations: 'congratulations',
    'get-well': 'get-well',
    graduation: 'graduation',
    holiday: 'holiday',
    'just-because': 'just-because'
};
export const RecurringGiftFrequency = {
    biMonthly: 'biMonthly',
    monthly: 'monthly',
    yearly: 'yearly'
};
export const PostWithdrawalBodyDtoReason = {
    ACP_CORRECTIVE: 'ACP_CORRECTIVE',
    ADP_CORRECTIVE: 'ADP_CORRECTIVE',
    CASH_OUT: 'CASH_OUT',
    CHILD: 'CHILD',
    DEATH: 'DEATH',
    '402G': '402G',
    DISABILITY: 'DISABILITY',
    EACA: 'EACA',
    FEE_OUT: 'FEE_OUT',
    FORCE_OUT: 'FORCE_OUT',
    ESA: 'ESA',
    HARDSHIP: 'HARDSHIP',
    IN_SERVICE: 'IN_SERVICE',
    NUMBER_415: '415',
    PARTICIPANT_TERMINATION: 'PARTICIPANT_TERMINATION',
    PLAN_TERMINATION: 'PLAN_TERMINATION',
    QACA: 'QACA',
    QDRO: 'QDRO',
    REQUIRED_MINIMUM: 'REQUIRED_MINIMUM',
    RETIREMENT_AGE: 'RETIREMENT_AGE',
    ROLLOVER: 'ROLLOVER'
};
export const PostWithdrawalBodyDtoDistributionMethod = {
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER',
    FULL_CASH: 'FULL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_CASH: 'PARTIAL_CASH',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER'
};
export const PostSubaInitiateExternalTransferBodyDtoExternalTransferType = {
    transferFromExternal: 'transferFromExternal',
    transferToExternal: 'transferToExternal'
};
export const PostParticipantPlaidLinksBalanceResDtoPlaidAccountType = {
    brokerage: 'brokerage',
    credit: 'credit',
    depository: 'depository',
    investment: 'investment',
    loan: 'loan',
    other: 'other'
};
export const PostParticipantPlaidLinksBalanceResDtoPlaidAccountSubtype = {
    '401a': '401a',
    '401k': '401k',
    '403B': '403B',
    '457b': '457b',
    NUMBER_529: '529',
    brokerage: 'brokerage',
    cash_isa: 'cash isa',
    crypto_exchange: 'crypto exchange',
    ebt: 'ebt',
    education_savings_account: 'education savings account',
    fixed_annuity: 'fixed annuity',
    gic: 'gic',
    health_reimbursement_arrangement: 'health reimbursement arrangement',
    hsa: 'hsa',
    ira: 'ira',
    isa: 'isa',
    lif: 'lif',
    life_insurance: 'life insurance',
    lira: 'lira',
    lrif: 'lrif',
    lrsp: 'lrsp',
    'non-custodial_wallet': 'non-custodial wallet',
    'non-taxable_brokerage_account': 'non-taxable brokerage account',
    other: 'other',
    other_annuity: 'other annuity',
    other_insurance: 'other insurance',
    pension: 'pension',
    prif: 'prif',
    profit_sharing_plan: 'profit sharing plan',
    rdsp: 'rdsp',
    resp: 'resp',
    retirement: 'retirement',
    rlif: 'rlif',
    roth: 'roth',
    roth_401k: 'roth 401k',
    rrif: 'rrif',
    credit_card: 'credit card',
    rrsp: 'rrsp',
    cd: 'cd',
    sep_ira: 'sep ira',
    checking: 'checking',
    simple_ira: 'simple ira',
    money_market: 'money market',
    sipp: 'sipp',
    auto: 'auto',
    stock_plan: 'stock plan',
    business: 'business',
    tfsa: 'tfsa',
    commercial: 'commercial',
    thrift_savings_plan: 'thrift savings plan',
    construction: 'construction',
    trust: 'trust',
    consumer: 'consumer',
    ugma: 'ugma',
    home_equity: 'home equity',
    variable_annuity: 'variable annuity',
    cash_management: 'cash management',
    paypal: 'paypal',
    keogh: 'keogh',
    line_of_credit: 'line of credit',
    savings: 'savings',
    loan: 'loan',
    prepaid: 'prepaid',
    mortgage: 'mortgage',
    mutual_fund: 'mutual fund',
    null: 'null',
    overdraft: 'overdraft',
    payroll: 'payroll',
    recurring: 'recurring',
    rewards: 'rewards',
    safe_deposit: 'safe deposit',
    sarsep: 'sarsep',
    student: 'student'
};
export const PostMsManagedAccountsPreviewAllocationBodyDtoRiskTolerance = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
export const PostMsManagedAccountsActivateBodyDtoRiskTolerance = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
export const PostMsManagedAccounts401KManagerQuestionnaireResDtoRiskTolerance = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
export const PostCensusCacheBodyDtoSchemaType = {
    digital_onboarding: 'digital_onboarding',
    esa_onboarding: 'esa_onboarding',
    jpm_conversion: 'jpm_conversion',
    state_conversion: 'state_conversion',
    state_onboarding: 'state_onboarding',
    voya_onboarding: 'voya_onboarding'
};
export const PdfConfigDtoFormat = {
    a0: 'a0',
    a1: 'a1',
    a2: 'a2',
    a3: 'a3',
    a4: 'a4',
    a5: 'a5',
    ledger: 'ledger',
    a6: 'a6',
    legal: 'legal',
    letter: 'letter',
    tabloid: 'tabloid'
};
export const PatchStatefulSchemaTrackingStatusBodyDtoStatus = {
    completed_successfully: 'completed_successfully',
    completed_unsuccessfully: 'completed_unsuccessfully',
    in_progress: 'in_progress',
    needs_attention: 'needs_attention',
    new: 'new',
    ongoing: 'ongoing'
};
export const PatchSponsorQuestionnaireDtoOnboardingPlanDesignCallStatus = {
    Plan_Design_Call_Delayed: 'Plan Design Call Delayed',
    Plan_Design_Call_Scheduled: 'Plan Design Call Scheduled'
};
export const PatchEsaWithdrawalBodyDtoEsaReason = {
    AUTOMOBILE: 'AUTOMOBILE',
    FUNERAL: 'FUNERAL',
    MEDICAL: 'MEDICAL',
    NOT_SAY: 'NOT_SAY',
    OTHER: 'OTHER',
    REPAIR_RESIDENCE: 'REPAIR_RESIDENCE',
    TUITION_EDUCATION: 'TUITION_EDUCATION'
};
export const ParticipantInvestmentsModelDtoModelType = {
    goal: 'goal',
    menu: 'menu',
    ms_ma: 'ms_ma',
    ms_ma_menu: 'ms_ma_menu',
    nli: 'nli',
    pmenu: 'pmenu',
    risk: 'risk',
    target: 'target'
};
export const ParticipantInvestmentElectionRiskProfile = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
export const ModelWithPerformanceModelType = {
    goal: 'goal',
    menu: 'menu',
    ms_ma: 'ms_ma',
    ms_ma_menu: 'ms_ma_menu',
    nli: 'nli',
    pmenu: 'pmenu',
    risk: 'risk',
    target: 'target'
};
export const ModelModelType = {
    goal: 'goal',
    menu: 'menu',
    ms_ma: 'ms_ma',
    ms_ma_menu: 'ms_ma_menu',
    nli: 'nli',
    pmenu: 'pmenu',
    risk: 'risk',
    target: 'target'
};
export const GiftSubmissionBodyDtoOccasion = {
    birthday: 'birthday',
    congratulations: 'congratulations',
    'get-well': 'get-well',
    graduation: 'graduation',
    holiday: 'holiday',
    'just-because': 'just-because'
};
export const GiftSubmissionBodyDtoFrequency = {
    biMonthly: 'biMonthly',
    monthly: 'monthly',
    yearly: 'yearly'
};
export const GiftPaymentMethod = {
    ach: 'ach',
    debit: 'debit'
};
export const GiftPaymentAccountType = {
    checking: 'checking',
    prepaid: 'prepaid',
    savings: 'savings'
};
export const GiftContributorBankBankAccountType = {
    checking: 'checking',
    prepaid: 'prepaid',
    savings: 'savings'
};
export const GetSigningMappingsResDtoStatus = {
    pending: 'pending',
    signed: 'signed',
    void: 'void'
};
export const GetPlanStatisticsModelAgeDistributionModelType = {
    goal: 'goal',
    menu: 'menu',
    ms_ma: 'ms_ma',
    ms_ma_menu: 'ms_ma_menu',
    nli: 'nli',
    pmenu: 'pmenu',
    risk: 'risk',
    target: 'target'
};
export const GetPlanStatisticsModelAgeDistributionAgeRange = {
    '26-35': '26-35',
    '36-45': '36-45',
    '46-55': '46-55',
    '56-65': '56-65',
    '<=25': '<=25',
    '>=66': '>=66'
};
export const GetPlanDesignConsultStateResDtoPlanDesignConsultType = {
    Full_Consultation: 'Full Consultation',
    Partner_Consultation: 'Partner Consultation',
    Sales_Consultation: 'Sales Consultation',
    Self_Service_Tiles: 'Self Service Tiles',
    'Solo(K)': 'Solo(K)',
    Website_Direct: 'Website Direct'
};
export const GetParticipantLoanCreateLoanPreferencesAllowedPayFrequenciesItem = {
    B: 'B',
    M: 'M',
    ME: 'ME',
    S: 'S',
    SC: 'SC',
    W: 'W'
};
export const GetParticipantLoanCreateLoanPreferencesAllowedLoanPurposesItem = {
    General: 'General',
    Principal_Residence_Purchase: 'Principal Residence Purchase'
};
export const GetParticipantBeneficiariesResDtoRelationship = {
    child: 'child',
    other: 'other',
    parent: 'parent',
    spouse: 'spouse'
};
export const GetParticipantBeneficiariesResDtoBeneficiaryType = {
    organization: 'organization',
    person: 'person',
    trust: 'trust'
};
export const GetOnboardingDtoStatus = {
    completed_successfully: 'completed_successfully',
    completed_unsuccessfully: 'completed_unsuccessfully',
    in_progress: 'in_progress',
    needs_attention: 'needs_attention',
    new: 'new',
    ongoing: 'ongoing'
};
export const GetMsManagedAccountsPreviewAllocationResDtoRiskTolerance = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
export const AgeBasedBodyDtoModelType = {
    nli: 'nli',
    target: 'target'
};
export const healthGetConnectivity = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/connectivity`
    });
};
export const getHealthGetConnectivityQueryKey = ()=>{
    return [
        `/connectivity`
    ];
};
export const getHealthGetConnectivityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getHealthGetConnectivityQueryKey();
    const queryFn = ({ signal })=>healthGetConnectivity(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useHealthGetConnectivity(options) {
    const queryOptions = getHealthGetConnectivityQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const healthPostDemoSDK = (introspectReqDto)=>{
    return client({
        data: introspectReqDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/demo-sdk`
    });
};
export const getHealthPostDemoSDKMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return healthPostDemoSDK(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useHealthPostDemoSDK = (options)=>{
    const mutationOptions = getHealthPostDemoSDKMutationOptions(options);
    return useMutation(mutationOptions);
};
export const healthGetHealth = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/health`
    });
};
export const getHealthGetHealthQueryKey = ()=>{
    return [
        `/health`
    ];
};
export const getHealthGetHealthQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getHealthGetHealthQueryKey();
    const queryFn = ({ signal })=>healthGetHealth(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useHealthGetHealth(options) {
    const queryOptions = getHealthGetHealthQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingHealthGetConnectivity = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/connectivity`
    });
};
export const getOnboardingHealthGetConnectivityQueryKey = ()=>{
    return [
        `/ob/connectivity`
    ];
};
export const getOnboardingHealthGetConnectivityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingHealthGetConnectivityQueryKey();
    const queryFn = ({ signal })=>onboardingHealthGetConnectivity(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingHealthGetConnectivity(options) {
    const queryOptions = getOnboardingHealthGetConnectivityQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingHealthPostDemoSdk = (demoReqDto)=>{
    return client({
        data: demoReqDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/ob/demo-sdk`
    });
};
export const getOnboardingHealthPostDemoSdkMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return onboardingHealthPostDemoSdk(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useOnboardingHealthPostDemoSdk = (options)=>{
    const mutationOptions = getOnboardingHealthPostDemoSdkMutationOptions(options);
    return useMutation(mutationOptions);
};
export const onboardingDocumentGetSigningMappings = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/ob/document/signing-mappings`
    });
};
export const getOnboardingDocumentGetSigningMappingsQueryKey = (params)=>{
    return [
        `/ob/document/signing-mappings`,
        ...params ? [
            params
        ] : []
    ];
};
export const getOnboardingDocumentGetSigningMappingsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingDocumentGetSigningMappingsQueryKey(params);
    const queryFn = ({ signal })=>onboardingDocumentGetSigningMappings(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingDocumentGetSigningMappings(params, options) {
    const queryOptions = getOnboardingDocumentGetSigningMappingsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingDocusignGetDocusignConnectivity = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/docusign/connectivity`
    });
};
export const getOnboardingDocusignGetDocusignConnectivityQueryKey = ()=>{
    return [
        `/ob/docusign/connectivity`
    ];
};
export const getOnboardingDocusignGetDocusignConnectivityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingDocusignGetDocusignConnectivityQueryKey();
    const queryFn = ({ signal })=>onboardingDocusignGetDocusignConnectivity(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingDocusignGetDocusignConnectivity(options) {
    const queryOptions = getOnboardingDocusignGetDocusignConnectivityQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingDocusignGetEnvelopes = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/docusign/envelopes`
    });
};
export const getOnboardingDocusignGetEnvelopesQueryKey = ()=>{
    return [
        `/ob/docusign/envelopes`
    ];
};
export const getOnboardingDocusignGetEnvelopesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingDocusignGetEnvelopesQueryKey();
    const queryFn = ({ signal })=>onboardingDocusignGetEnvelopes(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingDocusignGetEnvelopes(options) {
    const queryOptions = getOnboardingDocusignGetEnvelopesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingDocusignGetEnvelope = (envelopeId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/docusign/envelopes/${envelopeId}`
    });
};
export const getOnboardingDocusignGetEnvelopeQueryKey = (envelopeId)=>{
    return [
        `/ob/docusign/envelopes/${envelopeId}`
    ];
};
export const getOnboardingDocusignGetEnvelopeQueryOptions = (envelopeId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingDocusignGetEnvelopeQueryKey(envelopeId);
    const queryFn = ({ signal })=>onboardingDocusignGetEnvelope(envelopeId, signal);
    return {
        enabled: !!envelopeId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingDocusignGetEnvelope(envelopeId, options) {
    const queryOptions = getOnboardingDocusignGetEnvelopeQueryOptions(envelopeId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingDocusignGetEnvelopeRecipients = (envelopeId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/docusign/envelopes/${envelopeId}/signers`
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsQueryKey = (envelopeId)=>{
    return [
        `/ob/docusign/envelopes/${envelopeId}/signers`
    ];
};
export const getOnboardingDocusignGetEnvelopeRecipientsQueryOptions = (envelopeId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingDocusignGetEnvelopeRecipientsQueryKey(envelopeId);
    const queryFn = ({ signal })=>onboardingDocusignGetEnvelopeRecipients(envelopeId, signal);
    return {
        enabled: !!envelopeId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingDocusignGetEnvelopeRecipients(envelopeId, options) {
    const queryOptions = getOnboardingDocusignGetEnvelopeRecipientsQueryOptions(envelopeId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingDocusignPostEnvelopeRecipient = (envelopeId, postEnvelopeRecipientBodyDto)=>{
    return client({
        data: postEnvelopeRecipientBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/ob/docusign/envelopes/${envelopeId}/views/recipient`
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { envelopeId, data } = props ?? {};
        return onboardingDocusignPostEnvelopeRecipient(envelopeId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useOnboardingDocusignPostEnvelopeRecipient = (options)=>{
    const mutationOptions = getOnboardingDocusignPostEnvelopeRecipientMutationOptions(options);
    return useMutation(mutationOptions);
};
export const onboardingDocusignGetAccessToken = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/docusign/token`
    });
};
export const getOnboardingDocusignGetAccessTokenQueryKey = ()=>{
    return [
        `/ob/docusign/token`
    ];
};
export const getOnboardingDocusignGetAccessTokenQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingDocusignGetAccessTokenQueryKey();
    const queryFn = ({ signal })=>onboardingDocusignGetAccessToken(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingDocusignGetAccessToken(options) {
    const queryOptions = getOnboardingDocusignGetAccessTokenQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingDocusignGetUserInfo = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/docusign/user-info`
    });
};
export const getOnboardingDocusignGetUserInfoQueryKey = ()=>{
    return [
        `/ob/docusign/user-info`
    ];
};
export const getOnboardingDocusignGetUserInfoQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingDocusignGetUserInfoQueryKey();
    const queryFn = ({ signal })=>onboardingDocusignGetUserInfo(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingDocusignGetUserInfo(options) {
    const queryOptions = getOnboardingDocusignGetUserInfoQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingHealthGetHealth = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/health`
    });
};
export const getOnboardingHealthGetHealthQueryKey = ()=>{
    return [
        `/ob/health`
    ];
};
export const getOnboardingHealthGetHealthQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingHealthGetHealthQueryKey();
    const queryFn = ({ signal })=>onboardingHealthGetHealth(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingHealthGetHealth(options) {
    const queryOptions = getOnboardingHealthGetHealthQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAdvisorById = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/advisor`
    });
};
export const getPortalMiddlewareGetAdvisorByIdQueryKey = (params)=>{
    return [
        `/pm/api/advisor`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAdvisorByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAdvisorByIdQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetAdvisorById(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAdvisorById(params, options) {
    const queryOptions = getPortalMiddlewareGetAdvisorByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAdvisorCommercialPlatforms = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/advisor/commercial-platforms`
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsQueryKey = (params)=>{
    return [
        `/pm/api/advisor/commercial-platforms`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAdvisorCommercialPlatformsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetAdvisorCommercialPlatforms(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAdvisorCommercialPlatforms(params, options) {
    const queryOptions = getPortalMiddlewareGetAdvisorCommercialPlatformsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAdvisorContactCard = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/advisor/contact-card`
    });
};
export const getPortalMiddlewareGetAdvisorContactCardQueryKey = ()=>{
    return [
        `/pm/api/advisor/contact-card`
    ];
};
export const getPortalMiddlewareGetAdvisorContactCardQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAdvisorContactCardQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetAdvisorContactCard(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAdvisorContactCard(options) {
    const queryOptions = getPortalMiddlewareGetAdvisorContactCardQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutAdvisorContactCard = (advisorContactCardBodyDto)=>{
    return client({
        data: advisorContactCardBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/advisor/contact-card`
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutAdvisorContactCard(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutAdvisorContactCard = (options)=>{
    const mutationOptions = getPortalMiddlewarePutAdvisorContactCardMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlans = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/advisor/plans`
    });
};
export const getPortalMiddlewareGetPlansQueryKey = (params)=>{
    return [
        `/pm/api/advisor/plans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlansQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlansQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlans(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlans(params, options) {
    const queryOptions = getPortalMiddlewareGetPlansQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAdvisorAnnualTestingPlansPerYear = (year, params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/advisor/plans/annual-testing/${year}`
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearQueryKey = (year, params)=>{
    return [
        `/pm/api/advisor/plans/annual-testing/${year}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearQueryOptions = (year, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearQueryKey(year, params);
    const queryFn = ({ signal })=>portalMiddlewareGetAdvisorAnnualTestingPlansPerYear(year, params, signal);
    return {
        enabled: !!year,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAdvisorAnnualTestingPlansPerYear(year, params, options) {
    const queryOptions = getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearQueryOptions(year, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlansTracker = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/advisor/plans/tracker`
    });
};
export const getPortalMiddlewareGetPlansTrackerQueryKey = (params)=>{
    return [
        `/pm/api/advisor/plans/tracker`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlansTrackerQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlansTrackerQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlansTracker(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlansTracker(params, options) {
    const queryOptions = getPortalMiddlewareGetPlansTrackerQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAdvisorPlanEmployees = (planId, params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/advisor/plans/${planId}/employees`
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesQueryKey = (planId, params)=>{
    return [
        `/pm/api/advisor/plans/${planId}/employees`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesQueryOptions = (planId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAdvisorPlanEmployeesQueryKey(planId, params);
    const queryFn = ({ signal })=>portalMiddlewareGetAdvisorPlanEmployees(planId, params, signal);
    return {
        enabled: !!planId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAdvisorPlanEmployees(planId, params, options) {
    const queryOptions = getPortalMiddlewareGetAdvisorPlanEmployeesQueryOptions(planId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanEmployee = (planId, employeeId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/advisor/plans/${planId}/employees/${employeeId}`
    });
};
export const getPortalMiddlewareGetPlanEmployeeQueryKey = (planId, employeeId)=>{
    return [
        `/pm/api/advisor/plans/${planId}/employees/${employeeId}`
    ];
};
export const getPortalMiddlewareGetPlanEmployeeQueryOptions = (planId, employeeId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanEmployeeQueryKey(planId, employeeId);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanEmployee(planId, employeeId, signal);
    return {
        enabled: !!(planId && employeeId),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanEmployee(planId, employeeId, options) {
    const queryOptions = getPortalMiddlewareGetPlanEmployeeQueryOptions(planId, employeeId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAdvisorPlanStatistics = (planId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/advisor/plans/${planId}/stats`
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsQueryKey = (planId)=>{
    return [
        `/pm/api/advisor/plans/${planId}/stats`
    ];
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAdvisorPlanStatisticsQueryKey(planId);
    const queryFn = ({ signal })=>portalMiddlewareGetAdvisorPlanStatistics(planId, signal);
    return {
        enabled: !!planId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAdvisorPlanStatistics(planId, options) {
    const queryOptions = getPortalMiddlewareGetAdvisorPlanStatisticsQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostLinkSponsor = (advisorSponsorLinksBody)=>{
    return client({
        data: advisorSponsorLinksBody,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/advisor/sponsors/link`
    });
};
export const getPortalMiddlewarePostLinkSponsorMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostLinkSponsor(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostLinkSponsor = (options)=>{
    const mutationOptions = getPortalMiddlewarePostLinkSponsorMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetAdvisorStats = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/advisor/statistics`
    });
};
export const getPortalMiddlewareGetAdvisorStatsQueryKey = (params)=>{
    return [
        `/pm/api/advisor/statistics`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAdvisorStatsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAdvisorStatsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetAdvisorStats(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAdvisorStats(params, options) {
    const queryOptions = getPortalMiddlewareGetAdvisorStatsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetCarousel = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/carousel`
    });
};
export const getPortalMiddlewareGetCarouselQueryKey = ()=>{
    return [
        `/pm/api/carousel`
    ];
};
export const getPortalMiddlewareGetCarouselQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetCarouselQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetCarousel(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetCarousel(options) {
    const queryOptions = getPortalMiddlewareGetCarouselQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetConnectivity = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/connectivity`
    });
};
export const getPortalMiddlewareGetConnectivityQueryKey = (params)=>{
    return [
        `/pm/api/connectivity`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetConnectivityQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetConnectivityQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetConnectivity(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetConnectivity(params, options) {
    const queryOptions = getPortalMiddlewareGetConnectivityQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetCsm = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/csm`
    });
};
export const getPortalMiddlewareGetCsmQueryKey = (params)=>{
    return [
        `/pm/api/csm`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetCsmQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetCsmQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetCsm(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetCsm(params, options) {
    const queryOptions = getPortalMiddlewareGetCsmQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetLoginDisclosure = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/disclosure/login`
    });
};
export const getPortalMiddlewareGetLoginDisclosureQueryKey = ()=>{
    return [
        `/pm/api/disclosure/login`
    ];
};
export const getPortalMiddlewareGetLoginDisclosureQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetLoginDisclosureQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetLoginDisclosure(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetLoginDisclosure(options) {
    const queryOptions = getPortalMiddlewareGetLoginDisclosureQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutLoginDisclosure = (putLoginDisclosureBodyDto)=>{
    return client({
        data: putLoginDisclosureBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/disclosure/login`
    });
};
export const getPortalMiddlewarePutLoginDisclosureMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutLoginDisclosure(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutLoginDisclosure = (options)=>{
    const mutationOptions = getPortalMiddlewarePutLoginDisclosureMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetLoginDisclosureAgreement = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/disclosure/login/agreement`
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementQueryKey = ()=>{
    return [
        `/pm/api/disclosure/login/agreement`
    ];
};
export const getPortalMiddlewareGetLoginDisclosureAgreementQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetLoginDisclosureAgreementQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetLoginDisclosureAgreement(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetLoginDisclosureAgreement(options) {
    const queryOptions = getPortalMiddlewareGetLoginDisclosureAgreementQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetDocumentById = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/document`
    });
};
export const getPortalMiddlewareGetDocumentByIdQueryKey = (params)=>{
    return [
        `/pm/api/document`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetDocumentByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDocumentByIdQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetDocumentById(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDocumentById(params, options) {
    const queryOptions = getPortalMiddlewareGetDocumentByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchDeleteDocumentById = (documentQueryDto)=>{
    return client({
        data: documentQueryDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/document`
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchDeleteDocumentById(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchDeleteDocumentById = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchDeleteDocumentByIdMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetAllDocuments = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/documents`
    });
};
export const getPortalMiddlewareGetAllDocumentsQueryKey = (params)=>{
    return [
        `/pm/api/documents`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAllDocumentsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAllDocumentsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetAllDocuments(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAllDocuments(params, options) {
    const queryOptions = getPortalMiddlewareGetAllDocumentsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetDocumentAgreement = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/documents/agreement`
    });
};
export const getPortalMiddlewareGetDocumentAgreementQueryKey = (params)=>{
    return [
        `/pm/api/documents/agreement`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetDocumentAgreementQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDocumentAgreementQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetDocumentAgreement(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDocumentAgreement(params, options) {
    const queryOptions = getPortalMiddlewareGetDocumentAgreementQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostDocumentAgreement = (postDocumentAgreementBodyDto)=>{
    return client({
        data: postDocumentAgreementBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/documents/agreement`
    });
};
export const getPortalMiddlewarePostDocumentAgreementMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostDocumentAgreement(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostDocumentAgreement = (options)=>{
    const mutationOptions = getPortalMiddlewarePostDocumentAgreementMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetDocumentDownloadById = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/documents/download`
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdQueryKey = (params)=>{
    return [
        `/pm/api/documents/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetDocumentDownloadByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDocumentDownloadByIdQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetDocumentDownloadById(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDocumentDownloadById(params, options) {
    const queryOptions = getPortalMiddlewareGetDocumentDownloadByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetDocumentDownloadByKey = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/documents/download-by-key`
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyQueryKey = (params)=>{
    return [
        `/pm/api/documents/download-by-key`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetDocumentDownloadByKeyQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDocumentDownloadByKeyQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetDocumentDownloadByKey(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDocumentDownloadByKey(params, options) {
    const queryOptions = getPortalMiddlewareGetDocumentDownloadByKeyQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetDocumentAsHtml = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/documents/html`
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlQueryKey = (params)=>{
    return [
        `/pm/api/documents/html`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetDocumentAsHtmlQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDocumentAsHtmlQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetDocumentAsHtml(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDocumentAsHtml(params, options) {
    const queryOptions = getPortalMiddlewareGetDocumentAsHtmlQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetDocumentAsHtmlAndDownload = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        responseType: 'blob',
        signal,
        url: `/pm/api/documents/html/download`
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadQueryKey = (params)=>{
    return [
        `/pm/api/documents/html/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDocumentAsHtmlAndDownloadQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetDocumentAsHtmlAndDownload(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDocumentAsHtmlAndDownload(params, options) {
    const queryOptions = getPortalMiddlewareGetDocumentAsHtmlAndDownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostPdf = (postPdfBodyDto)=>{
    return client({
        data: postPdfBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        responseType: 'blob',
        url: `/pm/api/documents/pdf`
    });
};
export const getPortalMiddlewarePostPdfMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostPdf(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPdf = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPdfMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostProcessDocument = (postProcessDocumentBodyDto)=>{
    return client({
        data: postProcessDocumentBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/documents/process`
    });
};
export const getPortalMiddlewarePostProcessDocumentMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostProcessDocument(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostProcessDocument = (options)=>{
    const mutationOptions = getPortalMiddlewarePostProcessDocumentMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostUploadDocument = (uploadDocumentDto)=>{
    return client({
        data: uploadDocumentDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/documents/upload`
    });
};
export const getPortalMiddlewarePostUploadDocumentMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostUploadDocument(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostUploadDocument = (options)=>{
    const mutationOptions = getPortalMiddlewarePostUploadDocumentMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostEmail = (postEmailBodyDto)=>{
    return client({
        data: postEmailBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/email`
    });
};
export const getPortalMiddlewarePostEmailMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostEmail(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostEmail = (options)=>{
    const mutationOptions = getPortalMiddlewarePostEmailMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostEmailPreviewRender = (emailPreviewRenderBodyDto)=>{
    return client({
        data: emailPreviewRenderBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/email/preview/render`
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostEmailPreviewRender(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostEmailPreviewRender = (options)=>{
    const mutationOptions = getPortalMiddlewarePostEmailPreviewRenderMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetEmailPreviewById = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/email/previews`
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdQueryKey = (params)=>{
    return [
        `/pm/api/email/previews`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmailPreviewByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmailPreviewByIdQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmailPreviewById(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmailPreviewById(params, options) {
    const queryOptions = getPortalMiddlewareGetEmailPreviewByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeeHoldings = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employee/holdings`
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsQueryKey = (params)=>{
    return [
        `/pm/api/employee/holdings`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeeHoldingsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeeHoldingsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeeHoldings(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeeHoldings(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeeHoldingsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeeLoans = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employee/loans`
    });
};
export const getPortalMiddlewareGetEmployeeLoansQueryKey = (params)=>{
    return [
        `/pm/api/employee/loans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeeLoansQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeeLoansQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeeLoans(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeeLoans(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeeLoansQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeePerformance = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employee/performance`
    });
};
export const getPortalMiddlewareGetEmployeePerformanceQueryKey = (params)=>{
    return [
        `/pm/api/employee/performance`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeePerformanceQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeePerformanceQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeePerformance(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeePerformance(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeePerformanceQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeeTransactions = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employee/transactions`
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsQueryKey = (params)=>{
    return [
        `/pm/api/employee/transactions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeeTransactionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeeTransactionsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeeTransactions(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeeTransactions(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeeTransactionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeePendingTransactions = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employee/transactions/pending`
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsQueryKey = (params)=>{
    return [
        `/pm/api/employee/transactions/pending`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeePendingTransactionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeePendingTransactionsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeePendingTransactions(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeePendingTransactions(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeePendingTransactionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeeTransactionsYears = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employee/transactions/years`
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsQueryKey = (params)=>{
    return [
        `/pm/api/employee/transactions/years`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeeTransactionsYearsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeeTransactionsYears(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeeTransactionsYears(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeeTransactionsYearsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetProgramModelSecurities = (employeeId, type, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/employee/${employeeId}/model-securities/${type}`
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesQueryKey = (employeeId, type)=>{
    return [
        `/pm/api/employee/${employeeId}/model-securities/${type}`
    ];
};
export const getPortalMiddlewareGetProgramModelSecuritiesQueryOptions = (employeeId, type, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetProgramModelSecuritiesQueryKey(employeeId, type);
    const queryFn = ({ signal })=>portalMiddlewareGetProgramModelSecurities(employeeId, type, signal);
    return {
        enabled: !!(employeeId && type),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetProgramModelSecurities(employeeId, type, options) {
    const queryOptions = getPortalMiddlewareGetProgramModelSecuritiesQueryOptions(employeeId, type, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeesWithContributions = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employees/contributions`
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsQueryKey = (params)=>{
    return [
        `/pm/api/employees/contributions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeesWithContributionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeesWithContributionsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeesWithContributions(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeesWithContributions(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeesWithContributionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeeLoanDetails = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employees/loans/details`
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsQueryKey = (params)=>{
    return [
        `/pm/api/employees/loans/details`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeeLoanDetailsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeeLoanDetailsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeeLoanDetails(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeeLoanDetails(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeeLoanDetailsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeesTransactionsYears = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employees/transactions/years`
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsQueryKey = (params)=>{
    return [
        `/pm/api/employees/transactions/years`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeesTransactionsYearsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeesTransactionsYears(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeesTransactionsYears(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeesTransactionsYearsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchEsaParticipantGoal = (patchEsaParticipantGoalBodyDto)=>{
    return client({
        data: patchEsaParticipantGoalBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/esa/participant/goal`
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchEsaParticipantGoal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchEsaParticipantGoal = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchEsaParticipantGoalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetEsaParticipantGoals = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/esa/participant/goals`
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsQueryKey = ()=>{
    return [
        `/pm/api/esa/participant/goals`
    ];
};
export const getPortalMiddlewareGetEsaParticipantGoalsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEsaParticipantGoalsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetEsaParticipantGoals(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEsaParticipantGoals(options) {
    const queryOptions = getPortalMiddlewareGetEsaParticipantGoalsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEsaParticipantIncentives = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/esa/participant/incentives`
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesQueryKey = ()=>{
    return [
        `/pm/api/esa/participant/incentives`
    ];
};
export const getPortalMiddlewareGetEsaParticipantIncentivesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEsaParticipantIncentivesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetEsaParticipantIncentives(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEsaParticipantIncentives(options) {
    const queryOptions = getPortalMiddlewareGetEsaParticipantIncentivesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEsaPlanCashInterestRate = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/esa/plan/cash-interest-rate`
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateQueryKey = ()=>{
    return [
        `/pm/api/esa/plan/cash-interest-rate`
    ];
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEsaPlanCashInterestRateQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetEsaPlanCashInterestRate(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEsaPlanCashInterestRate(options) {
    const queryOptions = getPortalMiddlewareGetEsaPlanCashInterestRateQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEsaPlanGroupBalanceOverTime = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/esa/plan/group-balance-over-time`
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeQueryKey = (params)=>{
    return [
        `/pm/api/esa/plan/group-balance-over-time`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEsaPlanGroupBalanceOverTime(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEsaPlanGroupBalanceOverTime(params, options) {
    const queryOptions = getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEsaPlanGroupStats = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/esa/plan/group-stats`
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsQueryKey = (params)=>{
    return [
        `/pm/api/esa/plan/group-stats`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEsaPlanGroupStatsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEsaPlanGroupStatsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEsaPlanGroupStats(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEsaPlanGroupStats(params, options) {
    const queryOptions = getPortalMiddlewareGetEsaPlanGroupStatsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEsaPlanGroups = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/esa/plan/groups`
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsQueryKey = ()=>{
    return [
        `/pm/api/esa/plan/groups`
    ];
};
export const getPortalMiddlewareGetEsaPlanGroupsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEsaPlanGroupsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetEsaPlanGroups(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEsaPlanGroups(options) {
    const queryOptions = getPortalMiddlewareGetEsaPlanGroupsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEsaPlanIncentives = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/esa/plan/incentives`
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesQueryKey = ()=>{
    return [
        `/pm/api/esa/plan/incentives`
    ];
};
export const getPortalMiddlewareGetEsaPlanIncentivesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEsaPlanIncentivesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetEsaPlanIncentives(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEsaPlanIncentives(options) {
    const queryOptions = getPortalMiddlewareGetEsaPlanIncentivesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchEsaWithdrawal = (patchEsaWithdrawalBodyDto)=>{
    return client({
        data: patchEsaWithdrawalBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/esa/withdrawal`
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchEsaWithdrawal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchEsaWithdrawal = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchEsaWithdrawalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetFi360Download = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/fact-sheets`
    });
};
export const getPortalMiddlewareGetFi360DownloadQueryKey = (params)=>{
    return [
        `/pm/api/fact-sheets`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetFi360DownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetFi360DownloadQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetFi360Download(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetFi360Download(params, options) {
    const queryOptions = getPortalMiddlewareGetFi360DownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetFeatureToggles = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/feature-toggle`
    });
};
export const getPortalMiddlewareGetFeatureTogglesQueryKey = (params)=>{
    return [
        `/pm/api/feature-toggle`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetFeatureTogglesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetFeatureTogglesQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetFeatureToggles(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetFeatureToggles(params, options) {
    const queryOptions = getPortalMiddlewareGetFeatureTogglesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetFeatureTogglesList = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/feature-toggle/list`
    });
};
export const getPortalMiddlewareGetFeatureTogglesListQueryKey = (params)=>{
    return [
        `/pm/api/feature-toggle/list`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetFeatureTogglesListQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetFeatureTogglesListQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetFeatureTogglesList(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetFeatureTogglesList(params, options) {
    const queryOptions = getPortalMiddlewareGetFeatureTogglesListQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetFirmById = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/firm/entity`
    });
};
export const getPortalMiddlewareGetFirmByIdQueryKey = (params)=>{
    return [
        `/pm/api/firm/entity`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetFirmByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetFirmByIdQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetFirmById(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetFirmById(params, options) {
    const queryOptions = getPortalMiddlewareGetFirmByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetGiftContributorRecurring = (giftContributorId, giftAccountId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/gifting/contributor/${giftContributorId}/gift-account/${giftAccountId}/recurring`
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringQueryKey = (giftContributorId, giftAccountId)=>{
    return [
        `/pm/api/gifting/contributor/${giftContributorId}/gift-account/${giftAccountId}/recurring`
    ];
};
export const getPortalMiddlewareGetGiftContributorRecurringQueryOptions = (giftContributorId, giftAccountId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGiftContributorRecurringQueryKey(giftContributorId, giftAccountId);
    const queryFn = ({ signal })=>portalMiddlewareGetGiftContributorRecurring(giftContributorId, giftAccountId, signal);
    return {
        enabled: !!(giftContributorId && giftAccountId),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGiftContributorRecurring(giftContributorId, giftAccountId, options) {
    const queryOptions = getPortalMiddlewareGetGiftContributorRecurringQueryOptions(giftContributorId, giftAccountId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareDeleteGiftContributorRecurring = (giftContributorId, giftAccountId, recurringId)=>{
    return client({
        method: 'DELETE',
        url: `/pm/api/gifting/contributor/${giftContributorId}/gift-account/${giftAccountId}/recurring/${recurringId}`
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { giftContributorId, giftAccountId, recurringId } = props ?? {};
        return portalMiddlewareDeleteGiftContributorRecurring(giftContributorId, giftAccountId, recurringId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewareDeleteGiftContributorRecurring = (options)=>{
    const mutationOptions = getPortalMiddlewareDeleteGiftContributorRecurringMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetGiftContributorBanks = (giftContributorId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/gifting/contributor/${giftContributorId}/gift-banks`
    });
};
export const getPortalMiddlewareGetGiftContributorBanksQueryKey = (giftContributorId)=>{
    return [
        `/pm/api/gifting/contributor/${giftContributorId}/gift-banks`
    ];
};
export const getPortalMiddlewareGetGiftContributorBanksQueryOptions = (giftContributorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGiftContributorBanksQueryKey(giftContributorId);
    const queryFn = ({ signal })=>portalMiddlewareGetGiftContributorBanks(giftContributorId, signal);
    return {
        enabled: !!giftContributorId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGiftContributorBanks(giftContributorId, options) {
    const queryOptions = getPortalMiddlewareGetGiftContributorBanksQueryOptions(giftContributorId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetGiftContributorPayments = (giftContributorId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/gifting/contributor/${giftContributorId}/gift-payments`
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsQueryKey = (giftContributorId)=>{
    return [
        `/pm/api/gifting/contributor/${giftContributorId}/gift-payments`
    ];
};
export const getPortalMiddlewareGetGiftContributorPaymentsQueryOptions = (giftContributorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGiftContributorPaymentsQueryKey(giftContributorId);
    const queryFn = ({ signal })=>portalMiddlewareGetGiftContributorPayments(giftContributorId, signal);
    return {
        enabled: !!giftContributorId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGiftContributorPayments(giftContributorId, options) {
    const queryOptions = getPortalMiddlewareGetGiftContributorPaymentsQueryOptions(giftContributorId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetGiftContributorRecipients = (giftContributorId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/gifting/contributor/${giftContributorId}/recipients`
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsQueryKey = (giftContributorId)=>{
    return [
        `/pm/api/gifting/contributor/${giftContributorId}/recipients`
    ];
};
export const getPortalMiddlewareGetGiftContributorRecipientsQueryOptions = (giftContributorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGiftContributorRecipientsQueryKey(giftContributorId);
    const queryFn = ({ signal })=>portalMiddlewareGetGiftContributorRecipients(giftContributorId, signal);
    return {
        enabled: !!giftContributorId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGiftContributorRecipients(giftContributorId, options) {
    const queryOptions = getPortalMiddlewareGetGiftContributorRecipientsQueryOptions(giftContributorId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetGiftingPageAndAccountById = (giftingId, giftContributorId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/gifting/gift-account/${giftingId}/${giftContributorId}`
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdQueryKey = (giftingId, giftContributorId)=>{
    return [
        `/pm/api/gifting/gift-account/${giftingId}/${giftContributorId}`
    ];
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdQueryOptions = (giftingId, giftContributorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGiftingPageAndAccountByIdQueryKey(giftingId, giftContributorId);
    const queryFn = ({ signal })=>portalMiddlewareGetGiftingPageAndAccountById(giftingId, giftContributorId, signal);
    return {
        enabled: !!(giftingId && giftContributorId),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGiftingPageAndAccountById(giftingId, giftContributorId, options) {
    const queryOptions = getPortalMiddlewareGetGiftingPageAndAccountByIdQueryOptions(giftingId, giftContributorId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetGiftingPageById = (planId, giftingId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/gifting/gift/${planId}/${giftingId}`
    });
};
export const getPortalMiddlewareGetGiftingPageByIdQueryKey = (planId, giftingId)=>{
    return [
        `/pm/api/gifting/gift/${planId}/${giftingId}`
    ];
};
export const getPortalMiddlewareGetGiftingPageByIdQueryOptions = (planId, giftingId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGiftingPageByIdQueryKey(planId, giftingId);
    const queryFn = ({ signal })=>portalMiddlewareGetGiftingPageById(planId, giftingId, signal);
    return {
        enabled: !!(planId && giftingId),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGiftingPageById(planId, giftingId, options) {
    const queryOptions = getPortalMiddlewareGetGiftingPageByIdQueryOptions(planId, giftingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostCreateGiftorProfile = (postCreateGiftorProfileParamsDto)=>{
    return client({
        data: postCreateGiftorProfileParamsDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/gifting/profile`
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostCreateGiftorProfile(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostCreateGiftorProfile = (options)=>{
    const mutationOptions = getPortalMiddlewarePostCreateGiftorProfileMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutValidateGiftorProfile = (putValidateCreateGiftorProfileParamsDto)=>{
    return client({
        data: putValidateCreateGiftorProfileParamsDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/gifting/profile`
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutValidateGiftorProfile(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutValidateGiftorProfile = (options)=>{
    const mutationOptions = getPortalMiddlewarePutValidateGiftorProfileMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostGiftSubmission = (giftingId, giftSubmissionBodyDto)=>{
    return client({
        data: giftSubmissionBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/gifting/${giftingId}`
    });
};
export const getPortalMiddlewarePostGiftSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { giftingId, data } = props ?? {};
        return portalMiddlewarePostGiftSubmission(giftingId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostGiftSubmission = (options)=>{
    const mutationOptions = getPortalMiddlewarePostGiftSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutValidateGiftSubmission = (giftingId, giftSubmissionBodyDto)=>{
    return client({
        data: giftSubmissionBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/gifting/${giftingId}`
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { giftingId, data } = props ?? {};
        return portalMiddlewarePutValidateGiftSubmission(giftingId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutValidateGiftSubmission = (options)=>{
    const mutationOptions = getPortalMiddlewarePutValidateGiftSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetHealth = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/health`
    });
};
export const getPortalMiddlewareGetHealthQueryKey = ()=>{
    return [
        `/pm/api/health`
    ];
};
export const getPortalMiddlewareGetHealthQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetHealthQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetHealth(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetHealth(options) {
    const queryOptions = getPortalMiddlewareGetHealthQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetLoanAmortizationPdf = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        responseType: 'blob',
        signal,
        url: `/pm/api/loans/amortization/pdf`
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfQueryKey = (params)=>{
    return [
        `/pm/api/loans/amortization/pdf`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetLoanAmortizationPdfQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetLoanAmortizationPdfQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetLoanAmortizationPdf(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetLoanAmortizationPdf(params, options) {
    const queryOptions = getPortalMiddlewareGetLoanAmortizationPdfQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetManagedAccountsPlaidToken = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/managed-accounts/plaid-link-token`
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenQueryKey = ()=>{
    return [
        `/pm/api/managed-accounts/plaid-link-token`
    ];
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetManagedAccountsPlaidTokenQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetManagedAccountsPlaidToken(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetManagedAccountsPlaidToken(options) {
    const queryOptions = getPortalMiddlewareGetManagedAccountsPlaidTokenQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareDeleteManagedAccountsPlaidLinks = (deletePlaidLinkBodyDto)=>{
    return client({
        data: deletePlaidLinkBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'DELETE',
        url: `/pm/api/managed-accounts/plaid-links`
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewareDeleteManagedAccountsPlaidLinks(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewareDeleteManagedAccountsPlaidLinks = (options)=>{
    const mutationOptions = getPortalMiddlewareDeleteManagedAccountsPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetManagedAccountsPlaidLinks = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/managed-accounts/plaid-links`
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksQueryKey = ()=>{
    return [
        `/pm/api/managed-accounts/plaid-links`
    ];
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetManagedAccountsPlaidLinksQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetManagedAccountsPlaidLinks(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetManagedAccountsPlaidLinks(options) {
    const queryOptions = getPortalMiddlewareGetManagedAccountsPlaidLinksQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostManagedAccountsPlaidLinks = (postPlaidLinkBodyDto)=>{
    return client({
        data: postPlaidLinkBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/managed-accounts/plaid-links`
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostManagedAccountsPlaidLinks(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostManagedAccountsPlaidLinks = (options)=>{
    const mutationOptions = getPortalMiddlewarePostManagedAccountsPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostManagedAccountsPlaidBalances = (postPlaidBalancesBodyDto)=>{
    return client({
        data: postPlaidBalancesBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/managed-accounts/plaid-links/balance/get`
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostManagedAccountsPlaidBalances(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostManagedAccountsPlaidBalances = (options)=>{
    const mutationOptions = getPortalMiddlewarePostManagedAccountsPlaidBalancesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostMsManagedAccounts401KManagerQuestionnaire = (postMsManagedAccounts401KManagerQuestionnaireBodyDto)=>{
    return client({
        data: postMsManagedAccounts401KManagerQuestionnaireBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/ms-managed-accounts/401k-manager-questionnaire`
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostMsManagedAccounts401KManagerQuestionnaire(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaire = (options)=>{
    const mutationOptions = getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostMsManagedAccountsActivate = (postMsManagedAccountsActivateBodyDto)=>{
    return client({
        data: postMsManagedAccountsActivateBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/ms-managed-accounts/activate`
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostMsManagedAccountsActivate(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostMsManagedAccountsActivate = (options)=>{
    const mutationOptions = getPortalMiddlewarePostMsManagedAccountsActivateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostMsManagedAccountsDeactivate = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/ms-managed-accounts/deactivate`
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostMsManagedAccountsDeactivate();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostMsManagedAccountsDeactivate = (options)=>{
    const mutationOptions = getPortalMiddlewarePostMsManagedAccountsDeactivateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetMsManagedAccountsPreviewAllocation = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/ms-managed-accounts/preview-allocation`
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationQueryKey = ()=>{
    return [
        `/pm/api/ms-managed-accounts/preview-allocation`
    ];
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetMsManagedAccountsPreviewAllocationQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetMsManagedAccountsPreviewAllocation(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetMsManagedAccountsPreviewAllocation(options) {
    const queryOptions = getPortalMiddlewareGetMsManagedAccountsPreviewAllocationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostMsManagedAccountsPreviewAllocation = (postMsManagedAccountsPreviewAllocationBodyDto)=>{
    return client({
        data: postMsManagedAccountsPreviewAllocationBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/ms-managed-accounts/preview-allocation`
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostMsManagedAccountsPreviewAllocation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostMsManagedAccountsPreviewAllocation = (options)=>{
    const mutationOptions = getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetDigitalOnboardingState = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/onboarding/digital`
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateQueryKey = ()=>{
    return [
        `/pm/api/onboarding/digital`
    ];
};
export const getPortalMiddlewareGetDigitalOnboardingStateQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDigitalOnboardingStateQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetDigitalOnboardingState(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDigitalOnboardingState(options) {
    const queryOptions = getPortalMiddlewareGetDigitalOnboardingStateQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchDigitalOnboardingState = (patchDigitalOnboardingStateBodyDto)=>{
    return client({
        data: patchDigitalOnboardingStateBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/onboarding/digital`
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchDigitalOnboardingState(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchDigitalOnboardingState = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchDigitalOnboardingStateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutDigitalOnboardingState = (putDigitalOnboardingStateBodyDto)=>{
    return client({
        data: putDigitalOnboardingStateBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/onboarding/digital`
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutDigitalOnboardingState(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutDigitalOnboardingState = (options)=>{
    const mutationOptions = getPortalMiddlewarePutDigitalOnboardingStateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePatchStatefulSchemaTrackingStatus = (schemaType, patchStatefulSchemaTrackingStatusBodyDto)=>{
    return client({
        data: patchStatefulSchemaTrackingStatusBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/onboarding/stateful-schema-tracking/${schemaType}/status`
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { schemaType, data } = props ?? {};
        return portalMiddlewarePatchStatefulSchemaTrackingStatus(schemaType, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchStatefulSchemaTrackingStatus = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchStatefulSchemaTrackingStatusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantById = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participant`
    });
};
export const getPortalMiddlewareGetParticipantByIdQueryKey = (params)=>{
    return [
        `/pm/api/participant`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantByIdQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantById(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantById(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetParticipantAccountBalanceById = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participant/account-balance`
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdQueryKey = (params)=>{
    return [
        `/pm/api/participant/account-balance`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantAccountBalanceByIdQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantAccountBalanceById(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantAccountBalanceById(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantAccountBalanceByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostParticipantLoan = (loanBodyDto)=>{
    return client({
        data: loanBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/account/loans`
    });
};
export const getPortalMiddlewarePostParticipantLoanMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostParticipantLoan(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantLoan = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantLoanMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantPlaidLinkToken = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participant/account/loans/plaid-link-token`
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenQueryKey = (params)=>{
    return [
        `/pm/api/participant/account/loans/plaid-link-token`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantPlaidLinkTokenQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantPlaidLinkToken(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantPlaidLinkToken(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantPlaidLinkTokenQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetParticipantPlaidLinks = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/account/loans/plaid-links`
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksQueryKey = ()=>{
    return [
        `/pm/api/participant/account/loans/plaid-links`
    ];
};
export const getPortalMiddlewareGetParticipantPlaidLinksQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantPlaidLinksQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantPlaidLinks(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantPlaidLinks(options) {
    const queryOptions = getPortalMiddlewareGetParticipantPlaidLinksQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostParticipantPlaidLinks = (plaidLinkBodyDto)=>{
    return client({
        data: plaidLinkBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/account/loans/plaid-links`
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostParticipantPlaidLinks(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantPlaidLinks = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantLoanCreate = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/account/loans/request`
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateQueryKey = ()=>{
    return [
        `/pm/api/participant/account/loans/request`
    ];
};
export const getPortalMiddlewareGetParticipantLoanCreateQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantLoanCreateQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantLoanCreate(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantLoanCreate(options) {
    const queryOptions = getPortalMiddlewareGetParticipantLoanCreateQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchParticipantLoan = (loanId, loanAgreementBodyDto)=>{
    return client({
        data: loanAgreementBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/participant/account/loans/${loanId}`
    });
};
export const getPortalMiddlewarePatchParticipantLoanMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { loanId, data } = props ?? {};
        return portalMiddlewarePatchParticipantLoan(loanId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchParticipantLoan = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchParticipantLoanMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostLoanManualRepayment = (loanId, bankAccountIdDto)=>{
    return client({
        data: bankAccountIdDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/account/loans/${loanId}/payment`
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { loanId, data } = props ?? {};
        return portalMiddlewarePostLoanManualRepayment(loanId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostLoanManualRepayment = (options)=>{
    const mutationOptions = getPortalMiddlewarePostLoanManualRepaymentMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantAccounts = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participant/accounts`
    });
};
export const getPortalMiddlewareGetParticipantAccountsQueryKey = (params)=>{
    return [
        `/pm/api/participant/accounts`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantAccountsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantAccountsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantAccounts(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantAccounts(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantAccountsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetParticipantBalanceOverTime = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/balance-over-time`
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeQueryKey = ()=>{
    return [
        `/pm/api/participant/balance-over-time`
    ];
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantBalanceOverTimeQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantBalanceOverTime(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantBalanceOverTime(options) {
    const queryOptions = getPortalMiddlewareGetParticipantBalanceOverTimeQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutArchiveBankAccount = (bankAccountId)=>{
    return client({
        method: 'PUT',
        url: `/pm/api/participant/bank-account/${bankAccountId}/archive`
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { bankAccountId } = props ?? {};
        return portalMiddlewarePutArchiveBankAccount(bankAccountId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutArchiveBankAccount = (options)=>{
    const mutationOptions = getPortalMiddlewarePutArchiveBankAccountMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantBankAccounts = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/bank-accounts`
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsQueryKey = ()=>{
    return [
        `/pm/api/participant/bank-accounts`
    ];
};
export const getPortalMiddlewareGetParticipantBankAccountsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantBankAccountsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantBankAccounts(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantBankAccounts(options) {
    const queryOptions = getPortalMiddlewareGetParticipantBankAccountsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetParticipantDeposits = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participant/deposit`
    });
};
export const getPortalMiddlewareGetParticipantDepositsQueryKey = (params)=>{
    return [
        `/pm/api/participant/deposit`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantDepositsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantDepositsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantDeposits(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantDeposits(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantDepositsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostDepositData = (postParticipantDepositBodyDto)=>{
    return client({
        data: postParticipantDepositBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/deposit`
    });
};
export const getPortalMiddlewarePostDepositDataMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostDepositData(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostDepositData = (options)=>{
    const mutationOptions = getPortalMiddlewarePostDepositDataMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantRecurringSchedules = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participant/deposit/schedule`
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesQueryKey = (params)=>{
    return [
        `/pm/api/participant/deposit/schedule`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantRecurringSchedulesQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantRecurringSchedules(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantRecurringSchedules(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantRecurringSchedulesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutRecurringSchedule = (recurringScheduleId, putDepositDto)=>{
    return client({
        data: putDepositDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/participant/deposit/schedule/${recurringScheduleId}`
    });
};
export const getPortalMiddlewarePutRecurringScheduleMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { recurringScheduleId, data } = props ?? {};
        return portalMiddlewarePutRecurringSchedule(recurringScheduleId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutRecurringSchedule = (options)=>{
    const mutationOptions = getPortalMiddlewarePutRecurringScheduleMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetDeposit = (depositId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/deposit/${depositId}`
    });
};
export const getPortalMiddlewareGetDepositQueryKey = (depositId)=>{
    return [
        `/pm/api/participant/deposit/${depositId}`
    ];
};
export const getPortalMiddlewareGetDepositQueryOptions = (depositId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDepositQueryKey(depositId);
    const queryFn = ({ signal })=>portalMiddlewareGetDeposit(depositId, signal);
    return {
        enabled: !!depositId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDeposit(depositId, options) {
    const queryOptions = getPortalMiddlewareGetDepositQueryOptions(depositId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetRecentParticipantDocuments = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/documents/recent`
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsQueryKey = ()=>{
    return [
        `/pm/api/participant/documents/recent`
    ];
};
export const getPortalMiddlewareGetRecentParticipantDocumentsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRecentParticipantDocumentsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetRecentParticipantDocuments(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRecentParticipantDocuments(options) {
    const queryOptions = getPortalMiddlewareGetRecentParticipantDocumentsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostParticipantEligibility = (postParticipantsEligibilityBodyDto)=>{
    return client({
        data: postParticipantsEligibilityBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/eligibility`
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostParticipantEligibility(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantEligibility = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantEligibilityMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostEsaGoal = (participantEsaGoalDto)=>{
    return client({
        data: participantEsaGoalDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/esa/goal`
    });
};
export const getPortalMiddlewarePostEsaGoalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostEsaGoal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostEsaGoal = (options)=>{
    const mutationOptions = getPortalMiddlewarePostEsaGoalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantIdentityVerification = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/identity-verification`
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationQueryKey = ()=>{
    return [
        `/pm/api/participant/identity-verification`
    ];
};
export const getPortalMiddlewareGetParticipantIdentityVerificationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantIdentityVerificationQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantIdentityVerification(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantIdentityVerification(options) {
    const queryOptions = getPortalMiddlewareGetParticipantIdentityVerificationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchParticipantInfoWithEmails = (patchParticipantBodyDto)=>{
    return client({
        data: patchParticipantBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/participant/info`
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchParticipantInfoWithEmails(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchParticipantInfoWithEmails = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchParticipantInfoWithEmailsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetGoalFeedback = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/investment-election`
    });
};
export const getPortalMiddlewareGetGoalFeedbackQueryKey = ()=>{
    return [
        `/pm/api/participant/investment-election`
    ];
};
export const getPortalMiddlewareGetGoalFeedbackQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGoalFeedbackQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetGoalFeedback(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGoalFeedback(options) {
    const queryOptions = getPortalMiddlewareGetGoalFeedbackQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostElectionAgeSuggestion = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/participant/investment-election/age-suggestion`
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostElectionAgeSuggestion();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostElectionAgeSuggestion = (options)=>{
    const mutationOptions = getPortalMiddlewarePostElectionAgeSuggestionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostElectionRetirementIncomeSuggestion = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/participant/investment-election/retirement-income-suggestion`
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostElectionRetirementIncomeSuggestion();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostElectionRetirementIncomeSuggestion = (options)=>{
    const mutationOptions = getPortalMiddlewarePostElectionRetirementIncomeSuggestionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetElectionsSetup = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/investment-election/setup`
    });
};
export const getPortalMiddlewareGetElectionsSetupQueryKey = ()=>{
    return [
        `/pm/api/participant/investment-election/setup`
    ];
};
export const getPortalMiddlewareGetElectionsSetupQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetElectionsSetupQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetElectionsSetup(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetElectionsSetup(options) {
    const queryOptions = getPortalMiddlewareGetElectionsSetupQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostElectionsSetup = (investmentElectionSetupDto)=>{
    return client({
        data: investmentElectionSetupDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/investment-election/setup`
    });
};
export const getPortalMiddlewarePostElectionsSetupMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostElectionsSetup(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostElectionsSetup = (options)=>{
    const mutationOptions = getPortalMiddlewarePostElectionsSetupMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetInvestmentsModelDisplay = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/investments/model`
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayQueryKey = ()=>{
    return [
        `/pm/api/participant/investments/model`
    ];
};
export const getPortalMiddlewareGetInvestmentsModelDisplayQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetInvestmentsModelDisplayQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetInvestmentsModelDisplay(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetInvestmentsModelDisplay(options) {
    const queryOptions = getPortalMiddlewareGetInvestmentsModelDisplayQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanParticipantStats = (planId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/investments/options/plans/${planId}/stats`
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsQueryKey = (planId)=>{
    return [
        `/pm/api/participant/investments/options/plans/${planId}/stats`
    ];
};
export const getPortalMiddlewareGetPlanParticipantStatsQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanParticipantStatsQueryKey(planId);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanParticipantStats(planId, signal);
    return {
        enabled: !!planId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanParticipantStats(planId, options) {
    const queryOptions = getPortalMiddlewareGetPlanParticipantStatsQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostRebalanceRequest = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/participant/investments/rebalance-request`
    });
};
export const getPortalMiddlewarePostRebalanceRequestMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostRebalanceRequest();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostRebalanceRequest = (options)=>{
    const mutationOptions = getPortalMiddlewarePostRebalanceRequestMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetRebalanceSettings = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/investments/rebalance-settings`
    });
};
export const getPortalMiddlewareGetRebalanceSettingsQueryKey = ()=>{
    return [
        `/pm/api/participant/investments/rebalance-settings`
    ];
};
export const getPortalMiddlewareGetRebalanceSettingsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRebalanceSettingsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetRebalanceSettings(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRebalanceSettings(options) {
    const queryOptions = getPortalMiddlewareGetRebalanceSettingsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutRebalanceSettings = (rebalanceBodyDto)=>{
    return client({
        data: rebalanceBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/participant/investments/rebalance-settings`
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutRebalanceSettings(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutRebalanceSettings = (options)=>{
    const mutationOptions = getPortalMiddlewarePutRebalanceSettingsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetStrategiesIndex = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/investments/strategies`
    });
};
export const getPortalMiddlewareGetStrategiesIndexQueryKey = ()=>{
    return [
        `/pm/api/participant/investments/strategies`
    ];
};
export const getPortalMiddlewareGetStrategiesIndexQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetStrategiesIndexQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetStrategiesIndex(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetStrategiesIndex(options) {
    const queryOptions = getPortalMiddlewareGetStrategiesIndexQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAgeBased = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participant/investments/strategies/age-based`
    });
};
export const getPortalMiddlewareGetAgeBasedQueryKey = (params)=>{
    return [
        `/pm/api/participant/investments/strategies/age-based`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAgeBasedQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAgeBasedQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetAgeBased(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAgeBased(params, options) {
    const queryOptions = getPortalMiddlewareGetAgeBasedQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutAgeBased = (ageBasedBodyDto)=>{
    return client({
        data: ageBasedBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/participant/investments/strategies/age-based`
    });
};
export const getPortalMiddlewarePutAgeBasedMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutAgeBased(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutAgeBased = (options)=>{
    const mutationOptions = getPortalMiddlewarePutAgeBasedMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutCustomAllocation = (allocationsBodyDto)=>{
    return client({
        data: allocationsBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/participant/investments/strategies/custom-allocation`
    });
};
export const getPortalMiddlewarePutCustomAllocationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutCustomAllocation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutCustomAllocation = (options)=>{
    const mutationOptions = getPortalMiddlewarePutCustomAllocationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetRiskBased = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/investments/strategies/risk-based`
    });
};
export const getPortalMiddlewareGetRiskBasedQueryKey = ()=>{
    return [
        `/pm/api/participant/investments/strategies/risk-based`
    ];
};
export const getPortalMiddlewareGetRiskBasedQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRiskBasedQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetRiskBased(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRiskBased(options) {
    const queryOptions = getPortalMiddlewareGetRiskBasedQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutRiskBased = (riskBasedBodyDto)=>{
    return client({
        data: riskBasedBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/participant/investments/strategies/risk-based`
    });
};
export const getPortalMiddlewarePutRiskBasedMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutRiskBased(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutRiskBased = (options)=>{
    const mutationOptions = getPortalMiddlewarePutRiskBasedMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetRiskModelQuestionnaire = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participant/investments/strategies/risk-based/questionnaire`
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireQueryKey = (params)=>{
    return [
        `/pm/api/participant/investments/strategies/risk-based/questionnaire`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetRiskModelQuestionnaireQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRiskModelQuestionnaireQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetRiskModelQuestionnaire(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRiskModelQuestionnaire(params, options) {
    const queryOptions = getPortalMiddlewareGetRiskModelQuestionnaireQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetMailPreferences = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/mail-preferences`
    });
};
export const getPortalMiddlewareGetMailPreferencesQueryKey = ()=>{
    return [
        `/pm/api/participant/mail-preferences`
    ];
};
export const getPortalMiddlewareGetMailPreferencesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetMailPreferencesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetMailPreferences(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetMailPreferences(options) {
    const queryOptions = getPortalMiddlewareGetMailPreferencesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutMailPreferences = (paperlessNoticesDto)=>{
    return client({
        data: paperlessNoticesDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/participant/mail-preferences`
    });
};
export const getPortalMiddlewarePutMailPreferencesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutMailPreferences(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutMailPreferences = (options)=>{
    const mutationOptions = getPortalMiddlewarePutMailPreferencesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantOnboarding = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/onboarding`
    });
};
export const getPortalMiddlewareGetParticipantOnboardingQueryKey = ()=>{
    return [
        `/pm/api/participant/onboarding`
    ];
};
export const getPortalMiddlewareGetParticipantOnboardingQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantOnboardingQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantOnboarding(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantOnboarding(options) {
    const queryOptions = getPortalMiddlewareGetParticipantOnboardingQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetParticipantOverview = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/overview`
    });
};
export const getPortalMiddlewareGetParticipantOverviewQueryKey = ()=>{
    return [
        `/pm/api/participant/overview`
    ];
};
export const getPortalMiddlewareGetParticipantOverviewQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantOverviewQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantOverview(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantOverview(options) {
    const queryOptions = getPortalMiddlewareGetParticipantOverviewQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostParticipantPlaidLinksBalance = (plaidLinkBodyDto)=>{
    return client({
        data: plaidLinkBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/plaid-links/balance`
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostParticipantPlaidLinksBalance(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantPlaidLinksBalance = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantPlaidLinksBalanceMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostParticipantPlaidLinksBankAccount = (partipantPlaidLinkBankAccountDto)=>{
    return client({
        data: partipantPlaidLinkBankAccountDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/plaid-links/bank-account`
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostParticipantPlaidLinksBankAccount(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantPlaidLinksBankAccount = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantPlaidLinksBankAccountMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostParticipantDiscardPendingPlaidLinks = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/participant/plaid-links/discard-pending`
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostParticipantDiscardPendingPlaidLinks();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantDiscardPendingPlaidLinks = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPositions = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/positions`
    });
};
export const getPortalMiddlewareGetPositionsQueryKey = ()=>{
    return [
        `/pm/api/participant/positions`
    ];
};
export const getPortalMiddlewareGetPositionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPositionsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPositions(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPositions(options) {
    const queryOptions = getPortalMiddlewareGetPositionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetQboadWithdrawals = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/qboad/withdrawals`
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsQueryKey = ()=>{
    return [
        `/pm/api/participant/qboad/withdrawals`
    ];
};
export const getPortalMiddlewareGetQboadWithdrawalsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetQboadWithdrawalsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetQboadWithdrawals(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetQboadWithdrawals(options) {
    const queryOptions = getPortalMiddlewareGetQboadWithdrawalsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchParticipantRollover = (rolloverBodyDto)=>{
    return client({
        data: rolloverBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/participant/rollovers`
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchParticipantRollover(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchParticipantRollover = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchParticipantRolloverMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetRolloverInstructions = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/rollovers/instructions`
    });
};
export const getPortalMiddlewareGetRolloverInstructionsQueryKey = ()=>{
    return [
        `/pm/api/participant/rollovers/instructions`
    ];
};
export const getPortalMiddlewareGetRolloverInstructionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRolloverInstructionsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetRolloverInstructions(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRolloverInstructions(options) {
    const queryOptions = getPortalMiddlewareGetRolloverInstructionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetRolloverEligibility = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/rollovers/request`
    });
};
export const getPortalMiddlewareGetRolloverEligibilityQueryKey = ()=>{
    return [
        `/pm/api/participant/rollovers/request`
    ];
};
export const getPortalMiddlewareGetRolloverEligibilityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRolloverEligibilityQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetRolloverEligibility(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRolloverEligibility(options) {
    const queryOptions = getPortalMiddlewareGetRolloverEligibilityQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostParticipantRollover = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/participant/rollovers/request`
    });
};
export const getPortalMiddlewarePostParticipantRolloverMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostParticipantRollover();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantRollover = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantRolloverMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantRollover = (rolloverId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/rollovers/${rolloverId}`
    });
};
export const getPortalMiddlewareGetParticipantRolloverQueryKey = (rolloverId)=>{
    return [
        `/pm/api/participant/rollovers/${rolloverId}`
    ];
};
export const getPortalMiddlewareGetParticipantRolloverQueryOptions = (rolloverId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantRolloverQueryKey(rolloverId);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantRollover(rolloverId, signal);
    return {
        enabled: !!rolloverId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantRollover(rolloverId, options) {
    const queryOptions = getPortalMiddlewareGetParticipantRolloverQueryOptions(rolloverId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetGenerateRolloverLetter = (rolloverId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/rollovers/${rolloverId}/letter`
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterQueryKey = (rolloverId)=>{
    return [
        `/pm/api/participant/rollovers/${rolloverId}/letter`
    ];
};
export const getPortalMiddlewareGetGenerateRolloverLetterQueryOptions = (rolloverId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGenerateRolloverLetterQueryKey(rolloverId);
    const queryFn = ({ signal })=>portalMiddlewareGetGenerateRolloverLetter(rolloverId, signal);
    return {
        enabled: !!rolloverId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGenerateRolloverLetter(rolloverId, options) {
    const queryOptions = getPortalMiddlewareGetGenerateRolloverLetterQueryOptions(rolloverId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSavingsDisplay = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/savings`
    });
};
export const getPortalMiddlewareGetSavingsDisplayQueryKey = ()=>{
    return [
        `/pm/api/participant/savings`
    ];
};
export const getPortalMiddlewareGetSavingsDisplayQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSavingsDisplayQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSavingsDisplay(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSavingsDisplay(options) {
    const queryOptions = getPortalMiddlewareGetSavingsDisplayQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutSavings = (savingsBodyDto)=>{
    return client({
        data: savingsBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/participant/savings`
    });
};
export const getPortalMiddlewarePutSavingsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutSavings(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutSavings = (options)=>{
    const mutationOptions = getPortalMiddlewarePutSavingsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetSurveyLink = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/survey/link`
    });
};
export const getPortalMiddlewareGetSurveyLinkQueryKey = ()=>{
    return [
        `/pm/api/participant/survey/link`
    ];
};
export const getPortalMiddlewareGetSurveyLinkQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSurveyLinkQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSurveyLink(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSurveyLink(options) {
    const queryOptions = getPortalMiddlewareGetSurveyLinkQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetParticipantAggregatedByCategoryTransactions = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/transactions/aggregated-by-category`
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsQueryKey = ()=>{
    return [
        `/pm/api/participant/transactions/aggregated-by-category`
    ];
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantAggregatedByCategoryTransactions(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantAggregatedByCategoryTransactions(options) {
    const queryOptions = getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAllowedWithdrawalReasons = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/withdrawals`
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsQueryKey = ()=>{
    return [
        `/pm/api/participant/withdrawals`
    ];
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAllowedWithdrawalReasonsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetAllowedWithdrawalReasons(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAllowedWithdrawalReasons(options) {
    const queryOptions = getPortalMiddlewareGetAllowedWithdrawalReasonsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostWithdrawal = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/participant/withdrawals`
    });
};
export const getPortalMiddlewarePostWithdrawalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostWithdrawal();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostWithdrawal = (options)=>{
    const mutationOptions = getPortalMiddlewarePostWithdrawalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePatchOverrideParticipantEligibility = (participantId, patchOverrideParticipantEligibilityBodyDto)=>{
    return client({
        data: patchOverrideParticipantEligibilityBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/participant/${participantId}/override-eligibility`
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { participantId, data } = props ?? {};
        return portalMiddlewarePatchOverrideParticipantEligibility(participantId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchOverrideParticipantEligibility = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchOverrideParticipantEligibilityMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetEligibleAutoEnrolledParticipants = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participants/opt-out`
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsQueryKey = (params)=>{
    return [
        `/pm/api/participants/opt-out`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEligibleAutoEnrolledParticipantsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEligibleAutoEnrolledParticipants(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEligibleAutoEnrolledParticipants(params, options) {
    const queryOptions = getPortalMiddlewareGetEligibleAutoEnrolledParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetParticipantOptOutEmailDownload = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        responseType: 'blob',
        signal,
        url: `/pm/api/participants/opt-out-confirmation/download`
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadQueryKey = (params)=>{
    return [
        `/pm/api/participants/opt-out-confirmation/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantOptOutEmailDownloadQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantOptOutEmailDownload(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantOptOutEmailDownload(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantOptOutEmailDownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetOptedOutAutoEnrolledParticipants = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participants/opt-out/enrolled`
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsQueryKey = (params)=>{
    return [
        `/pm/api/participants/opt-out/enrolled`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetOptedOutAutoEnrolledParticipants(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetOptedOutAutoEnrolledParticipants(params, options) {
    const queryOptions = getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetUnregisteredParticipants = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participants/unregistered`
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsQueryKey = (params)=>{
    return [
        `/pm/api/participants/unregistered`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetUnregisteredParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetUnregisteredParticipantsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetUnregisteredParticipants(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetUnregisteredParticipants(params, options) {
    const queryOptions = getPortalMiddlewareGetUnregisteredParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetUnregisteredParticipantsCount = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participants/unregistered/count`
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountQueryKey = (params)=>{
    return [
        `/pm/api/participants/unregistered/count`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetUnregisteredParticipantsCountQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetUnregisteredParticipantsCount(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetUnregisteredParticipantsCount(params, options) {
    const queryOptions = getPortalMiddlewareGetUnregisteredParticipantsCountQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostParticipantsWelcomeEmails = (postParticipantWelcomeEmailsBodyDto)=>{
    return client({
        data: postParticipantWelcomeEmailsBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participants/welcome-emails/bulk`
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostParticipantsWelcomeEmails(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantsWelcomeEmails = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantsWelcomeEmailsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantWelcomeEmailDownload = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        responseType: 'blob',
        signal,
        url: `/pm/api/participants/welcome-emails/download`
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadQueryKey = (params)=>{
    return [
        `/pm/api/participants/welcome-emails/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantWelcomeEmailDownloadQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantWelcomeEmailDownload(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantWelcomeEmailDownload(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantWelcomeEmailDownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetParticipantWelcomeEmailsHistory = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participants/welcome-emails/history`
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryQueryKey = (params)=>{
    return [
        `/pm/api/participants/welcome-emails/history`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantWelcomeEmailsHistoryQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantWelcomeEmailsHistory(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantWelcomeEmailsHistory(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantWelcomeEmailsHistoryQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetCalculatedEsaEmployerContributions = (participantId, params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participants/${participantId}/calculate-employer-contributions`
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsQueryKey = (participantId, params)=>{
    return [
        `/pm/api/participants/${participantId}/calculate-employer-contributions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetCalculatedEsaEmployerContributionsQueryKey(participantId, params);
    const queryFn = ({ signal })=>portalMiddlewareGetCalculatedEsaEmployerContributions(participantId, params, signal);
    return {
        enabled: !!participantId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetCalculatedEsaEmployerContributions(participantId, params, options) {
    const queryOptions = getPortalMiddlewareGetCalculatedEsaEmployerContributionsQueryOptions(participantId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetCalculatedEmployerMatchContribution = (participantId, params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participants/${participantId}/calculate-employer-match`
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionQueryKey = (participantId, params)=>{
    return [
        `/pm/api/participants/${participantId}/calculate-employer-match`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetCalculatedEmployerMatchContributionQueryKey(participantId, params);
    const queryFn = ({ signal })=>portalMiddlewareGetCalculatedEmployerMatchContribution(participantId, params, signal);
    return {
        enabled: !!participantId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetCalculatedEmployerMatchContribution(participantId, params, options) {
    const queryOptions = getPortalMiddlewareGetCalculatedEmployerMatchContributionQueryOptions(participantId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostParticipantsAutoEnrollOptOut = (planId, postParticipantsAutoEnrollOptOutBodyDto)=>{
    return client({
        data: postParticipantsAutoEnrollOptOutBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participants/${planId}/opt-out`
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { planId, data } = props ?? {};
        return portalMiddlewarePostParticipantsAutoEnrollOptOut(planId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantsAutoEnrollOptOut = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantsAutoEnrollOptOutMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanDesign = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/plan-design`
    });
};
export const getPortalMiddlewareGetPlanDesignQueryKey = ()=>{
    return [
        `/pm/api/plan-design`
    ];
};
export const getPortalMiddlewareGetPlanDesignQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanDesignQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanDesign(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanDesign(options) {
    const queryOptions = getPortalMiddlewareGetPlanDesignQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchUpdatePlanDesign = (planDesignDto)=>{
    return client({
        data: planDesignDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/plan-design`
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchUpdatePlanDesign(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchUpdatePlanDesign = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchUpdatePlanDesignMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanDesignTiles = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/plan-design/tiles`
    });
};
export const getPortalMiddlewareGetPlanDesignTilesQueryKey = ()=>{
    return [
        `/pm/api/plan-design/tiles`
    ];
};
export const getPortalMiddlewareGetPlanDesignTilesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanDesignTilesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanDesignTiles(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanDesignTiles(options) {
    const queryOptions = getPortalMiddlewareGetPlanDesignTilesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanParticipants = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/plan/participants`
    });
};
export const getPortalMiddlewareGetPlanParticipantsQueryKey = (params)=>{
    return [
        `/pm/api/plan/participants`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlanParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanParticipantsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanParticipants(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanParticipants(params, options) {
    const queryOptions = getPortalMiddlewareGetPlanParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanModel = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/plans/models`
    });
};
export const getPortalMiddlewareGetPlanModelQueryKey = (params)=>{
    return [
        `/pm/api/plans/models`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlanModelQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanModelQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanModel(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanModel(params, options) {
    const queryOptions = getPortalMiddlewareGetPlanModelQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchPlan = (planId, patchPlanBodyDto)=>{
    return client({
        data: patchPlanBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/plans/${planId}`
    });
};
export const getPortalMiddlewarePatchPlanMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { planId, data } = props ?? {};
        return portalMiddlewarePatchPlan(planId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchPlan = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchPlanMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetEsaProgram = (planId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/plans/${planId}/esa-program`
    });
};
export const getPortalMiddlewareGetEsaProgramQueryKey = (planId)=>{
    return [
        `/pm/api/plans/${planId}/esa-program`
    ];
};
export const getPortalMiddlewareGetEsaProgramQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEsaProgramQueryKey(planId);
    const queryFn = ({ signal })=>portalMiddlewareGetEsaProgram(planId, signal);
    return {
        enabled: !!planId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEsaProgram(planId, options) {
    const queryOptions = getPortalMiddlewareGetEsaProgramQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanInvestments = (planId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/plans/${planId}/investments`
    });
};
export const getPortalMiddlewareGetPlanInvestmentsQueryKey = (planId)=>{
    return [
        `/pm/api/plans/${planId}/investments`
    ];
};
export const getPortalMiddlewareGetPlanInvestmentsQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanInvestmentsQueryKey(planId);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanInvestments(planId, signal);
    return {
        enabled: !!planId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanInvestments(planId, options) {
    const queryOptions = getPortalMiddlewareGetPlanInvestmentsQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanModelSecurities = (planId, modelId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/plans/${planId}/models/${modelId}/securities`
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesQueryKey = (planId, modelId)=>{
    return [
        `/pm/api/plans/${planId}/models/${modelId}/securities`
    ];
};
export const getPortalMiddlewareGetPlanModelSecuritiesQueryOptions = (planId, modelId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanModelSecuritiesQueryKey(planId, modelId);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanModelSecurities(planId, modelId, signal);
    return {
        enabled: !!(planId && modelId),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanModelSecurities(planId, modelId, options) {
    const queryOptions = getPortalMiddlewareGetPlanModelSecuritiesQueryOptions(planId, modelId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetProgramModels = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/program/models`
    });
};
export const getPortalMiddlewareGetProgramModelsQueryKey = (params)=>{
    return [
        `/pm/api/program/models`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetProgramModelsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetProgramModelsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetProgramModels(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetProgramModels(params, options) {
    const queryOptions = getPortalMiddlewareGetProgramModelsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetProgramInvestmentOptionsExport = (programId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/program/${programId}/investment-options/download`
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportQueryKey = (programId)=>{
    return [
        `/pm/api/program/${programId}/investment-options/download`
    ];
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportQueryOptions = (programId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetProgramInvestmentOptionsExportQueryKey(programId);
    const queryFn = ({ signal })=>portalMiddlewareGetProgramInvestmentOptionsExport(programId, signal);
    return {
        enabled: !!programId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetProgramInvestmentOptionsExport(programId, options) {
    const queryOptions = getPortalMiddlewareGetProgramInvestmentOptionsExportQueryOptions(programId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetProspectusUrlParts = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/prospectus/url`
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsQueryKey = ()=>{
    return [
        `/pm/api/prospectus/url`
    ];
};
export const getPortalMiddlewareGetProspectusUrlPartsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetProspectusUrlPartsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetProspectusUrlParts(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetProspectusUrlParts(options) {
    const queryOptions = getPortalMiddlewareGetProspectusUrlPartsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAdvisorReport = (advisorId, reportType, fileName, params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/reports/advisors/${advisorId}/${reportType}/${fileName}`
    });
};
export const getPortalMiddlewareGetAdvisorReportQueryKey = (advisorId, reportType, fileName, params)=>{
    return [
        `/pm/api/reports/advisors/${advisorId}/${reportType}/${fileName}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAdvisorReportQueryOptions = (advisorId, reportType, fileName, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAdvisorReportQueryKey(advisorId, reportType, fileName, params);
    const queryFn = ({ signal })=>portalMiddlewareGetAdvisorReport(advisorId, reportType, fileName, params, signal);
    return {
        enabled: !!(advisorId && reportType && fileName),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAdvisorReport(advisorId, reportType, fileName, params, options) {
    const queryOptions = getPortalMiddlewareGetAdvisorReportQueryOptions(advisorId, reportType, fileName, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeeReport = (employeeId, reportType, fileName, params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/reports/employees/${employeeId}/${reportType}/${fileName}`
    });
};
export const getPortalMiddlewareGetEmployeeReportQueryKey = (employeeId, reportType, fileName, params)=>{
    return [
        `/pm/api/reports/employees/${employeeId}/${reportType}/${fileName}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeeReportQueryOptions = (employeeId, reportType, fileName, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeeReportQueryKey(employeeId, reportType, fileName, params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeeReport(employeeId, reportType, fileName, params, signal);
    return {
        enabled: !!(employeeId && reportType && fileName),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeeReport(employeeId, reportType, fileName, params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeeReportQueryOptions(employeeId, reportType, fileName, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetUnregisteredParticipantsReport = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/reports/participants/unregistered`
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportQueryKey = (params)=>{
    return [
        `/pm/api/reports/participants/unregistered`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetUnregisteredParticipantsReportQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetUnregisteredParticipantsReport(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetUnregisteredParticipantsReport(params, options) {
    const queryOptions = getPortalMiddlewareGetUnregisteredParticipantsReportQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanReport = (planId, reportType, fileName, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/reports/plans/${planId}/${reportType}/${fileName}`
    });
};
export const getPortalMiddlewareGetPlanReportQueryKey = (planId, reportType, fileName)=>{
    return [
        `/pm/api/reports/plans/${planId}/${reportType}/${fileName}`
    ];
};
export const getPortalMiddlewareGetPlanReportQueryOptions = (planId, reportType, fileName, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanReportQueryKey(planId, reportType, fileName);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanReport(planId, reportType, fileName, signal);
    return {
        enabled: !!(planId && reportType && fileName),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanReport(planId, reportType, fileName, options) {
    const queryOptions = getPortalMiddlewareGetPlanReportQueryOptions(planId, reportType, fileName, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSponsorReport = (sponsorId, reportType, fileName, params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/reports/sponsors/${sponsorId}/${reportType}/${fileName}`
    });
};
export const getPortalMiddlewareGetSponsorReportQueryKey = (sponsorId, reportType, fileName, params)=>{
    return [
        `/pm/api/reports/sponsors/${sponsorId}/${reportType}/${fileName}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetSponsorReportQueryOptions = (sponsorId, reportType, fileName, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorReportQueryKey(sponsorId, reportType, fileName, params);
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorReport(sponsorId, reportType, fileName, params, signal);
    return {
        enabled: !!(sponsorId && reportType && fileName),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorReport(sponsorId, reportType, fileName, params, options) {
    const queryOptions = getPortalMiddlewareGetSponsorReportQueryOptions(sponsorId, reportType, fileName, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSubaTransactionsReport = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/reports/suba-transactions`
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportQueryKey = (params)=>{
    return [
        `/pm/api/reports/suba-transactions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetSubaTransactionsReportQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSubaTransactionsReportQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetSubaTransactionsReport(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSubaTransactionsReport(params, options) {
    const queryOptions = getPortalMiddlewareGetSubaTransactionsReportQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAllSafeHarborContributionTypes = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/safe-harbor-contribution-types`
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesQueryKey = ()=>{
    return [
        `/pm/api/safe-harbor-contribution-types`
    ];
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAllSafeHarborContributionTypesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetAllSafeHarborContributionTypes(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAllSafeHarborContributionTypes(options) {
    const queryOptions = getPortalMiddlewareGetAllSafeHarborContributionTypesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSubaExternalMarketValue = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sdba/external-market-value`
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueQueryKey = (params)=>{
    return [
        `/pm/api/sdba/external-market-value`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetSubaExternalMarketValueQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSubaExternalMarketValueQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetSubaExternalMarketValue(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSubaExternalMarketValue(params, options) {
    const queryOptions = getPortalMiddlewareGetSubaExternalMarketValueQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostSubaInitiateExternalTransfer = (postSubaInitiateExternalTransferBodyDto)=>{
    return client({
        data: postSubaInitiateExternalTransferBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sdba/initiate-external-transfer`
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostSubaInitiateExternalTransfer(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostSubaInitiateExternalTransfer = (options)=>{
    const mutationOptions = getPortalMiddlewarePostSubaInitiateExternalTransferMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetSdbaSetup = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sdba/setup`
    });
};
export const getPortalMiddlewareGetSdbaSetupQueryKey = ()=>{
    return [
        `/pm/api/sdba/setup`
    ];
};
export const getPortalMiddlewareGetSdbaSetupQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSdbaSetupQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSdbaSetup(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSdbaSetup(options) {
    const queryOptions = getPortalMiddlewareGetSdbaSetupQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSdbaTransfersInfo = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sdba/transfers`
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoQueryKey = (params)=>{
    return [
        `/pm/api/sdba/transfers`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetSdbaTransfersInfoQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSdbaTransfersInfoQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetSdbaTransfersInfo(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSdbaTransfersInfo(params, options) {
    const queryOptions = getPortalMiddlewareGetSdbaTransfersInfoQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetCheckActiveSdbaTransfers = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sdba/transfers-in-progress`
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersQueryKey = (params)=>{
    return [
        `/pm/api/sdba/transfers-in-progress`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetCheckActiveSdbaTransfersQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetCheckActiveSdbaTransfers(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetCheckActiveSdbaTransfers(params, options) {
    const queryOptions = getPortalMiddlewareGetCheckActiveSdbaTransfersQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSession = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/session`
    });
};
export const getPortalMiddlewareGetSessionQueryKey = ()=>{
    return [
        `/pm/api/session`
    ];
};
export const getPortalMiddlewareGetSessionQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSessionQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSession(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSession(options) {
    const queryOptions = getPortalMiddlewareGetSessionQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSponsorAbilities = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/abilities`
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/abilities`
    ];
};
export const getPortalMiddlewareGetSponsorAbilitiesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorAbilitiesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorAbilities(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorAbilities(options) {
    const queryOptions = getPortalMiddlewareGetSponsorAbilitiesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAutoEnrollSponsorPlan = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/auto-enroll`
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/auto-enroll`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAutoEnrollSponsorPlanQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetAutoEnrollSponsorPlan(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAutoEnrollSponsorPlan(params, options) {
    const queryOptions = getPortalMiddlewareGetAutoEnrollSponsorPlanQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetCensusParticipants = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/census/participants`
    });
};
export const getPortalMiddlewareGetCensusParticipantsQueryKey = ()=>{
    return [
        `/pm/api/sponsor/census/participants`
    ];
};
export const getPortalMiddlewareGetCensusParticipantsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetCensusParticipantsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetCensusParticipants(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetCensusParticipants(options) {
    const queryOptions = getPortalMiddlewareGetCensusParticipantsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetBankAccount = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/company/bank-account`
    });
};
export const getPortalMiddlewareGetBankAccountQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/company/bank-account`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetBankAccountQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetBankAccountQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetBankAccount(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetBankAccount(params, options) {
    const queryOptions = getPortalMiddlewareGetBankAccountQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostBankAccount = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/company/bank-account`
    });
};
export const getPortalMiddlewarePostBankAccountMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostBankAccount();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostBankAccount = (options)=>{
    const mutationOptions = getPortalMiddlewarePostBankAccountMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutBankAccount = (postBankAccountDto)=>{
    return client({
        data: postBankAccountDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/company/bank-account`
    });
};
export const getPortalMiddlewarePutBankAccountMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutBankAccount(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutBankAccount = (options)=>{
    const mutationOptions = getPortalMiddlewarePutBankAccountMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutSponsorArchiveBankAccount = (putBankAccountArchiveDto)=>{
    return client({
        data: putBankAccountArchiveDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/company/bank-account/archive`
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutSponsorArchiveBankAccount(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutSponsorArchiveBankAccount = (options)=>{
    const mutationOptions = getPortalMiddlewarePutSponsorArchiveBankAccountMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutFeePaymentMethod = (putFeePaymentMethodDto)=>{
    return client({
        data: putFeePaymentMethodDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/company/bank-account/fee-payment-method`
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutFeePaymentMethod(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutFeePaymentMethod = (options)=>{
    const mutationOptions = getPortalMiddlewarePutFeePaymentMethodMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePatchSponsor = (companyInfoBodyDto)=>{
    return client({
        data: companyInfoBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/sponsor/company/company-info`
    });
};
export const getPortalMiddlewarePatchSponsorMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchSponsor(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchSponsor = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchSponsorMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetSponsorTeammates = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/company/manage-teammate`
    });
};
export const getPortalMiddlewareGetSponsorTeammatesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/company/manage-teammate`
    ];
};
export const getPortalMiddlewareGetSponsorTeammatesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorTeammatesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorTeammates(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorTeammates(options) {
    const queryOptions = getPortalMiddlewareGetSponsorTeammatesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchDeleteTeammate = ()=>{
    return client({
        method: 'PATCH',
        url: `/pm/api/sponsor/company/manage-teammate`
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePatchDeleteTeammate();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchDeleteTeammate = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchDeleteTeammateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostSendUserInvite = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/company/manage-teammate`
    });
};
export const getPortalMiddlewarePostSendUserInviteMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostSendUserInvite();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostSendUserInvite = (options)=>{
    const mutationOptions = getPortalMiddlewarePostSendUserInviteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanConfigurationV2 = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/compliance/configuration`
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2QueryKey = ()=>{
    return [
        `/pm/api/sponsor/compliance/configuration`
    ];
};
export const getPortalMiddlewareGetPlanConfigurationV2QueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanConfigurationV2QueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanConfigurationV2(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanConfigurationV2(options) {
    const queryOptions = getPortalMiddlewareGetPlanConfigurationV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPlanConfigurationV2 = (putPlanConfigurationBodyDtoV2)=>{
    return client({
        data: putPlanConfigurationBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/compliance/configuration`
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanConfigurationV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanConfigurationV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanConfigurationV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanEmployeesV2 = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/compliance/employees`
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2QueryKey = ()=>{
    return [
        `/pm/api/sponsor/compliance/employees`
    ];
};
export const getPortalMiddlewareGetPlanEmployeesV2QueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanEmployeesV2QueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanEmployeesV2(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanEmployeesV2(options) {
    const queryOptions = getPortalMiddlewareGetPlanEmployeesV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanGrossCompensationV2 = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/compliance/gross-compensation`
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2QueryKey = ()=>{
    return [
        `/pm/api/sponsor/compliance/gross-compensation`
    ];
};
export const getPortalMiddlewareGetPlanGrossCompensationV2QueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanGrossCompensationV2QueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanGrossCompensationV2(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanGrossCompensationV2(options) {
    const queryOptions = getPortalMiddlewareGetPlanGrossCompensationV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPlanEmployeeGrossCompensationV2 = (putPlanGrossCompensationBodyDtoV2)=>{
    return client({
        data: putPlanGrossCompensationBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/compliance/gross-compensation`
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanEmployeeGrossCompensationV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanEmployeeGrossCompensationV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetGrossCompensationTemplateV2 = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/compliance/gross-compensation/download/template`
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2QueryKey = (params)=>{
    return [
        `/pm/api/sponsor/compliance/gross-compensation/download/template`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2QueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGrossCompensationTemplateV2QueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetGrossCompensationTemplateV2(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGrossCompensationTemplateV2(params, options) {
    const queryOptions = getPortalMiddlewareGetGrossCompensationTemplateV2QueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostPlanEmployeeGrossCompensationUploadV2 = (postPlanGrossCompensationUploadBodyDtoV2)=>{
    return client({
        data: postPlanGrossCompensationUploadBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/compliance/gross-compensation/upload`
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostPlanEmployeeGrossCompensationUploadV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostPlanNonEmployeeOwnerV2 = (postPlanNonEmployeeOwnerBodyDtoV2)=>{
    return client({
        data: postPlanNonEmployeeOwnerBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/compliance/non-employee-owner`
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostPlanNonEmployeeOwnerV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPlanNonEmployeeOwnerV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPlanNonEmployeeOwnerV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanOfficersV2 = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/compliance/officers`
    });
};
export const getPortalMiddlewareGetPlanOfficersV2QueryKey = ()=>{
    return [
        `/pm/api/sponsor/compliance/officers`
    ];
};
export const getPortalMiddlewareGetPlanOfficersV2QueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanOfficersV2QueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanOfficersV2(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanOfficersV2(options) {
    const queryOptions = getPortalMiddlewareGetPlanOfficersV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPlanOfficerStatusV2 = (putPlanOfficersBodyDtoV2)=>{
    return client({
        data: putPlanOfficersBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/compliance/officers`
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanOfficerStatusV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanOfficerStatusV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanOfficerStatusV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareDeletePlanOwnerV2 = (deletePlanOwnerBodyDtoV2)=>{
    return client({
        data: deletePlanOwnerBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'DELETE',
        url: `/pm/api/sponsor/compliance/owners`
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewareDeletePlanOwnerV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewareDeletePlanOwnerV2 = (options)=>{
    const mutationOptions = getPortalMiddlewareDeletePlanOwnerV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanOwnersV2 = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/compliance/owners`
    });
};
export const getPortalMiddlewareGetPlanOwnersV2QueryKey = ()=>{
    return [
        `/pm/api/sponsor/compliance/owners`
    ];
};
export const getPortalMiddlewareGetPlanOwnersV2QueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanOwnersV2QueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanOwnersV2(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanOwnersV2(options) {
    const queryOptions = getPortalMiddlewareGetPlanOwnersV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostPlanEmployeeOwnerV2 = (postPlanEmployeeOwnerBodyDtoV2)=>{
    return client({
        data: postPlanEmployeeOwnerBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/compliance/owners`
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostPlanEmployeeOwnerV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPlanEmployeeOwnerV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPlanEmployeeOwnerV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutPlanEmployeeOwnerV2 = (putPlanEmployeeOwnerBodyDtoV2)=>{
    return client({
        data: putPlanEmployeeOwnerBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/compliance/owners`
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanEmployeeOwnerV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanEmployeeOwnerV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanEmployeeOwnerV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareDeletePlanOwnersFamilyV2 = (deletePlanOwnersFamilyBodyDtoV2)=>{
    return client({
        data: deletePlanOwnersFamilyBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'DELETE',
        url: `/pm/api/sponsor/compliance/owners-family`
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewareDeletePlanOwnersFamilyV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewareDeletePlanOwnersFamilyV2 = (options)=>{
    const mutationOptions = getPortalMiddlewareDeletePlanOwnersFamilyV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanOwnersFamilyV2 = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/compliance/owners-family`
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2QueryKey = (params)=>{
    return [
        `/pm/api/sponsor/compliance/owners-family`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2QueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanOwnersFamilyV2QueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanOwnersFamilyV2(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanOwnersFamilyV2(params, options) {
    const queryOptions = getPortalMiddlewareGetPlanOwnersFamilyV2QueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPlanOwnersFamilyV2 = (putPlanOwnersFamilyBodyDtoV2)=>{
    return client({
        data: putPlanOwnersFamilyBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/compliance/owners-family`
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanOwnersFamilyV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanOwnersFamilyV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanOwnersFamilyV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostFileHeadersUpdate = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contribution/headers/mapping`
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostFileHeadersUpdate();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostFileHeadersUpdate = (options)=>{
    const mutationOptions = getPortalMiddlewarePostFileHeadersUpdateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetContributionsLandingPageDisplay = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions`
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayQueryKey = ()=>{
    return [
        `/pm/api/sponsor/contributions`
    ];
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionsLandingPageDisplayQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetContributionsLandingPageDisplay(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionsLandingPageDisplay(options) {
    const queryOptions = getPortalMiddlewareGetContributionsLandingPageDisplayQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostContribution = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions`
    });
};
export const getPortalMiddlewarePostContributionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostContribution();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostContribution = (options)=>{
    const mutationOptions = getPortalMiddlewarePostContributionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostCancelSubmission = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/cancel`
    });
};
export const getPortalMiddlewarePostCancelSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostCancelSubmission();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostCancelSubmission = (options)=>{
    const mutationOptions = getPortalMiddlewarePostCancelSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostCancellationSubmission = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/cancellation`
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostCancellationSubmission();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostCancellationSubmission = (options)=>{
    const mutationOptions = getPortalMiddlewarePostCancellationSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantsLoans = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/loans`
    });
};
export const getPortalMiddlewareGetParticipantsLoansQueryKey = ()=>{
    return [
        `/pm/api/sponsor/contributions/loans`
    ];
};
export const getPortalMiddlewareGetParticipantsLoansQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantsLoansQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantsLoans(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantsLoans(options) {
    const queryOptions = getPortalMiddlewareGetParticipantsLoansQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostMatchRemediationContribution = (postMatchRemediationContributionBodyDto)=>{
    return client({
        data: postMatchRemediationContributionBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/contributions/match-remediation`
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostMatchRemediationContribution(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostMatchRemediationContribution = (options)=>{
    const mutationOptions = getPortalMiddlewarePostMatchRemediationContributionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostOffCycleContribution = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/offcycle`
    });
};
export const getPortalMiddlewarePostOffCycleContributionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostOffCycleContribution();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostOffCycleContribution = (options)=>{
    const mutationOptions = getPortalMiddlewarePostOffCycleContributionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostResumeSubmission = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/resume`
    });
};
export const getPortalMiddlewarePostResumeSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostResumeSubmission();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostResumeSubmission = (options)=>{
    const mutationOptions = getPortalMiddlewarePostResumeSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostIngestionFlowValidation = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/validate`
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostIngestionFlowValidation();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostIngestionFlowValidation = (options)=>{
    const mutationOptions = getPortalMiddlewarePostIngestionFlowValidationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostContributionValidation = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/validation`
    });
};
export const getPortalMiddlewarePostContributionValidationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostContributionValidation();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostContributionValidation = (options)=>{
    const mutationOptions = getPortalMiddlewarePostContributionValidationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetContributionSubmissionDisplay = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}`
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}`
    ];
};
export const getPortalMiddlewareGetContributionSubmissionDisplayQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionSubmissionDisplayQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionSubmissionDisplay(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionSubmissionDisplay(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionSubmissionDisplayQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetContributionAdjustments = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/adjustments`
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/adjustments`
    ];
};
export const getPortalMiddlewareGetContributionAdjustmentsQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionAdjustmentsQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionAdjustments(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionAdjustments(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionAdjustmentsQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostContributionConfirmation = (ucid)=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/${ucid}/confirm`
    });
};
export const getPortalMiddlewarePostContributionConfirmationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid } = props ?? {};
        return portalMiddlewarePostContributionConfirmation(ucid);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostContributionConfirmation = (options)=>{
    const mutationOptions = getPortalMiddlewarePostContributionConfirmationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetContributionConfirmationDisplay = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/confirmation`
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/confirmation`
    ];
};
export const getPortalMiddlewareGetContributionConfirmationDisplayQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionConfirmationDisplayQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionConfirmationDisplay(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionConfirmationDisplay(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionConfirmationDisplayQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostContributionCorrection = (ucid)=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/${ucid}/correction`
    });
};
export const getPortalMiddlewarePostContributionCorrectionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid } = props ?? {};
        return portalMiddlewarePostContributionCorrection(ucid);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostContributionCorrection = (options)=>{
    const mutationOptions = getPortalMiddlewarePostContributionCorrectionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetContributionCorrections = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/corrections`
    });
};
export const getPortalMiddlewareGetContributionCorrectionsQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/corrections`
    ];
};
export const getPortalMiddlewareGetContributionCorrectionsQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionCorrectionsQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionCorrections(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionCorrections(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionCorrectionsQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetContributionDetails = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/details`
    });
};
export const getPortalMiddlewareGetContributionDetailsQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/details`
    ];
};
export const getPortalMiddlewareGetContributionDetailsQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionDetailsQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionDetails(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionDetails(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionDetailsQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetContributionDisplay = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/display`
    });
};
export const getPortalMiddlewareGetContributionDisplayQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/display`
    ];
};
export const getPortalMiddlewareGetContributionDisplayQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionDisplayQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionDisplay(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionDisplay(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionDisplayQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostContributionUpload = (ucid, categoryId)=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/${ucid}/document-category/${categoryId}/upload`
    });
};
export const getPortalMiddlewarePostContributionUploadMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid, categoryId } = props ?? {};
        return portalMiddlewarePostContributionUpload(ucid, categoryId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostContributionUpload = (options)=>{
    const mutationOptions = getPortalMiddlewarePostContributionUploadMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetDownloadContributionFile = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/file`
    });
};
export const getPortalMiddlewareGetDownloadContributionFileQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/file`
    ];
};
export const getPortalMiddlewareGetDownloadContributionFileQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDownloadContributionFileQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetDownloadContributionFile(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDownloadContributionFile(ucid, options) {
    const queryOptions = getPortalMiddlewareGetDownloadContributionFileQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetForfeiture = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/forfeiture`
    });
};
export const getPortalMiddlewareGetForfeitureQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/forfeiture`
    ];
};
export const getPortalMiddlewareGetForfeitureQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetForfeitureQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetForfeiture(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetForfeiture(ucid, options) {
    const queryOptions = getPortalMiddlewareGetForfeitureQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostForfeiture = (ucid)=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/${ucid}/forfeiture`
    });
};
export const getPortalMiddlewarePostForfeitureMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid } = props ?? {};
        return portalMiddlewarePostForfeiture(ucid);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostForfeiture = (options)=>{
    const mutationOptions = getPortalMiddlewarePostForfeitureMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetContributionHeaderValidations = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/headers`
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/headers`
    ];
};
export const getPortalMiddlewareGetContributionHeaderValidationsQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionHeaderValidationsQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionHeaderValidations(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionHeaderValidations(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionHeaderValidationsQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetNormalizedContributionData = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/normalized`
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/normalized`
    ];
};
export const getPortalMiddlewareGetNormalizedContributionDataQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetNormalizedContributionDataQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetNormalizedContributionData(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetNormalizedContributionData(ucid, options) {
    const queryOptions = getPortalMiddlewareGetNormalizedContributionDataQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostIngestionFlowStart = (ucid)=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/${ucid}/start`
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid } = props ?? {};
        return portalMiddlewarePostIngestionFlowStart(ucid);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostIngestionFlowStart = (options)=>{
    const mutationOptions = getPortalMiddlewarePostIngestionFlowStartMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetDownloadContributionTemplate = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/template.xlsx`
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/template.xlsx`
    ];
};
export const getPortalMiddlewareGetDownloadContributionTemplateQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDownloadContributionTemplateQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetDownloadContributionTemplate(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDownloadContributionTemplate(ucid, options) {
    const queryOptions = getPortalMiddlewareGetDownloadContributionTemplateQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetContributionValidationPageDisplay = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/validate`
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/validate`
    ];
};
export const getPortalMiddlewareGetContributionValidationPageDisplayQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionValidationPageDisplayQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionValidationPageDisplay(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionValidationPageDisplay(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionValidationPageDisplayQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetContributionValidation = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/validation`
    });
};
export const getPortalMiddlewareGetContributionValidationQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/validation`
    ];
};
export const getPortalMiddlewareGetContributionValidationQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionValidationQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionValidation(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionValidation(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionValidationQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetDeferralChanges = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/deferral/changes`
    });
};
export const getPortalMiddlewareGetDeferralChangesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/deferral/changes`
    ];
};
export const getPortalMiddlewareGetDeferralChangesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDeferralChangesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetDeferralChanges(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDeferralChanges(options) {
    const queryOptions = getPortalMiddlewareGetDeferralChangesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchDeferralChangesActivities = ()=>{
    return client({
        method: 'PATCH',
        url: `/pm/api/sponsor/deferral/changes`
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePatchDeferralChangesActivities();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchDeferralChangesActivities = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchDeferralChangesActivitiesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutParticipant = ()=>{
    return client({
        method: 'PUT',
        url: `/pm/api/sponsor/employee`
    });
};
export const getPortalMiddlewarePutParticipantMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePutParticipant();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutParticipant = (options)=>{
    const mutationOptions = getPortalMiddlewarePutParticipantMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetEmployeeClasses = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/employee-classes`
    });
};
export const getPortalMiddlewareGetEmployeeClassesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/employee-classes`
    ];
};
export const getPortalMiddlewareGetEmployeeClassesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeeClassesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeeClasses(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeeClasses(options) {
    const queryOptions = getPortalMiddlewareGetEmployeeClassesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployees = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/employees`
    });
};
export const getPortalMiddlewareGetEmployeesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/employees`
    ];
};
export const getPortalMiddlewareGetEmployeesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetEmployees(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployees(options) {
    const queryOptions = getPortalMiddlewareGetEmployeesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutParticipants = ()=>{
    return client({
        method: 'PUT',
        url: `/pm/api/sponsor/employees`
    });
};
export const getPortalMiddlewarePutParticipantsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePutParticipants();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutParticipants = (options)=>{
    const mutationOptions = getPortalMiddlewarePutParticipantsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostUploadCensusOriginal = (postCensusOriginalBodyDto)=>{
    return client({
        data: postCensusOriginalBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/employees/original`
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostUploadCensusOriginal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostUploadCensusOriginal = (options)=>{
    const mutationOptions = getPortalMiddlewarePostUploadCensusOriginalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostValidateEmployee = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/employees/validate`
    });
};
export const getPortalMiddlewarePostValidateEmployeeMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostValidateEmployee();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostValidateEmployee = (options)=>{
    const mutationOptions = getPortalMiddlewarePostValidateEmployeeMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetEmployeeDetails = (employeeId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/employees/${employeeId}`
    });
};
export const getPortalMiddlewareGetEmployeeDetailsQueryKey = (employeeId)=>{
    return [
        `/pm/api/sponsor/employees/${employeeId}`
    ];
};
export const getPortalMiddlewareGetEmployeeDetailsQueryOptions = (employeeId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeeDetailsQueryKey(employeeId);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeeDetails(employeeId, signal);
    return {
        enabled: !!employeeId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeeDetails(employeeId, options) {
    const queryOptions = getPortalMiddlewareGetEmployeeDetailsQueryOptions(employeeId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostContactInfo = (employeeId)=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/employees/${employeeId}/address`
    });
};
export const getPortalMiddlewarePostContactInfoMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { employeeId } = props ?? {};
        return portalMiddlewarePostContactInfo(employeeId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostContactInfo = (options)=>{
    const mutationOptions = getPortalMiddlewarePostContactInfoMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutParticipantContributions = (employeeId)=>{
    return client({
        method: 'PUT',
        url: `/pm/api/sponsor/employees/${employeeId}/contributions`
    });
};
export const getPortalMiddlewarePutParticipantContributionsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { employeeId } = props ?? {};
        return portalMiddlewarePutParticipantContributions(employeeId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutParticipantContributions = (options)=>{
    const mutationOptions = getPortalMiddlewarePutParticipantContributionsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetSponsorEntity = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/entity`
    });
};
export const getPortalMiddlewareGetSponsorEntityQueryKey = ()=>{
    return [
        `/pm/api/sponsor/entity`
    ];
};
export const getPortalMiddlewareGetSponsorEntityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorEntityQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorEntity(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorEntity(options) {
    const queryOptions = getPortalMiddlewareGetSponsorEntityQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetForfeiturePreference = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/forfeiture-preference`
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceQueryKey = ()=>{
    return [
        `/pm/api/sponsor/forfeiture-preference`
    ];
};
export const getPortalMiddlewareGetForfeiturePreferenceQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetForfeiturePreferenceQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetForfeiturePreference(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetForfeiturePreference(options) {
    const queryOptions = getPortalMiddlewareGetForfeiturePreferenceQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutForfeiturePreference = (putForfeiturePreferenceBodyDto)=>{
    return client({
        data: putForfeiturePreferenceBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/forfeiture-preference`
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutForfeiturePreference(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutForfeiturePreference = (options)=>{
    const mutationOptions = getPortalMiddlewarePutForfeiturePreferenceMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetHeapData = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/heap`
    });
};
export const getPortalMiddlewareGetHeapDataQueryKey = ()=>{
    return [
        `/pm/api/sponsor/heap`
    ];
};
export const getPortalMiddlewareGetHeapDataQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetHeapDataQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetHeapData(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetHeapData(options) {
    const queryOptions = getPortalMiddlewareGetHeapDataQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetOnboarding = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/onboarding`
    });
};
export const getPortalMiddlewareGetOnboardingQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/onboarding`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetOnboardingQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetOnboardingQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetOnboarding(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetOnboarding(params, options) {
    const queryOptions = getPortalMiddlewareGetOnboardingQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostOnboarding = (params)=>{
    return client({
        method: 'POST',
        params,
        url: `/pm/api/sponsor/onboarding`
    });
};
export const getPortalMiddlewarePostOnboardingMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { params } = props ?? {};
        return portalMiddlewarePostOnboarding(params);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostOnboarding = (options)=>{
    const mutationOptions = getPortalMiddlewarePostOnboardingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutOnboarding = ()=>{
    return client({
        method: 'PUT',
        url: `/pm/api/sponsor/onboarding`
    });
};
export const getPortalMiddlewarePutOnboardingMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePutOnboarding();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutOnboarding = (options)=>{
    const mutationOptions = getPortalMiddlewarePutOnboardingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetSponsorOnboardingInformation = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding-information`
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding-information`
    ];
};
export const getPortalMiddlewareGetSponsorOnboardingInformationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorOnboardingInformationQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorOnboardingInformation(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorOnboardingInformation(options) {
    const queryOptions = getPortalMiddlewareGetSponsorOnboardingInformationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutSponsorOnboardingInformation = (putSponsorOnboardingInformationDto)=>{
    return client({
        data: putSponsorOnboardingInformationDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/onboarding-information`
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutSponsorOnboardingInformation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutSponsorOnboardingInformation = (options)=>{
    const mutationOptions = getPortalMiddlewarePutSponsorOnboardingInformationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostUploadCensus = (postCensusBodyDto)=>{
    return client({
        data: postCensusBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/onboarding/add-employees`
    });
};
export const getPortalMiddlewarePostUploadCensusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostUploadCensus(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostUploadCensus = (options)=>{
    const mutationOptions = getPortalMiddlewarePostUploadCensusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostUploadOnboardingCensusOriginal = (postCensusOriginalBodyDto)=>{
    return client({
        data: postCensusOriginalBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/onboarding/add-employees/original`
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostUploadOnboardingCensusOriginal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostUploadOnboardingCensusOriginal = (options)=>{
    const mutationOptions = getPortalMiddlewarePostUploadOnboardingCensusOriginalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetInitialCensus = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/onboarding/census`
    });
};
export const getPortalMiddlewareGetInitialCensusQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/onboarding/census`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetInitialCensusQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetInitialCensusQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetInitialCensus(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetInitialCensus(params, options) {
    const queryOptions = getPortalMiddlewareGetInitialCensusQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareDeleteCensusCache = ()=>{
    return client({
        method: 'DELETE',
        url: `/pm/api/sponsor/onboarding/census-cache`
    });
};
export const getPortalMiddlewareDeleteCensusCacheMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewareDeleteCensusCache();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewareDeleteCensusCache = (options)=>{
    const mutationOptions = getPortalMiddlewareDeleteCensusCacheMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetCensusCache = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding/census-cache`
    });
};
export const getPortalMiddlewareGetCensusCacheQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding/census-cache`
    ];
};
export const getPortalMiddlewareGetCensusCacheQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetCensusCacheQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetCensusCache(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetCensusCache(options) {
    const queryOptions = getPortalMiddlewareGetCensusCacheQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostCensusCache = (postCensusCacheBodyDto)=>{
    return client({
        data: postCensusCacheBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/onboarding/census-cache`
    });
};
export const getPortalMiddlewarePostCensusCacheMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostCensusCache(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostCensusCache = (options)=>{
    const mutationOptions = getPortalMiddlewarePostCensusCacheMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetSponsorEsaProgram = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/onboarding/esa-program`
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/onboarding/esa-program`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetSponsorEsaProgramQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorEsaProgramQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorEsaProgram(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorEsaProgram(params, options) {
    const queryOptions = getPortalMiddlewareGetSponsorEsaProgramQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostFinishOnboarding = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/onboarding/finish`
    });
};
export const getPortalMiddlewarePostFinishOnboardingMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostFinishOnboarding();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostFinishOnboarding = (options)=>{
    const mutationOptions = getPortalMiddlewarePostFinishOnboardingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetSponsorOnboardingTeammates = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding/manage-teammate`
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding/manage-teammate`
    ];
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorOnboardingTeammatesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorOnboardingTeammates(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorOnboardingTeammates(options) {
    const queryOptions = getPortalMiddlewareGetSponsorOnboardingTeammatesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostSendOnboardingUserInvite = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/onboarding/manage-teammate`
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostSendOnboardingUserInvite();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostSendOnboardingUserInvite = (options)=>{
    const mutationOptions = getPortalMiddlewarePostSendOnboardingUserInviteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetNextPayrollDates = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding/payroll-dates`
    });
};
export const getPortalMiddlewareGetNextPayrollDatesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding/payroll-dates`
    ];
};
export const getPortalMiddlewareGetNextPayrollDatesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetNextPayrollDatesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetNextPayrollDates(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetNextPayrollDates(options) {
    const queryOptions = getPortalMiddlewareGetNextPayrollDatesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPayrollProviders = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding/payroll-providers`
    });
};
export const getPortalMiddlewareGetPayrollProvidersQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding/payroll-providers`
    ];
};
export const getPortalMiddlewareGetPayrollProvidersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPayrollProvidersQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPayrollProviders(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPayrollProviders(options) {
    const queryOptions = getPortalMiddlewareGetPayrollProvidersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSponsorPlaidLinkToken = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding/plaid-link-token`
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding/plaid-link-token`
    ];
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorPlaidLinkTokenQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorPlaidLinkToken(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorPlaidLinkToken(options) {
    const queryOptions = getPortalMiddlewareGetSponsorPlaidLinkTokenQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostGetSponsorPlaidLinks = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/onboarding/plaid-links`
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostGetSponsorPlaidLinks();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostGetSponsorPlaidLinks = (options)=>{
    const mutationOptions = getPortalMiddlewarePostGetSponsorPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanDesignConsultState = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding/plan-design-consult-state`
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding/plan-design-consult-state`
    ];
};
export const getPortalMiddlewareGetPlanDesignConsultStateQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanDesignConsultStateQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanDesignConsultState(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanDesignConsultState(options) {
    const queryOptions = getPortalMiddlewareGetPlanDesignConsultStateQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanLaunchCallUrl = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding/plan-launch-call`
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding/plan-launch-call`
    ];
};
export const getPortalMiddlewareGetPlanLaunchCallUrlQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanLaunchCallUrlQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanLaunchCallUrl(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanLaunchCallUrl(options) {
    const queryOptions = getPortalMiddlewareGetPlanLaunchCallUrlQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetUserRoles = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding/user-roles`
    });
};
export const getPortalMiddlewareGetUserRolesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding/user-roles`
    ];
};
export const getPortalMiddlewareGetUserRolesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetUserRolesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetUserRoles(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetUserRoles(options) {
    const queryOptions = getPortalMiddlewareGetUserRolesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPayrollConnectionStatus = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/payroll/connection-status`
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusQueryKey = ()=>{
    return [
        `/pm/api/sponsor/payroll/connection-status`
    ];
};
export const getPortalMiddlewareGetPayrollConnectionStatusQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPayrollConnectionStatusQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPayrollConnectionStatus(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPayrollConnectionStatus(options) {
    const queryOptions = getPortalMiddlewareGetPayrollConnectionStatusQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPayrollDates = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/payroll/dates`
    });
};
export const getPortalMiddlewareGetPayrollDatesQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/payroll/dates`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPayrollDatesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPayrollDatesQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPayrollDates(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPayrollDates(params, options) {
    const queryOptions = getPortalMiddlewareGetPayrollDatesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPayrollInfo = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/payroll/info`
    });
};
export const getPortalMiddlewareGetPayrollInfoQueryKey = ()=>{
    return [
        `/pm/api/sponsor/payroll/info`
    ];
};
export const getPortalMiddlewareGetPayrollInfoQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPayrollInfoQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPayrollInfo(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPayrollInfo(options) {
    const queryOptions = getPortalMiddlewareGetPayrollInfoQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPayrollSetups = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/payroll/setup`
    });
};
export const getPortalMiddlewareGetPayrollSetupsQueryKey = ()=>{
    return [
        `/pm/api/sponsor/payroll/setup`
    ];
};
export const getPortalMiddlewareGetPayrollSetupsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPayrollSetupsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPayrollSetups(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPayrollSetups(options) {
    const queryOptions = getPortalMiddlewareGetPayrollSetupsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostPayrollSetup = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/payroll/setup`
    });
};
export const getPortalMiddlewarePostPayrollSetupMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostPayrollSetup();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPayrollSetup = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPayrollSetupMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostBulkPayrollSetupDisconnection = (bulkPayrollSetupDto)=>{
    return client({
        data: bulkPayrollSetupDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/payroll/setup/disconnect`
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostBulkPayrollSetupDisconnection(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostBulkPayrollSetupDisconnection = (options)=>{
    const mutationOptions = getPortalMiddlewarePostBulkPayrollSetupDisconnectionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPayrollFundingSetups = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/payroll/setup/funding`
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsQueryKey = ()=>{
    return [
        `/pm/api/sponsor/payroll/setup/funding`
    ];
};
export const getPortalMiddlewareGetPayrollFundingSetupsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPayrollFundingSetupsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPayrollFundingSetups(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPayrollFundingSetups(options) {
    const queryOptions = getPortalMiddlewareGetPayrollFundingSetupsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPayrollProvider = ()=>{
    return client({
        method: 'PUT',
        url: `/pm/api/sponsor/payroll/setup/provider`
    });
};
export const getPortalMiddlewarePutPayrollProviderMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePutPayrollProvider();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPayrollProvider = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPayrollProviderMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutPayrollSkipStatus = ()=>{
    return client({
        method: 'PUT',
        url: `/pm/api/sponsor/payroll/setup/skip`
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePutPayrollSkipStatus();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPayrollSkipStatus = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPayrollSkipStatusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutSkipSubmission = ()=>{
    return client({
        method: 'PUT',
        url: `/pm/api/sponsor/payroll/setup/skipping`
    });
};
export const getPortalMiddlewarePutSkipSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePutSkipSubmission();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutSkipSubmission = (options)=>{
    const mutationOptions = getPortalMiddlewarePutSkipSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareDeletePayrollSetup = (payrollSetupId)=>{
    return client({
        method: 'DELETE',
        url: `/pm/api/sponsor/payroll/setup/${payrollSetupId}`
    });
};
export const getPortalMiddlewareDeletePayrollSetupMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { payrollSetupId } = props ?? {};
        return portalMiddlewareDeletePayrollSetup(payrollSetupId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewareDeletePayrollSetup = (options)=>{
    const mutationOptions = getPortalMiddlewareDeletePayrollSetupMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutPayrollDates = (payrollSetupId)=>{
    return client({
        method: 'PUT',
        url: `/pm/api/sponsor/payroll/setup/${payrollSetupId}/dates`
    });
};
export const getPortalMiddlewarePutPayrollDatesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { payrollSetupId } = props ?? {};
        return portalMiddlewarePutPayrollDates(payrollSetupId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPayrollDates = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPayrollDatesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostPayrollSetupDisconnection = (payrollSetupId)=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/payroll/setup/${payrollSetupId}/disconnect`
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { payrollSetupId } = props ?? {};
        return portalMiddlewarePostPayrollSetupDisconnection(payrollSetupId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPayrollSetupDisconnection = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPayrollSetupDisconnectionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutPayrollSetupInfo = (payrollSetupId)=>{
    return client({
        method: 'PUT',
        url: `/pm/api/sponsor/payroll/setup/${payrollSetupId}/info`
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { payrollSetupId } = props ?? {};
        return portalMiddlewarePutPayrollSetupInfo(payrollSetupId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPayrollSetupInfo = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPayrollSetupInfoMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostPayrollValidations = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/payroll/validate`
    });
};
export const getPortalMiddlewarePostPayrollValidationsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostPayrollValidations();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPayrollValidations = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPayrollValidationsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanFeatures = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/plan-features`
    });
};
export const getPortalMiddlewareGetPlanFeaturesQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/plan-features`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlanFeaturesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanFeaturesQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanFeatures(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanFeatures(params, options) {
    const queryOptions = getPortalMiddlewareGetPlanFeaturesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanOnboardingStatus = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/plan/onboarding/status`
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusQueryKey = ()=>{
    return [
        `/pm/api/sponsor/plan/onboarding/status`
    ];
};
export const getPortalMiddlewareGetPlanOnboardingStatusQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanOnboardingStatusQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanOnboardingStatus(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanOnboardingStatus(options) {
    const queryOptions = getPortalMiddlewareGetPlanOnboardingStatusQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostSponsorPlanDisconnection = (planId)=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/plan/${planId}/disconnect`
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { planId } = props ?? {};
        return portalMiddlewarePostSponsorPlanDisconnection(planId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostSponsorPlanDisconnection = (options)=>{
    const mutationOptions = getPortalMiddlewarePostSponsorPlanDisconnectionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanStatistics = (planId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/plans/${planId}/stats`
    });
};
export const getPortalMiddlewareGetPlanStatisticsQueryKey = (planId)=>{
    return [
        `/pm/api/sponsor/plans/${planId}/stats`
    ];
};
export const getPortalMiddlewareGetPlanStatisticsQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanStatisticsQueryKey(planId);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanStatistics(planId, signal);
    return {
        enabled: !!planId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanStatistics(planId, options) {
    const queryOptions = getPortalMiddlewareGetPlanStatisticsQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanConfiguration = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/pocet/configuration`
    });
};
export const getPortalMiddlewareGetPlanConfigurationQueryKey = ()=>{
    return [
        `/pm/api/sponsor/pocet/configuration`
    ];
};
export const getPortalMiddlewareGetPlanConfigurationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanConfigurationQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanConfiguration(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanConfiguration(options) {
    const queryOptions = getPortalMiddlewareGetPlanConfigurationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPlanConfiguration = (putPlanConfigurationBodyDto)=>{
    return client({
        data: putPlanConfigurationBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/pocet/configuration`
    });
};
export const getPortalMiddlewarePutPlanConfigurationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanConfiguration(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanConfiguration = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanConfigurationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanEmployees = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/pocet/employees`
    });
};
export const getPortalMiddlewareGetPlanEmployeesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/pocet/employees`
    ];
};
export const getPortalMiddlewareGetPlanEmployeesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanEmployeesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanEmployees(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanEmployees(options) {
    const queryOptions = getPortalMiddlewareGetPlanEmployeesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanGrossCompensation = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/pocet/gross-compensation`
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationQueryKey = ()=>{
    return [
        `/pm/api/sponsor/pocet/gross-compensation`
    ];
};
export const getPortalMiddlewareGetPlanGrossCompensationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanGrossCompensationQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanGrossCompensation(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanGrossCompensation(options) {
    const queryOptions = getPortalMiddlewareGetPlanGrossCompensationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPlanEmployeeGrossCompensation = (putPlanGrossCompensationBodyDto)=>{
    return client({
        data: putPlanGrossCompensationBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/pocet/gross-compensation`
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanEmployeeGrossCompensation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanEmployeeGrossCompensation = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanEmployeeGrossCompensationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetGrossCompensationTemplate = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/pocet/gross-compensation/download/template`
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/pocet/gross-compensation/download/template`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetGrossCompensationTemplateQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGrossCompensationTemplateQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetGrossCompensationTemplate(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGrossCompensationTemplate(params, options) {
    const queryOptions = getPortalMiddlewareGetGrossCompensationTemplateQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostPlanEmployeeGrossCompensationUpload = (postPlanGrossCompensationUploadBodyDto)=>{
    return client({
        data: postPlanGrossCompensationUploadBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/pocet/gross-compensation/upload`
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostPlanEmployeeGrossCompensationUpload(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPlanEmployeeGrossCompensationUpload = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostPlanNonEmployeeOwner = (postPlanNonEmployeeOwnerBodyDto)=>{
    return client({
        data: postPlanNonEmployeeOwnerBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/pocet/non-employee-owner`
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostPlanNonEmployeeOwner(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPlanNonEmployeeOwner = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPlanNonEmployeeOwnerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanOfficers = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/pocet/officers`
    });
};
export const getPortalMiddlewareGetPlanOfficersQueryKey = ()=>{
    return [
        `/pm/api/sponsor/pocet/officers`
    ];
};
export const getPortalMiddlewareGetPlanOfficersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanOfficersQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanOfficers(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanOfficers(options) {
    const queryOptions = getPortalMiddlewareGetPlanOfficersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPlanOfficerStatus = (putPlanOfficersBodyDto)=>{
    return client({
        data: putPlanOfficersBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/pocet/officers`
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanOfficerStatus(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanOfficerStatus = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanOfficerStatusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareDeletePlanOwner = (deletePlanOwnerBodyDto)=>{
    return client({
        data: deletePlanOwnerBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'DELETE',
        url: `/pm/api/sponsor/pocet/owners`
    });
};
export const getPortalMiddlewareDeletePlanOwnerMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewareDeletePlanOwner(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewareDeletePlanOwner = (options)=>{
    const mutationOptions = getPortalMiddlewareDeletePlanOwnerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanOwners = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/pocet/owners`
    });
};
export const getPortalMiddlewareGetPlanOwnersQueryKey = ()=>{
    return [
        `/pm/api/sponsor/pocet/owners`
    ];
};
export const getPortalMiddlewareGetPlanOwnersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanOwnersQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanOwners(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanOwners(options) {
    const queryOptions = getPortalMiddlewareGetPlanOwnersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostPlanEmployeeOwner = (postPlanEmployeeOwnerBodyDto)=>{
    return client({
        data: postPlanEmployeeOwnerBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/pocet/owners`
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostPlanEmployeeOwner(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPlanEmployeeOwner = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPlanEmployeeOwnerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutPlanEmployeeOwner = (putPlanEmployeeOwnerBodyDto)=>{
    return client({
        data: putPlanEmployeeOwnerBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/pocet/owners`
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanEmployeeOwner(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanEmployeeOwner = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanEmployeeOwnerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareDeletePlanOwnersFamily = (deletePlanOwnersFamilyBodyDto)=>{
    return client({
        data: deletePlanOwnersFamilyBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'DELETE',
        url: `/pm/api/sponsor/pocet/owners-family`
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewareDeletePlanOwnersFamily(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewareDeletePlanOwnersFamily = (options)=>{
    const mutationOptions = getPortalMiddlewareDeletePlanOwnersFamilyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanOwnersFamily = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/pocet/owners-family`
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/pocet/owners-family`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlanOwnersFamilyQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanOwnersFamilyQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanOwnersFamily(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanOwnersFamily(params, options) {
    const queryOptions = getPortalMiddlewareGetPlanOwnersFamilyQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPlanOwnersFamily = (putPlanOwnersFamilyBodyDto)=>{
    return client({
        data: putPlanOwnersFamilyBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/pocet/owners-family`
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanOwnersFamily(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanOwnersFamily = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanOwnersFamilyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetTrackerDetails = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/pocet/tracker`
    });
};
export const getPortalMiddlewareGetTrackerDetailsQueryKey = ()=>{
    return [
        `/pm/api/sponsor/pocet/tracker`
    ];
};
export const getPortalMiddlewareGetTrackerDetailsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetTrackerDetailsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetTrackerDetails(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetTrackerDetails(options) {
    const queryOptions = getPortalMiddlewareGetTrackerDetailsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostPriorProvider = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/prior-provider`
    });
};
export const getPortalMiddlewarePostPriorProviderMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostPriorProvider();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPriorProvider = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPriorProviderMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPriorProviders = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/prior-providers`
    });
};
export const getPortalMiddlewareGetPriorProvidersQueryKey = ()=>{
    return [
        `/pm/api/sponsor/prior-providers`
    ];
};
export const getPortalMiddlewareGetPriorProvidersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPriorProvidersQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPriorProviders(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPriorProviders(options) {
    const queryOptions = getPortalMiddlewareGetPriorProvidersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSponsorQuestionnaire = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/questionnaire`
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireQueryKey = ()=>{
    return [
        `/pm/api/sponsor/questionnaire`
    ];
};
export const getPortalMiddlewareGetSponsorQuestionnaireQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorQuestionnaireQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorQuestionnaire(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorQuestionnaire(options) {
    const queryOptions = getPortalMiddlewareGetSponsorQuestionnaireQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchSponsorQuestionnaire = (patchSponsorQuestionnaireDto)=>{
    return client({
        data: patchSponsorQuestionnaireDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/sponsor/questionnaire`
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchSponsorQuestionnaire(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchSponsorQuestionnaire = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchSponsorQuestionnaireMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetQuestionnaireInformation = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/questionnaire-information`
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationQueryKey = ()=>{
    return [
        `/pm/api/sponsor/questionnaire-information`
    ];
};
export const getPortalMiddlewareGetQuestionnaireInformationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetQuestionnaireInformationQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetQuestionnaireInformation(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetQuestionnaireInformation(options) {
    const queryOptions = getPortalMiddlewareGetQuestionnaireInformationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetContributions = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/sponsor-plan/contributions`
    });
};
export const getPortalMiddlewareGetContributionsQueryKey = ()=>{
    return [
        `/pm/api/sponsor/sponsor-plan/contributions`
    ];
};
export const getPortalMiddlewareGetContributionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetContributions(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributions(options) {
    const queryOptions = getPortalMiddlewareGetContributionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSubaPlanDetails = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/suba-plan-details`
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/suba-plan-details`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetSubaPlanDetailsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSubaPlanDetailsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetSubaPlanDetails(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSubaPlanDetails(params, options) {
    const queryOptions = getPortalMiddlewareGetSubaPlanDetailsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSubaTransactions = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/suba-transactions`
    });
};
export const getPortalMiddlewareGetSubaTransactionsQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/suba-transactions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetSubaTransactionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSubaTransactionsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetSubaTransactions(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSubaTransactions(params, options) {
    const queryOptions = getPortalMiddlewareGetSubaTransactionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostYetCensusAutosave = (postYetCensusAutosaveBodyDto)=>{
    return client({
        data: postYetCensusAutosaveBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/census/autosave`
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostYetCensusAutosave(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostYetCensusAutosave = (options)=>{
    const mutationOptions = getPortalMiddlewarePostYetCensusAutosaveMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetYetCensusDataDownload = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/yet/census/download`
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/yet/census/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetYetCensusDataDownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYetCensusDataDownloadQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetYetCensusDataDownload(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYetCensusDataDownload(params, options) {
    const queryOptions = getPortalMiddlewareGetYetCensusDataDownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetYetCensusDataPaged = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/yet/census/paged`
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/yet/census/paged`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetYetCensusDataPagedQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYetCensusDataPagedQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetYetCensusDataPaged(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYetCensusDataPaged(params, options) {
    const queryOptions = getPortalMiddlewareGetYetCensusDataPagedQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostRefreshCensus = (postRestartCensusBodyDto)=>{
    return client({
        data: postRestartCensusBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/census/refresh`
    });
};
export const getPortalMiddlewarePostRefreshCensusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostRefreshCensus(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostRefreshCensus = (options)=>{
    const mutationOptions = getPortalMiddlewarePostRefreshCensusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostRestartCensus = (postRestartCensusBodyDto)=>{
    return client({
        data: postRestartCensusBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/census/restart`
    });
};
export const getPortalMiddlewarePostRestartCensusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostRestartCensus(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostRestartCensus = (options)=>{
    const mutationOptions = getPortalMiddlewarePostRestartCensusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostYetCensusStart = (yetCensusBodyDto)=>{
    return client({
        data: yetCensusBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/census/start`
    });
};
export const getPortalMiddlewarePostYetCensusStartMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostYetCensusStart(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostYetCensusStart = (options)=>{
    const mutationOptions = getPortalMiddlewarePostYetCensusStartMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetCensusStatus = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/yet/census/status`
    });
};
export const getPortalMiddlewareGetCensusStatusQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/yet/census/status`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetCensusStatusQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetCensusStatusQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetCensusStatus(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetCensusStatus(params, options) {
    const queryOptions = getPortalMiddlewareGetCensusStatusQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostYetCensusSubmit = (yetCensusBodyDto)=>{
    return client({
        data: yetCensusBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/census/submit`
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostYetCensusSubmit(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostYetCensusSubmit = (options)=>{
    const mutationOptions = getPortalMiddlewarePostYetCensusSubmitMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostYetCensusUpload = (postYetCensusUploadBodyDto)=>{
    return client({
        data: postYetCensusUploadBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/census/upload`
    });
};
export const getPortalMiddlewarePostYetCensusUploadMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostYetCensusUpload(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostYetCensusUpload = (options)=>{
    const mutationOptions = getPortalMiddlewarePostYetCensusUploadMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetYetChecklist = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/yet/checklist`
    });
};
export const getPortalMiddlewareGetYetChecklistQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/yet/checklist`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetYetChecklistQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYetChecklistQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetYetChecklist(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYetChecklist(params, options) {
    const queryOptions = getPortalMiddlewareGetYetChecklistQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchYetChecklist = (patchYetChecklistBodyDto)=>{
    return client({
        data: patchYetChecklistBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/sponsor/yet/checklist`
    });
};
export const getPortalMiddlewarePatchYetChecklistMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchYetChecklist(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchYetChecklist = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchYetChecklistMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetYetConfig = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/yet/config`
    });
};
export const getPortalMiddlewareGetYetConfigQueryKey = ()=>{
    return [
        `/pm/api/sponsor/yet/config`
    ];
};
export const getPortalMiddlewareGetYetConfigQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYetConfigQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetYetConfig(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYetConfig(options) {
    const queryOptions = getPortalMiddlewareGetYetConfigQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostContributionsFund = (yetDocumentIdBodyDto)=>{
    return client({
        data: yetDocumentIdBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/contributions/fund`
    });
};
export const getPortalMiddlewarePostContributionsFundMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostContributionsFund(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostContributionsFund = (options)=>{
    const mutationOptions = getPortalMiddlewarePostContributionsFundMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostContributionsRefund = (yetDocumentIdBodyDto)=>{
    return client({
        data: yetDocumentIdBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/contributions/refund`
    });
};
export const getPortalMiddlewarePostContributionsRefundMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostContributionsRefund(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostContributionsRefund = (options)=>{
    const mutationOptions = getPortalMiddlewarePostContributionsRefundMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetYetDocuments = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/yet/documents`
    });
};
export const getPortalMiddlewareGetYetDocumentsQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/yet/documents`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetYetDocumentsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYetDocumentsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetYetDocuments(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYetDocuments(params, options) {
    const queryOptions = getPortalMiddlewareGetYetDocumentsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostStartOfPackaging = (getYetChecklistQueryDto)=>{
    return client({
        data: getYetChecklistQueryDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/packaging/start`
    });
};
export const getPortalMiddlewarePostStartOfPackagingMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostStartOfPackaging(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostStartOfPackaging = (options)=>{
    const mutationOptions = getPortalMiddlewarePostStartOfPackagingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanTestResults = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/yet/plan-test-results`
    });
};
export const getPortalMiddlewareGetPlanTestResultsQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/yet/plan-test-results`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlanTestResultsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanTestResultsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanTestResults(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanTestResults(params, options) {
    const queryOptions = getPortalMiddlewareGetPlanTestResultsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetYetSponsorQuestionnaire = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/yet/questionnaire`
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/yet/questionnaire`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYetSponsorQuestionnaireQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetYetSponsorQuestionnaire(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYetSponsorQuestionnaire(params, options) {
    const queryOptions = getPortalMiddlewareGetYetSponsorQuestionnaireQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostYetSponsorQuestionnaire = (postYetQuestionnaireDto)=>{
    return client({
        data: postYetQuestionnaireDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/questionnaire`
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostYetSponsorQuestionnaire(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostYetSponsorQuestionnaire = (options)=>{
    const mutationOptions = getPortalMiddlewarePostYetSponsorQuestionnaireMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostRestartTestingProcess = (postRestartTestingProcessBodyDto)=>{
    return client({
        data: postRestartTestingProcessBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/restart`
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostRestartTestingProcess(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostRestartTestingProcess = (options)=>{
    const mutationOptions = getPortalMiddlewarePostRestartTestingProcessMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetYetStatus = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/yet/status`
    });
};
export const getPortalMiddlewareGetYetStatusQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/yet/status`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetYetStatusQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYetStatusQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetYetStatus(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYetStatus(params, options) {
    const queryOptions = getPortalMiddlewareGetYetStatusQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetYtdContributions = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/ytd-contributions`
    });
};
export const getPortalMiddlewareGetYtdContributionsQueryKey = ()=>{
    return [
        `/pm/api/sponsor/ytd-contributions`
    ];
};
export const getPortalMiddlewareGetYtdContributionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYtdContributionsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetYtdContributions(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYtdContributions(options) {
    const queryOptions = getPortalMiddlewareGetYtdContributionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetTiaaIncomeProjection = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/tiaa/income-projection`
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionQueryKey = ()=>{
    return [
        `/pm/api/tiaa/income-projection`
    ];
};
export const getPortalMiddlewareGetTiaaIncomeProjectionQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetTiaaIncomeProjectionQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetTiaaIncomeProjection(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetTiaaIncomeProjection(options) {
    const queryOptions = getPortalMiddlewareGetTiaaIncomeProjectionQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchParticipantById = (patchParticipantBodyDto, params)=>{
    return client({
        data: patchParticipantBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        params,
        url: `/pm/api/v2/participant`
    });
};
export const getPortalMiddlewarePatchParticipantByIdMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data, params } = props ?? {};
        return portalMiddlewarePatchParticipantById(data, params);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchParticipantById = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchParticipantByIdMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantBeneficiaries = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/v2/participant/beneficiaries`
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesQueryKey = (params)=>{
    return [
        `/pm/api/v2/participant/beneficiaries`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantBeneficiariesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantBeneficiariesQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantBeneficiaries(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantBeneficiaries(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantBeneficiariesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutParticipantBeneficiariesV2 = (portalMiddlewarePutParticipantBeneficiariesV2Body)=>{
    return client({
        data: portalMiddlewarePutParticipantBeneficiariesV2Body,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/v2/participant/beneficiaries`
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutParticipantBeneficiariesV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutParticipantBeneficiariesV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePutParticipantBeneficiariesV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanByIdV2 = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/v2/plans`
    });
};
export const getPortalMiddlewareGetPlanByIdV2QueryKey = (params)=>{
    return [
        `/pm/api/v2/plans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlanByIdV2QueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanByIdV2QueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanByIdV2(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanByIdV2(params, options) {
    const queryOptions = getPortalMiddlewareGetPlanByIdV2QueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetVssPlanById = (planId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/vss/plans/${planId}`
    });
};
export const getPortalMiddlewareGetVssPlanByIdQueryKey = (planId)=>{
    return [
        `/pm/api/vss/plans/${planId}`
    ];
};
export const getPortalMiddlewareGetVssPlanByIdQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetVssPlanByIdQueryKey(planId);
    const queryFn = ({ signal })=>portalMiddlewareGetVssPlanById(planId, signal);
    return {
        enabled: !!planId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetVssPlanById(planId, options) {
    const queryOptions = getPortalMiddlewareGetVssPlanByIdQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetVssStatus = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/vss/status`
    });
};
export const getPortalMiddlewareGetVssStatusQueryKey = ()=>{
    return [
        `/pm/api/vss/status`
    ];
};
export const getPortalMiddlewareGetVssStatusQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetVssStatusQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetVssStatus(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetVssStatus(options) {
    const queryOptions = getPortalMiddlewareGetVssStatusQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostLobLetterEventsWebhook = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/webhooks/lob/letter-events`
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostLobLetterEventsWebhook();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostLobLetterEventsWebhook = (options)=>{
    const mutationOptions = getPortalMiddlewarePostLobLetterEventsWebhookMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetWhiteLabel = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/whitelabel`
    });
};
export const getPortalMiddlewareGetWhiteLabelQueryKey = ()=>{
    return [
        `/pm/api/whitelabel`
    ];
};
export const getPortalMiddlewareGetWhiteLabelQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetWhiteLabelQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetWhiteLabel(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetWhiteLabel(options) {
    const queryOptions = getPortalMiddlewareGetWhiteLabelQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetWhiteLabelUnauthorized = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/whitelabel/unauthorized`
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedQueryKey = ()=>{
    return [
        `/pm/api/whitelabel/unauthorized`
    ];
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetWhiteLabelUnauthorizedQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetWhiteLabelUnauthorized(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetWhiteLabelUnauthorized(options) {
    const queryOptions = getPortalMiddlewareGetWhiteLabelUnauthorizedQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostCreateWithdrawal = (postWithdrawalBodyDto)=>{
    return client({
        data: postWithdrawalBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/withdrawal`
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostCreateWithdrawal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostCreateWithdrawal = (options)=>{
    const mutationOptions = getPortalMiddlewarePostCreateWithdrawalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetRmdAmount = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/withdrawal/rmd-amount`
    });
};
export const getPortalMiddlewareGetRmdAmountQueryKey = (params)=>{
    return [
        `/pm/api/withdrawal/rmd-amount`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetRmdAmountQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRmdAmountQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetRmdAmount(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRmdAmount(params, options) {
    const queryOptions = getPortalMiddlewareGetRmdAmountQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetRmdBalance = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/withdrawal/rmd-balance`
    });
};
export const getPortalMiddlewareGetRmdBalanceQueryKey = (params)=>{
    return [
        `/pm/api/withdrawal/rmd-balance`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetRmdBalanceQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRmdBalanceQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetRmdBalance(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRmdBalance(params, options) {
    const queryOptions = getPortalMiddlewareGetRmdBalanceQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetRolloverProviders = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/withdrawal/rollover-providers`
    });
};
export const getPortalMiddlewareGetRolloverProvidersQueryKey = ()=>{
    return [
        `/pm/api/withdrawal/rollover-providers`
    ];
};
export const getPortalMiddlewareGetRolloverProvidersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRolloverProvidersQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetRolloverProviders(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRolloverProviders(options) {
    const queryOptions = getPortalMiddlewareGetRolloverProvidersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetWithholding = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/withdrawal/withholding`
    });
};
export const getPortalMiddlewareGetWithholdingQueryKey = (params)=>{
    return [
        `/pm/api/withdrawal/withholding`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetWithholdingQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetWithholdingQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetWithholding(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetWithholding(params, options) {
    const queryOptions = getPortalMiddlewareGetWithholdingQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetWithholdingDetail = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/withdrawal/withholding/total-estimate`
    });
};
export const getPortalMiddlewareGetWithholdingDetailQueryKey = (params)=>{
    return [
        `/pm/api/withdrawal/withholding/total-estimate`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetWithholdingDetailQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetWithholdingDetailQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetWithholdingDetail(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetWithholdingDetail(params, options) {
    const queryOptions = getPortalMiddlewareGetWithholdingDetailQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetYetNaics = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/yet/naics`
    });
};
export const getPortalMiddlewareGetYetNaicsQueryKey = ()=>{
    return [
        `/pm/api/yet/naics`
    ];
};
export const getPortalMiddlewareGetYetNaicsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYetNaicsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetYetNaics(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYetNaics(options) {
    const queryOptions = getPortalMiddlewareGetYetNaicsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetZendeskJwt = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/zendesk/jwt`
    });
};
export const getPortalMiddlewareGetZendeskJwtQueryKey = ()=>{
    return [
        `/pm/api/zendesk/jwt`
    ];
};
export const getPortalMiddlewareGetZendeskJwtQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetZendeskJwtQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetZendeskJwt(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetZendeskJwt(options) {
    const queryOptions = getPortalMiddlewareGetZendeskJwtQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEntitySession = (entity, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/${entity}/session`
    });
};
export const getPortalMiddlewareGetEntitySessionQueryKey = (entity)=>{
    return [
        `/pm/api/${entity}/session`
    ];
};
export const getPortalMiddlewareGetEntitySessionQueryOptions = (entity, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEntitySessionQueryKey(entity);
    const queryFn = ({ signal })=>portalMiddlewareGetEntitySession(entity, signal);
    return {
        enabled: !!entity,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEntitySession(entity, options) {
    const queryOptions = getPortalMiddlewareGetEntitySessionQueryOptions(entity, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const healthGetPublicRoute = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/public`
    });
};
export const getHealthGetPublicRouteQueryKey = ()=>{
    return [
        `/public`
    ];
};
export const getHealthGetPublicRouteQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getHealthGetPublicRouteQueryKey();
    const queryFn = ({ signal })=>healthGetPublicRoute(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useHealthGetPublicRoute(options) {
    const queryOptions = getHealthGetPublicRouteQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthGetConnectivity = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/wt/connectivity`
    });
};
export const getWentworthGetConnectivityQueryKey = ()=>{
    return [
        `/wt/connectivity`
    ];
};
export const getWentworthGetConnectivityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthGetConnectivityQueryKey();
    const queryFn = ({ signal })=>wentworthGetConnectivity(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthGetConnectivity(options) {
    const queryOptions = getWentworthGetConnectivityQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthPostDemoSdk = (demoReqDto)=>{
    return client({
        data: demoReqDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/wt/demo-sdk`
    });
};
export const getWentworthPostDemoSdkMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return wentworthPostDemoSdk(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useWentworthPostDemoSdk = (options)=>{
    const mutationOptions = getWentworthPostDemoSdkMutationOptions(options);
    return useMutation(mutationOptions);
};
export const wentworthGetHealth = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/wt/health`
    });
};
export const getWentworthGetHealthQueryKey = ()=>{
    return [
        `/wt/health`
    ];
};
export const getWentworthGetHealthQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthGetHealthQueryKey();
    const queryFn = ({ signal })=>wentworthGetHealth(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthGetHealth(options) {
    const queryOptions = getWentworthGetHealthQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getHealthGetConnectivityResponseMock = (overrideResponse = {})=>({
        details: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        error: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        info: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        status: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock = (overrideResponse = {})=>({
        active: faker.datatype.boolean(),
        aud: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        client_id: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        exp: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        iat: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        iss: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        jti: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        nbf: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        scope: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sub: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        token_type: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        username: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock = (overrideResponse = {})=>({
        demo: faker.datatype.boolean(),
        name: faker.word.sample(),
        nestedProp: {
            nested: faker.datatype.boolean()
        },
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            docusignEnvelopeId: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            signedAt: faker.word.sample(),
            sponsorPlanId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            status: faker.helpers.arrayElement([
                'pending',
                'void',
                'signed'
            ]),
            type: faker.word.sample()
        }));
export const getOnboardingDocusignGetEnvelopesResponseMock = (overrideResponse = {})=>({
        endPosition: faker.word.sample(),
        envelopes: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                allowMarkup: faker.word.sample(),
                allowReassign: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowViewHistory: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                anySigner: faker.word.sample(),
                attachmentsUri: faker.word.sample(),
                autoNavigation: faker.word.sample(),
                burnDefaultTabData: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                certificateUri: faker.word.sample(),
                createdDateTime: faker.word.sample(),
                customFieldsUri: faker.word.sample(),
                deliveredDateTime: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                documentsCombinedUri: faker.word.sample(),
                documentsUri: faker.word.sample(),
                emailSubject: faker.word.sample(),
                enableWetSign: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                envelopeId: faker.word.sample(),
                envelopeIdStamping: faker.word.sample(),
                envelopeLocation: faker.word.sample(),
                envelopeMetadata: faker.helpers.arrayElement([
                    {
                        allowAdvancedCorrect: faker.word.sample(),
                        allowCorrect: faker.word.sample(),
                        enableSignWithNotary: faker.word.sample()
                    },
                    undefined
                ]),
                envelopeUri: faker.word.sample(),
                expireAfter: faker.word.sample(),
                expireDateTime: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expireEnabled: faker.word.sample(),
                hasFormDataChanged: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                initialSentDateTime: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                is21CFRPart11: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isDynamicEnvelope: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isSignatureProviderEnvelope: faker.word.sample(),
                lastModifiedDateTime: faker.word.sample(),
                notificationUri: faker.word.sample(),
                purgeState: faker.word.sample(),
                recipientsUri: faker.word.sample(),
                sender: {
                    accountId: faker.word.sample(),
                    email: faker.word.sample(),
                    ipAddress: faker.word.sample(),
                    userId: faker.word.sample(),
                    userName: faker.word.sample()
                },
                sentDateTime: faker.word.sample(),
                signerCanSignOnMobile: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                signingLocation: faker.word.sample(),
                status: faker.word.sample(),
                statusChangedDateTime: faker.word.sample(),
                templatesUri: faker.word.sample(),
                uSigState: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                useDisclosure: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            })),
        nextUri: faker.word.sample(),
        previousUri: faker.word.sample(),
        resultSetSize: faker.word.sample(),
        startPosition: faker.word.sample(),
        totalSetSize: faker.word.sample(),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock = (overrideResponse = {})=>({
        allowMarkup: faker.word.sample(),
        allowReassign: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        allowViewHistory: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        anySigner: faker.word.sample(),
        attachmentsUri: faker.word.sample(),
        autoNavigation: faker.word.sample(),
        burnDefaultTabData: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        certificateUri: faker.word.sample(),
        createdDateTime: faker.word.sample(),
        customFieldsUri: faker.word.sample(),
        deliveredDateTime: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        documentsCombinedUri: faker.word.sample(),
        documentsUri: faker.word.sample(),
        emailSubject: faker.word.sample(),
        enableWetSign: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        envelopeId: faker.word.sample(),
        envelopeIdStamping: faker.word.sample(),
        envelopeLocation: faker.word.sample(),
        envelopeMetadata: faker.helpers.arrayElement([
            {
                allowAdvancedCorrect: faker.word.sample(),
                allowCorrect: faker.word.sample(),
                enableSignWithNotary: faker.word.sample()
            },
            undefined
        ]),
        envelopeUri: faker.word.sample(),
        expireAfter: faker.word.sample(),
        expireDateTime: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        expireEnabled: faker.word.sample(),
        hasFormDataChanged: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        initialSentDateTime: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        is21CFRPart11: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isDynamicEnvelope: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isSignatureProviderEnvelope: faker.word.sample(),
        lastModifiedDateTime: faker.word.sample(),
        notificationUri: faker.word.sample(),
        purgeState: faker.word.sample(),
        recipientsUri: faker.word.sample(),
        sender: {
            accountId: faker.word.sample(),
            email: faker.word.sample(),
            ipAddress: faker.word.sample(),
            userId: faker.word.sample(),
            userName: faker.word.sample()
        },
        sentDateTime: faker.word.sample(),
        signerCanSignOnMobile: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        signingLocation: faker.word.sample(),
        status: faker.word.sample(),
        statusChangedDateTime: faker.word.sample(),
        templatesUri: faker.word.sample(),
        uSigState: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        useDisclosure: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            clientUserId: faker.word.sample(),
            completedCount: faker.word.sample(),
            creationReason: faker.word.sample(),
            deliveredDateTime: faker.word.sample(),
            deliveryMethod: faker.word.sample(),
            email: faker.word.sample(),
            firstName: faker.word.sample(),
            isBulkRecipient: faker.word.sample(),
            lastName: faker.word.sample(),
            name: faker.word.sample(),
            note: faker.word.sample(),
            recipientId: faker.word.sample(),
            recipientIdGuid: faker.word.sample(),
            recipientType: faker.word.sample(),
            requireIdLookup: faker.word.sample(),
            requireUploadSignature: faker.word.sample(),
            roleName: faker.word.sample(),
            routingOrder: faker.word.sample(),
            sentDateTime: faker.word.sample(),
            signInEachLocation: faker.word.sample(),
            signatureInfo: {
                fontStyle: faker.word.sample(),
                signatureInitials: faker.word.sample(),
                signatureName: faker.word.sample()
            },
            status: faker.word.sample(),
            templateRequired: faker.word.sample(),
            userId: faker.word.sample()
        }));
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock = (overrideResponse = {})=>({
        url: faker.word.sample(),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock = (overrideResponse = {})=>({
        access_token: faker.word.sample(),
        expires_in: faker.number.int({
            max: undefined,
            min: undefined
        }),
        token_type: faker.word.sample(),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock = (overrideResponse = {})=>({
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock = (overrideResponse = {})=>({
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.word.sample(),
        firmId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        firstName: faker.word.sample(),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        lastName: faker.word.sample(),
        phone: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            commercialPlatformId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            navbar: faker.helpers.arrayElement([
                {
                    logo: {
                        desktop: faker.word.sample(),
                        mobile: faker.word.sample()
                    }
                },
                undefined
            ]),
            numberOfSponsorPlans: faker.number.int({
                max: undefined,
                min: undefined
            }),
            stats: {
                totalBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            subdomain: faker.word.sample()
        }));
export const getPortalMiddlewareGetAdvisorContactCardResponseMock = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        displayName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        image: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isEnabled: faker.datatype.boolean(),
        note: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        displayName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        image: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isEnabled: faker.datatype.boolean(),
        note: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                attributes: {
                    effectiveDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    eligibleParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    employeeBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    employerBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    forfeitureBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    hasPriorLoans: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    inboundBlackoutEndDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    inboundBlackoutStartDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isActive: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    isBlackout: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    isOffboardingBlackoutActive: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    loanBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    name: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    offboardingBlackoutEndDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    offboardingBlackoutStartDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    participantsWithBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    participantsWithDeferrals: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    readyToEnrollParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    recordkeeper: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    registeredParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    rolloverBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    sponsorCompanyName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    statefulSchemaTrackingState: faker.helpers.arrayElement([
                        {
                            attributes: faker.helpers.arrayElement([
                                {
                                    createdAt: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    status: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    updatedAt: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    status: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    totalBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    type: faker.helpers.arrayElement([
                        {},
                        undefined
                    ])
                },
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                relationships: {
                    advisor: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    firm: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    program: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    sponsor: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    tpa: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                data: faker.helpers.arrayElement([
                                    {
                                        id: faker.helpers.arrayElement([
                                            faker.number.int({
                                                max: undefined,
                                                min: undefined
                                            }),
                                            undefined
                                        ]),
                                        name: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        type: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    },
                                    undefined
                                ])
                            })),
                        undefined
                    ])
                }
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                hasNoOfficers: faker.datatype.boolean(),
                hasNoOwners: faker.datatype.boolean(),
                name: faker.word.sample(),
                officersCompleted: faker.datatype.boolean(),
                ownersCompleted: faker.datatype.boolean(),
                packagingCompleted: faker.datatype.boolean(),
                planName: faker.word.sample(),
                processEvents: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        createdAt: faker.word.sample(),
                        eventName: faker.word.sample(),
                        processEventId: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    })),
                processId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                questionnaireCompleted: faker.datatype.boolean(),
                sponsorPlanId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                sponsorYearEndChecklistId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                year: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                yearEndCensusCompleted: faker.datatype.boolean()
            })),
        meta: {
            count: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                attributes: faker.helpers.arrayElement([
                    {
                        accountBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        cashBalanceInterestRate: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        contributingAvgDeferralRatePct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsEmployee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsEmployer: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsLoan: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsRollover: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        eligibleParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        eligibleParticipantsWithBeneficiary: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        eligiblesAvgDeferralRatePct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        employedParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        modelAgeDistributions: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    ageRange: faker.helpers.arrayElement([
                                        {},
                                        undefined
                                    ]),
                                    balance: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    modelId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    modelName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    modelType: faker.helpers.arrayElement([
                                        {},
                                        undefined
                                    ]),
                                    participantsInModel: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        modelDistributions: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    balance: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    factsheet: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    modelId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    modelName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    modelType: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    participantsInModel: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    viewName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        mostRecentEmployeeContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        mostRecentEmployerContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        mostRecentLoanContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        nextPayrollDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        participantsWithBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        participantsWithBeneficiary: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        participantsWithDeferrals: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        participationRate: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        readyToEnrollParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        registeredParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        terminatedParticipantsWithBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        totalContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        totalParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        totalPlanMarketValue: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                type: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock = (overrideResponse = {})=>({
        eligibleParticipants: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participantsWithBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participantsWithDeferrals: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalPlans: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock = (overrideResponse = {})=>({
        esaItems: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    alt: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    path: faker.word.sample(),
                    pdf: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        items: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    alt: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    path: faker.word.sample(),
                    pdf: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock = (overrideResponse = {})=>({
        createdAt: faker.word.sample(),
        csmId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        name: faker.word.sample(),
        phoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock = (overrideResponse = {})=>({
        document: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock = (overrideResponse = {})=>({
        isAccepted: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            documentKey: faker.word.sample(),
            entity: faker.word.sample(),
            entityId: faker.word.sample(),
            etag: faker.word.sample(),
            groupDetails: faker.helpers.arrayElement([
                {
                    effectiveDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    groupId: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    id: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    uploadHistoryId: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                undefined
            ]),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            isDraft: faker.datatype.boolean(),
            isEnabled: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            originalFileName: faker.word.sample(),
            uploadPath: faker.word.sample()
        }));
export const getPortalMiddlewareGetDocumentAgreementResponseMock = (overrideResponse = {})=>({
        date: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isAccepted: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock = (overrideResponse = {})=>({
        document: faker.word.sample(),
        documentId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        originalFileName: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPortalMiddlewarePostPdfResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPortalMiddlewarePostProcessDocumentResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({})),
        headers: {},
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            assetAllocations: {
                bondNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                cashNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                otherNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                stockNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            assetClass: faker.word.sample(),
            balance: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            broadCategory: faker.word.sample(),
            category: faker.word.sample(),
            cusip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expenseRatioPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            fiveYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            fiveYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            id: faker.word.sample(),
            inceptionDate: faker.word.sample(),
            itdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            itdPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            oneYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            oneYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            performanceUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityType: faker.word.sample(),
            securityTypeName: faker.word.sample(),
            shareClass: faker.word.sample(),
            shares: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            tenYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            tenYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            weightPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ytdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ytdPct: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetEmployeeLoansResponseMock = (overrideResponse = {})=>({
        balanceOverview: faker.helpers.arrayElement([
            {
                loanAmountAvailable: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                loanOutstandingBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                sdbaBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                totalAccountBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                totalVestedBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            undefined
        ]),
        eligibilityStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        hasAccess: faker.datatype.boolean(),
        hasPendingWithdrawal: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        hasSdbaTransfersOut: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isAddressFraudRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isBlackout: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isEmailFraudRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isFraudRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isLoansAllowed: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        loanPreferences: faker.helpers.arrayElement([
            {
                attributes: faker.helpers.arrayElement([
                    {
                        allowedLoanPurposes: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({})),
                            undefined
                        ]),
                        allowedPayFrequencies: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({})),
                            undefined
                        ]),
                        maintenanceFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        maxOutstandingLoans: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        maxYearsResidencePurchase: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        originationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        overnightCheckFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        wireFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                relationships: faker.helpers.arrayElement([
                    {
                        plan: faker.helpers.arrayElement([
                            {
                                data: faker.helpers.arrayElement([
                                    {
                                        id: faker.helpers.arrayElement([
                                            faker.number.int({
                                                max: undefined,
                                                min: undefined
                                            }),
                                            undefined
                                        ]),
                                        type: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    },
                                    undefined
                                ])
                            },
                            undefined
                        ])
                    },
                    undefined
                ]),
                type: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        loanSummaries: faker.helpers.arrayElement([
            {
                fromAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fromCreatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                fromOutstandingBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fromStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                pageNumber: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                pageSize: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                'participant-id': faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                'plan-id': faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                sort: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                statuses: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                toAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                toCreatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                toOutstandingBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                toStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        planStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        recordkeeper: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            assetAllocations: {
                bondNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                cashNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                otherNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                stockNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            assetClass: faker.word.sample(),
            broadCategory: faker.word.sample(),
            category: faker.word.sample(),
            cusip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expenseRatioPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            fiveYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            fiveYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            id: faker.word.sample(),
            inceptionDate: faker.word.sample(),
            itdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            itdPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            oneYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            oneYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            performanceUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityType: faker.word.sample(),
            securityTypeName: faker.word.sample(),
            shareClass: faker.word.sample(),
            targetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tenYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            tenYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            weightPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ytdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ytdPct: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock = (overrideResponse = {})=>({
        loan: {
            bankAccountInfo: faker.helpers.arrayElement([
                {
                    accountNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    routingNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            deliveryAddress: faker.helpers.arrayElement([
                {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                undefined
            ]),
            deliveryMethod: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            interestRate: faker.number.int({
                max: undefined,
                min: undefined
            }),
            isConversion: faker.datatype.boolean(),
            isSignedAgreement: faker.datatype.boolean(),
            loanAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            loanExpectedPayment: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    dueDate: faker.word.sample(),
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    interest: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    interestPaid: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    latestPaymentDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    loanId: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    paymentSequenceNumber: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    paymentStatus: faker.word.sample(),
                    principal: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    principalPaid: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    total: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    updatedAt: faker.word.sample()
                })),
            loanPurpose: faker.word.sample(),
            loanStatus: faker.word.sample(),
            maintenanceFee: faker.number.int({
                max: undefined,
                min: undefined
            }),
            nextPaymentDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            originationFee: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            outstandingPrincipalDue: faker.number.int({
                max: undefined,
                min: undefined
            }),
            overdueInterest: faker.number.int({
                max: undefined,
                min: undefined
            }),
            paymentFrequency: faker.word.sample(),
            promissoryNoteAcceptanceDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            purchaseSaleAgreementUploaded: faker.datatype.boolean(),
            remainingPaymentsCount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            repaymentYears: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        loanPreferences: {
            allowLoans: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            allowResidencePurchaseExtension: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasPriorLoans: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            maintenanceFee: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            maxOutstandingLoans: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            maxYearsResidencePurchase: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            originationFee: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            overnightCheckFee: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            wireFee: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        plan: {
            isBlackout: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            recordkeeper: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        sponsor: {
            activationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyEntityType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyPhoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dayToDayContactLastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            doingBusinessAs: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ein: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            fiscalYearEnd: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hasOtherBusinesses: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isPartOfControlGroup: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            mailingAddress: faker.helpers.arrayElement([
                {
                    address1: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    zip: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            physicalAddress: faker.helpers.arrayElement([
                {
                    address1: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    zip: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            primaryContact: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    firstName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    lastName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    role: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            stateOfIncorporation: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            wiredAtWork: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            goalAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            priority: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        }));
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock = (overrideResponse = {})=>({
        employerMatch: {
            dollarCap: faker.number.int({
                max: undefined,
                min: undefined
            }),
            lifetimeCap: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        initialBonusAmount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        initialBonusMinimum: faker.number.int({
            max: undefined,
            min: undefined
        }),
        milestoneBonus: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                bonusAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                bonusThreshold: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            cashInterestProgramId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            effectiveStartDate: faker.word.sample(),
            rate: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            balance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            dateOf: faker.word.sample()
        }));
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock = (overrideResponse = {})=>({
        averageSavingsRateDollars: faker.number.int({
            max: undefined,
            min: undefined
        }),
        averageSavingsRatePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participantsAccessingSavings: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participatingParticipantsNumber: faker.number.int({
            max: undefined,
            min: undefined
        }),
        savingsRateDollarsParticipantsCount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        savingsRatePctParticipantsCount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalParticipantsNumber: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            description: faker.word.sample(),
            groupId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            initialBonus: faker.number.int({
                max: undefined,
                min: undefined
            }),
            initialBonusThreshold: faker.number.int({
                max: undefined,
                min: undefined
            }),
            match: {
                dollarAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                lifetimeAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                percent: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            milestoneBonus: {
                amount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                threshold: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            name: faker.word.sample(),
            participantCount: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            allowInitialBonus: faker.datatype.boolean(),
            allowMatch: faker.datatype.boolean(),
            allowMilestoneBonus: faker.datatype.boolean(),
            bonusAmount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            bonusThreshold: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            dollarCap: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            employeeGroupId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            initialBonusAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            initialBonusMinimum: faker.number.int({
                max: undefined,
                min: undefined
            }),
            lifetimeCap: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        }));
export const getPortalMiddlewareGetFeatureTogglesResponseMock = ()=>({
        [faker.string.alphanumeric(5)]: faker.datatype.boolean()
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            isExperiment: faker.datatype.boolean(),
            name: faker.word.sample(),
            variation: faker.helpers.arrayElement([
                {
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    name: faker.word.sample()
                },
                undefined
            ])
        }));
export const getPortalMiddlewareGetFirmByIdResponseMock = (overrideResponse = {})=>({
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contactName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        firmId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        firmType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        website: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.word.sample(),
                amount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                bankAccountId: faker.word.sample(),
                correlationId: faker.word.sample(),
                customerId: faker.word.sample(),
                eventTriggerType: faker.word.sample(),
                frequency: faker.helpers.arrayElement([
                    faker.helpers.arrayElement([
                        'monthly',
                        'biMonthly',
                        'yearly'
                    ]),
                    undefined
                ]),
                id: faker.word.sample(),
                isDeactivated: faker.datatype.boolean(),
                isPaused: faker.datatype.boolean(),
                parameters: {
                    from: faker.word.sample(),
                    giftAccountId: faker.word.sample(),
                    giftBankAccountId: faker.word.sample(),
                    giftContributorId: faker.word.sample(),
                    isAnonymous: faker.datatype.boolean(),
                    occasion: faker.helpers.arrayElement([
                        'birthday',
                        'just-because',
                        'holiday',
                        'congratulations',
                        'graduation',
                        'get-well'
                    ])
                },
                planId: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.word.sample(),
                bankAccountNumber: faker.word.sample(),
                bankAccountType: faker.helpers.arrayElement([
                    'checking',
                    'savings',
                    'prepaid'
                ]),
                bankName: faker.word.sample(),
                createdDate: faker.word.sample(),
                customerId: faker.word.sample(),
                deleted: faker.datatype.boolean(),
                giftContributorId: faker.word.sample(),
                id: faker.word.sample(),
                lastUpdated: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                payInstructionId: faker.word.sample(),
                routingNumber: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                active: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                createdDate: faker.word.sample(),
                disbursementId: faker.word.sample(),
                feeAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                from: faker.word.sample(),
                giftAccountId: faker.word.sample(),
                giftBankId: faker.word.sample(),
                giftContributorEmail: faker.word.sample(),
                giftContributorId: faker.word.sample(),
                giftContributorPhone: faker.word.sample(),
                giftTransactionId: faker.word.sample(),
                grossAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.word.sample(),
                isAnonymous: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                lastUpdated: faker.word.sample(),
                netAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                occasion: {
                    id: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    name: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                postedDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                recurringContributionsId: faker.word.sample(),
                theme: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                deleted: faker.datatype.boolean(),
                encodedAccountId: faker.word.sample(),
                giftAccount: {
                    accountPublic: {
                        contributionHold: faker.datatype.boolean(),
                        firstName: faker.word.sample(),
                        goalPercentage: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        isActive: faker.datatype.boolean(),
                        planId: faker.word.sample(),
                        title: faker.word.sample()
                    },
                    giftAccount: {
                        accountId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        active: faker.datatype.boolean(),
                        assetId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        canAcceptMoreGifts: faker.datatype.boolean(),
                        contributions: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        deleted: faker.datatype.boolean(),
                        goalPercentage: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        hideGoal: faker.datatype.boolean(),
                        id: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        modeAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        pendingContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        pendingContributionCount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        planId: faker.word.sample(),
                        remainingBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        shareUrl: faker.word.sample()
                    }
                },
                giftAccountId: faker.word.sample(),
                giftContributorId: faker.word.sample(),
                id: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock = (overrideResponse = {})=>({
        data: {
            accountPublic: {
                contributionHold: faker.datatype.boolean(),
                firstName: faker.word.sample(),
                goalPercentage: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                isActive: faker.datatype.boolean(),
                planId: faker.word.sample(),
                title: faker.word.sample()
            },
            giftAccount: {
                accountId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                active: faker.datatype.boolean(),
                assetId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                canAcceptMoreGifts: faker.datatype.boolean(),
                contributions: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                deleted: faker.datatype.boolean(),
                goalPercentage: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                hideGoal: faker.datatype.boolean(),
                id: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modeAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                pendingContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                pendingContributionCount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                planId: faker.word.sample(),
                remainingBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                shareUrl: faker.word.sample()
            }
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock = (overrideResponse = {})=>({
        data: {
            accountId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            active: faker.datatype.boolean(),
            assetId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            canAcceptMoreGifts: faker.datatype.boolean(),
            contributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            deleted: faker.datatype.boolean(),
            goalPercentage: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            hideGoal: faker.datatype.boolean(),
            id: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            modeAmount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            pendingContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            pendingContributionCount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            planId: faker.word.sample(),
            remainingBalance: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            shareUrl: faker.word.sample()
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock = (overrideResponse = {})=>({
        data: faker.word.sample(),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock = (overrideResponse = {})=>({
        data: faker.word.sample(),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock = (overrideResponse = {})=>({
        data: {},
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock = (overrideResponse = {})=>({
        data: {},
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock = (overrideResponse = {})=>({
        linkToken: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            availableBalance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            currentBalance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            institutionId: faker.word.sample(),
            itemId: faker.word.sample(),
            plaidAccountId: faker.word.sample(),
            plaidAccountSubtype: faker.word.sample(),
            plaidAccountType: faker.word.sample()
        }));
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock = (overrideResponse = {})=>({
        riskTolerance: faker.helpers.arrayElement([
            'aggressive',
            'conservative',
            'moderate'
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock = (overrideResponse = {})=>({
        targetAllocations: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                morningStarId: faker.word.sample(),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                percentageAllocation: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                weightPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock = (overrideResponse = {})=>({
        deactivateStatus: faker.word.sample(),
        failureReason: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock = (overrideResponse = {})=>({
        currentAge: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isActivated: faker.datatype.boolean(),
        lastUpdated: faker.word.sample(),
        retirementAge: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        riskTolerance: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'aggressive',
                'conservative',
                'moderate'
            ]),
            undefined
        ]),
        targetAllocations: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                morningStarId: faker.word.sample(),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                percentageAllocation: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                weightPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock = (overrideResponse = {})=>({
        currentAge: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isActivated: faker.datatype.boolean(),
        lastUpdated: faker.word.sample(),
        retirementAge: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        riskTolerance: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'aggressive',
                'conservative',
                'moderate'
            ]),
            undefined
        ]),
        targetAllocations: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                morningStarId: faker.word.sample(),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                percentageAllocation: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                weightPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock = (overrideResponse = {})=>({
        census: faker.word.sample(),
        companyQuestionnaire: faker.word.sample(),
        completedAt: faker.word.sample(),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        payrollAndPayment: faker.word.sample(),
        planDesign: faker.word.sample(),
        planLaunch: faker.word.sample(),
        sponsorId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock = (overrideResponse = {})=>({
        accountId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        activationDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        addressUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        advisorId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        afterTaxContribution: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        afterTaxContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        autorebalance: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        birthDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        cipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contactInformation: {
            address: {
                address1: faker.word.sample(),
                address2: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                city: faker.word.sample(),
                country: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                state: faker.word.sample(),
                zip: faker.word.sample()
            },
            mailingAddress: faker.helpers.arrayElement([
                {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                undefined
            ]),
            personalEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            phoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            physicalSameAsMailing: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            workEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        contributesToRoth: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        contribution: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        contributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contributions: faker.helpers.arrayElement([
            {
                irsLimit: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            undefined
        ]),
        createdAt: faker.word.sample(),
        dateOfTermination: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        deferralChanged: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        deferralElections: {
            afterTaxAmt: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            afterTaxType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            preTaxAmt: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            preTaxType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rothAmt: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            rothType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        eligibility: faker.helpers.arrayElement([
            {
                ageRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                entryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isLtpt: faker.datatype.boolean(),
                isOverride: faker.datatype.boolean(),
                overrideNotes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                serviceRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                status: faker.word.sample()
            },
            undefined
        ]),
        emailUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employeeClass: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employeeStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employmentStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        esaGroupId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        esaGroupName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        externalId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        firstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        gender: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        hireDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        inRmdAge: faker.datatype.boolean(),
        isDeceased: faker.datatype.boolean(),
        isDisabled: faker.datatype.boolean(),
        isExcluded: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isVerified: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        lastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        maritalStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        matchEligibility: faker.helpers.arrayElement([
            {
                ageRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                entryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isLtpt: faker.datatype.boolean(),
                isOverride: faker.datatype.boolean(),
                overrideNotes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                serviceRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                status: faker.word.sample()
            },
            undefined
        ]),
        middleName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        model: faker.helpers.arrayElement([
            {
                modelId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                modelName: faker.word.sample(),
                modelType: faker.word.sample(),
                modelViewName: faker.word.sample()
            },
            undefined
        ]),
        nameUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        onboardingWizardCompletedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        participantChangedDeferralAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        password: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        planId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        psEligibility: faker.helpers.arrayElement([
            {
                ageRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                entryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isLtpt: faker.datatype.boolean(),
                isOverride: faker.datatype.boolean(),
                overrideNotes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                serviceRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                status: faker.word.sample()
            },
            undefined
        ]),
        registeredOn: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        rehireDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        riskValue: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        rothContribution: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        rothContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        savesForRetirement: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sendEmailUpdate: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        sponsorId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ssn: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraAccountStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraCipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraPerEmployerStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        updatedBy: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        yearsToRetire: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock = (overrideResponse = {})=>({
        employeeBalance: {
            afterTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            preTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            roth: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        employerBalance: {
            match: faker.number.int({
                max: undefined,
                min: undefined
            }),
            profitSharing: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        loanBalance: {
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        rolloverBalance: {
            preTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            roth: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        totalBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        updatedOn: faker.word.sample(),
        vestedBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock = (overrideResponse = {})=>({
        data: {
            attributes: faker.helpers.arrayElement([
                {
                    addressUpdate: faker.helpers.arrayElement([
                        {
                            address1: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            approvedBy: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            country: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            status: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            submittedBy: faker.word.sample(),
                            updatedAt: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            zip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    bankAccountInfo: faker.helpers.arrayElement([
                        {
                            accountNumber: faker.word.sample(),
                            financialInstitution: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            plaidMask: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            routingNumber: faker.word.sample()
                        },
                        undefined
                    ]),
                    calloutToParticipant: faker.datatype.boolean(),
                    createdAt: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    deliveryAddress: faker.helpers.arrayElement([
                        {
                            address1: faker.word.sample(),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.word.sample(),
                            country: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.word.sample(),
                            zip: faker.word.sample()
                        },
                        undefined
                    ]),
                    deliveryMethod: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    extraFee: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    forCreditTo: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    forFurtherCreditTo: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    fraudNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    interestRate: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    isConversion: faker.datatype.boolean(),
                    isReamortizing: faker.datatype.boolean(),
                    isSignedAgreement: faker.datatype.boolean(),
                    loanAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    loanPayments: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                attributes: faker.helpers.arrayElement([
                                    {
                                        dueDate: faker.word.sample(),
                                        interest: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        interestPaid: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        latestPaymentDate: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        paymentSequenceNumber: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        paymentStatus: faker.word.sample(),
                                        principal: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        principalPaid: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        total: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        updatedAt: faker.word.sample()
                                    },
                                    undefined
                                ]),
                                id: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                type: faker.word.sample()
                            })),
                        undefined
                    ]),
                    loanPurpose: faker.word.sample(),
                    loanStatus: faker.word.sample(),
                    ltLoanId: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    maintenanceFee: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    nextPaymentDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    notes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    originationDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    originationFee: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    outstandingPrincipalDue: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    overdueInterest: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    participantFirstName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    participantLastName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    paymentFrequency: faker.word.sample(),
                    promissoryNoteAcceptanceDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    purchaseSaleAgreementUploaded: faker.datatype.boolean(),
                    remainingPaymentsCount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    repaymentYears: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    totalPaymentsCount: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            type: faker.word.sample()
        },
        included: {},
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock = (overrideResponse = {})=>({
        linkToken: faker.word.sample(),
        verificationStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            attributes: faker.helpers.arrayElement([
                {
                    accountNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    accountVerificationStatus: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    bankAccountMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    bankAccountName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    holdReason: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    id: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    institutionName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    plaidAccountId: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    plaidMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    routingNumberMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    wireRoutingMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            id: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock = (overrideResponse = {})=>({
        attributes: faker.helpers.arrayElement([
            {
                accountNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                accountVerificationStatus: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                bankAccountMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                bankAccountName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                holdReason: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                institutionName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                plaidAccountId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                plaidMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                routingNumberMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                wireRoutingMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        id: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock = (overrideResponse = {})=>({
        balanceOverview: faker.helpers.arrayElement([
            {
                loanAmountAvailable: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                loanOutstandingBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                sdbaBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                totalAccountBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                totalVestedBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            undefined
        ]),
        hasAccess: faker.datatype.boolean(),
        interestRate: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        isFraudCheckRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        loanPreferences: faker.helpers.arrayElement([
            {
                allowedLoanPurposes: faker.helpers.arrayElement([
                    faker.helpers.arrayElements([
                        'General',
                        'Principal Residence Purchase'
                    ]),
                    undefined
                ]),
                allowedPayFrequencies: faker.helpers.arrayElement([
                    faker.helpers.arrayElements([
                        'SC',
                        'B',
                        'W',
                        'S',
                        'M',
                        'ME'
                    ]),
                    undefined
                ]),
                maintenanceFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                maxOutstandingLoans: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                maxYearsResidencePurchase: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                originationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                overnightCheckFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                wireFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        reason: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                attributes: faker.helpers.arrayElement([
                    {
                        code: faker.word.sample(),
                        source: faker.word.sample(),
                        tax: faker.word.sample()
                    },
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                type: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        stats: faker.helpers.arrayElement([
            {
                allocations: faker.helpers.arrayElement([
                    {
                        assetClass: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        fundName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        targetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        ticker: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                balance: faker.helpers.arrayElement([
                    {
                        afterTax: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        employee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        employer: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        loan: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        preTax: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        profitSharing: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        rollover: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        roth: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        total: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                metaAssetAllocations: faker.helpers.arrayElement([
                    {
                        bondNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        cashNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        otherNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        stockNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                vesting: faker.helpers.arrayElement([
                    {
                        EMNotVested: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        EMVestedPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        PSNotVested: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        PSVestedPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        QSHMNotVested: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        QSHMVestedPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        QSHNENotVested: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        QSHNEVestedPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        blendedNotVested: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        blendedVariablePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        total: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        vestedTotal: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    },
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            balance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            dateOf: faker.word.sample()
        }));
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            accountName: faker.word.sample(),
            accountNumberMasked: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            plaidMask: faker.word.sample(),
            routingNumberMasked: faker.word.sample()
        }));
export const getPortalMiddlewareGetParticipantDepositsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            bankAccountId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            createdAt: faker.word.sample(),
            createdBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            depositType: faker.word.sample(),
            id: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            status: faker.word.sample(),
            updatedAt: faker.word.sample()
        }));
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            autoPause: faker.datatype.boolean(),
            bankAccountId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            createdAt: faker.word.sample(),
            createdBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            frequency: faker.word.sample(),
            id: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            nextDate: faker.word.sample(),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            status: faker.word.sample(),
            updatedAt: faker.word.sample(),
            version: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewarePutRecurringScheduleResponseMock = (overrideResponse = {})=>({
        amount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        bankAccountId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        createdAt: faker.word.sample(),
        createdBy: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        depositType: faker.word.sample(),
        id: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        participantId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        status: faker.word.sample(),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock = (overrideResponse = {})=>({
        amount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        bankAccountId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        createdAt: faker.word.sample(),
        createdBy: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        depositType: faker.word.sample(),
        id: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        participantId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        status: faker.word.sample(),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock = (overrideResponse = {})=>({
        beacon: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                updatedAt: faker.word.sample()
            },
            undefined
        ]),
        cipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        idVerResponse: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                completedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                steps: {
                    acceptTos: faker.word.sample(),
                    documentaryVerification: faker.word.sample(),
                    kycCheck: faker.word.sample(),
                    riskCheck: faker.word.sample(),
                    selfieCheck: faker.word.sample(),
                    verifySms: faker.word.sample(),
                    watchlistScreening: faker.word.sample()
                },
                token: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                verificationUrl: faker.word.sample()
            },
            undefined
        ]),
        requiredDocUploads: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock = (overrideResponse = {})=>({
        data: {
            election: {
                age: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ageToDrawSocialSecurity: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                annualIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                currentGoalProbability: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                goalQuestionnaireId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                goalStrategyAnnualIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                isSystemGenerated: faker.datatype.boolean(),
                outsideAccounts: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        accountBalance: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        accountName: faker.word.sample(),
                        accountType: faker.word.sample()
                    })),
                outsideAccountsAnnualIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                participantId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                production: faker.datatype.boolean(),
                retireAtAge: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                retirementDate: faker.word.sample(),
                retirementIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                riskProfile: faker.helpers.arrayElement([
                    'aggressive',
                    'conservative',
                    'moderate'
                ]),
                saveMorePerMonth: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                socialSecurityAnnualIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                spendLess: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                totalProjectedAnnualIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                updatedAt: faker.word.sample(),
                updatedBy: {
                    authRole: faker.word.sample(),
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    idType: faker.word.sample()
                }
            },
            participant: {
                age: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            portfolio: {
                pieChart: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        label: faker.word.sample(),
                        value: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    })),
                table: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        allocation: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        assetClass: faker.word.sample(),
                        id: faker.word.sample(),
                        targetAllocations: Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                allocation: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                assetAllocations: {
                                    bondNetPct: faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    cashNetPct: faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    otherNetPct: faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    stockNetPct: faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    })
                                },
                                assetClass: faker.word.sample(),
                                broadCategory: faker.word.sample(),
                                category: faker.word.sample(),
                                cusip: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ]),
                                expenseRatioPct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                fiveYearPerformancePct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                fundName: faker.word.sample(),
                                id: faker.word.sample(),
                                inceptionDate: faker.word.sample(),
                                itdBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                itdPct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                name: faker.word.sample(),
                                oneYearBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                oneYearPerformancePct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                performanceUpdatedAt: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ]),
                                securityId: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ]),
                                securityType: faker.word.sample(),
                                securityTypeName: faker.word.sample(),
                                shareClass: faker.word.sample(),
                                tenYearBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                tenYearPerformancePct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                weightPct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                ytdBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                ytdPct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                })
                            }))
                    }))
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock = (overrideResponse = {})=>({
        data: {
            document: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            election: faker.helpers.arrayElement([
                {
                    age: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    ageToDrawSocialSecurity: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    annualIncome: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    retirementIncome: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                undefined
            ]),
            feeDocumentId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            participant: {
                currentAge: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock = (overrideResponse = {})=>({
        asOfDate: faker.word.sample(),
        expenseRatioPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        fi360FactsheetPath: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        fiveYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        fiveYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        inceptionDate: faker.word.sample(),
        inceptionToDateReturn: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isDefault: faker.datatype.boolean(),
        itdBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        itdPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        metaAssetAllocations: {
            bondNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            cashNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            otherNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            stockNetPct: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        modelBoundaries: {
            riskLevel: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            targetRetireYearHigh: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            targetRetireYearLow: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            yearsToRetireHigh: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            yearsToRetireLow: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        modelDescription: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelFundSecurity: faker.helpers.arrayElement([
            {
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                weightPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            undefined
        ]),
        modelSecurities: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                weightPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        modelType: faker.helpers.arrayElement([
            'target',
            'risk',
            'menu',
            'pmenu',
            'goal',
            'ms_ma',
            'ms_ma_menu',
            'nli'
        ]),
        name: faker.word.sample(),
        oneYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        oneYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        performanceUpdatedAt: faker.word.sample(),
        securityAllocations: {
            bondNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            cashNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            otherNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            stockNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        tenYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        tenYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        viewName: faker.word.sample(),
        ytdBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ytdPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock = (overrideResponse = {})=>({
        autoRebalance: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock = (overrideResponse = {})=>({
        currentlyInUse: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        defaultType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelTypes: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock = (overrideResponse = {})=>({
        birthDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        models: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                asOfDate: faker.word.sample(),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fi360FactsheetPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                fiveYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                inceptionDate: faker.word.sample(),
                inceptionToDateReturn: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                isDefault: faker.datatype.boolean(),
                itdBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                metaAssetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                modelBoundaries: {
                    riskLevel: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                modelDescription: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modelFundSecurity: faker.helpers.arrayElement([
                    {
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            cashNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            otherNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            stockNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        weightPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    },
                    undefined
                ]),
                modelSecurities: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            cashNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            otherNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            stockNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        weightPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    })),
                modelType: faker.helpers.arrayElement([
                    'target',
                    'risk',
                    'menu',
                    'pmenu',
                    'goal',
                    'ms_ma',
                    'ms_ma_menu',
                    'nli'
                ]),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.word.sample(),
                securityAllocations: {
                    bondNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    cashNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    otherNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    stockNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                tenYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                viewName: faker.word.sample(),
                ytdBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        participantAge: faker.number.int({
            max: undefined,
            min: undefined
        }),
        retirementAge: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock = (overrideResponse = {})=>({
        models: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                asOfDate: faker.word.sample(),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fi360FactsheetPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                fiveYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                inceptionDate: faker.word.sample(),
                inceptionToDateReturn: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                isDefault: faker.datatype.boolean(),
                itdBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                metaAssetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                modelBoundaries: {
                    riskLevel: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                modelDescription: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modelFundSecurity: faker.helpers.arrayElement([
                    {
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            cashNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            otherNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            stockNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        weightPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    },
                    undefined
                ]),
                modelSecurities: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            cashNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            otherNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            stockNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        weightPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    })),
                modelType: faker.helpers.arrayElement([
                    'target',
                    'risk',
                    'menu',
                    'pmenu',
                    'goal',
                    'ms_ma',
                    'ms_ma_menu',
                    'nli'
                ]),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.word.sample(),
                securityAllocations: {
                    bondNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    cashNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    otherNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    stockNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                tenYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                viewName: faker.word.sample(),
                ytdBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        programId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock = (overrideResponse = {})=>({
        modelId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        name: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        riskValue1High: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        riskValue1Low: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock = (overrideResponse = {})=>({
        isWiredAtWork: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        paperlessNotices: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock = (overrideResponse = {})=>({
        autoEnrollAmount: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        contribution: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        contributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        deferInDollars: faker.datatype.boolean(),
        esaProgramSponsorPlanFree: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        keepExistingRate: faker.datatype.boolean(),
        participantChangedDeferralAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        rothContribution: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        rothContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        safeHarborStrategy: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock = (overrideResponse = {})=>({
        allowRothDeferrals: faker.datatype.boolean(),
        transfers: {
            isEffectiveDateUpcoming: faker.datatype.boolean(),
            loan: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rollover: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rolloverIntoAccountAllowed: faker.datatype.boolean()
        },
        ytdContributions: {
            limit: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            }),
            year: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            availableBalance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            currentBalance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            institutionId: faker.word.sample(),
            itemId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            plaidAccountId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            plaidAccountSubtype: faker.helpers.arrayElement([
                '401a',
                '401k',
                '403B',
                '457b',
                '529',
                'brokerage',
                'cash isa',
                'crypto exchange',
                'education savings account',
                'ebt',
                'fixed annuity',
                'gic',
                'health reimbursement arrangement',
                'hsa',
                'isa',
                'ira',
                'lif',
                'life insurance',
                'lira',
                'lrif',
                'lrsp',
                'non-custodial wallet',
                'non-taxable brokerage account',
                'other',
                'other insurance',
                'other annuity',
                'prif',
                'rdsp',
                'resp',
                'rlif',
                'rrif',
                'pension',
                'profit sharing plan',
                'retirement',
                'roth',
                'roth 401k',
                'rrsp',
                'sep ira',
                'simple ira',
                'sipp',
                'stock plan',
                'thrift savings plan',
                'tfsa',
                'trust',
                'ugma',
                'variable annuity',
                'credit card',
                'paypal',
                'cd',
                'checking',
                'savings',
                'money market',
                'prepaid',
                'auto',
                'business',
                'commercial',
                'construction',
                'consumer',
                'home equity',
                'loan',
                'mortgage',
                'overdraft',
                'line of credit',
                'student',
                'cash management',
                'keogh',
                'mutual fund',
                'recurring',
                'rewards',
                'safe deposit',
                'sarsep',
                'payroll',
                'null'
            ]),
            plaidAccountType: faker.helpers.arrayElement([
                'investment',
                'credit',
                'depository',
                'loan',
                'brokerage',
                'other'
            ])
        }));
export const getPortalMiddlewareGetPositionsResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    attributes: faker.helpers.arrayElement([
                        {
                            assetClass: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            broadAssetClass: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            cusip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            expenseRatioPct: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            fundName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            securityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            shares: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            vestedBalance: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            vestedShares: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            weight: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    id: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    type: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        stats: faker.helpers.arrayElement([
            {
                assetAllocations: faker.helpers.arrayElement([
                    {
                        bondNet: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        bondNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        cashNet: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        cashNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        otherNet: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        otherNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        stockNet: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        stockNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                modelAllocations: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            model: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            percent: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ])
                        })),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            availableAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            birthOrAdoptionDate: faker.word.sample(),
            childFirstName: faker.word.sample(),
            childLastName: faker.word.sample(),
            childSsn: faker.word.sample(),
            disabled: faker.datatype.boolean(),
            disabledReason: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            validUntil: faker.word.sample()
        }));
export const getPortalMiddlewareGetParticipantRolloverResponseMock = (overrideResponse = {})=>({
        attributes: {
            accountProvider: faker.word.sample(),
            accountType: {},
            createdAt: faker.word.sample(),
            letterDocumentId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            preTaxAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            rothAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            rothCostBasis: faker.number.int({
                max: undefined,
                min: undefined
            }),
            rothStartDate: faker.word.sample(),
            status: {}
        },
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        type: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock = (overrideResponse = {})=>({
        afterTaxAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        age: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        allowDollarAmounts: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        allowRothDeferrals: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        catchUpLimit: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        employeeLimit: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        preTaxAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        rothAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        safeHarborMatchType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        safeHarborMatchTypeDescription: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        superCatchUpLimit: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ytdContributions: {
            limit: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            total: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            year: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock = (overrideResponse = {})=>({
        asOfDate: faker.word.sample(),
        transactions: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    amount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    category: faker.word.sample()
                })),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock = (overrideResponse = {})=>({
        allowedReasons: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    afterTaxAvailableAmount: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    afterTaxMaxAmount: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    disabled: faker.datatype.boolean(),
                    distributionMethods: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                        undefined
                    ]),
                    fee: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    maxAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    preTaxAvailableAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    preTaxMaxAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    qboadSupported: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    reason: faker.word.sample(),
                    rothAvailableAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    rothMaxAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                })),
            undefined
        ]),
        disallowedReasons: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        fullyVestedPreTaxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        fullyVestedRothBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        overnightCheckFee: faker.number.int({
            max: undefined,
            min: undefined
        }),
        rolloverPreTaxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        rolloverRothBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        sdbaPreTaxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        sdbaRothBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalPreTaxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalRothBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        vestedPreTaxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        vestedRothBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        wireFee: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                autoEnrolledParticipants: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        contribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        contributionType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        eligibilityStatus: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        eligibilityStatusId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        email: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        entryDate: faker.word.sample(),
                        firstName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        lastName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        loginUserId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        participantId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        personalEmail: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        ssnSuffix: faker.word.sample(),
                        workEmail: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    })),
                meta: {
                    total: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                }
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                meta: {
                    total: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                optedOutParticipants: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        firstName: faker.word.sample(),
                        lastName: faker.word.sample(),
                        optedOutAt: faker.word.sample(),
                        optedOutByUserEmail: faker.word.sample(),
                        optedOutByUserId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        participantId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        ssnSuffix: faker.word.sample()
                    }))
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock = (overrideResponse = {})=>({
        participants: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    address1: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    eligibilityEntryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    eligibilityStatus: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    emailInfo: faker.helpers.arrayElement([
                        {
                            messageId: faker.word.sample(),
                            sentOn: faker.word.sample(),
                            sentTo: faker.word.sample()
                        },
                        undefined
                    ]),
                    emailType: faker.helpers.arrayElement([
                        {},
                        undefined
                    ]),
                    firstName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    lastName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    middleName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    personalEmail: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    ssn: faker.word.sample(),
                    state: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    status: faker.word.sample(),
                    workEmail: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    zip: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        totalCount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock = (overrideResponse = {})=>({
        count: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock = (overrideResponse = {})=>({
        successEmails: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalEmails: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock = (overrideResponse = {})=>({
        firstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        history: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    eventType: faker.word.sample(),
                    messageId: faker.word.sample(),
                    sentOn: faker.word.sample(),
                    sentTo: faker.word.sample()
                })),
            undefined
        ]),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        lastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ssn: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock = (overrideResponse = {})=>({
        data: {
            atTotal: faker.number.int({
                max: undefined,
                min: undefined
            }),
            employerMatch: faker.number.int({
                max: undefined,
                min: undefined
            }),
            esaGroupId: faker.word.sample(),
            initialBonus: faker.number.int({
                max: undefined,
                min: undefined
            }),
            milestoneBonusAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            milestoneBonusId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        error: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        success: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock = (overrideResponse = {})=>({
        data: {
            employerMatch: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock = (overrideResponse = {})=>({
        distributionFeatures: faker.helpers.arrayElement([
            {
                allowHardshipElective: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipFromPartialVestedAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipMatch: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipProfitSharing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipRollover: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipSafeHarbor: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipTransfer: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipWithdrawals: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowHardshipWithdrawalsFromRothAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtEarlyAge: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtEarlyAgeFromAllAccounts: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtNormalAge: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtNormalAgeFromAllAccounts: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtSpecifiedAge: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowInServiceFromPartialVestedAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceFromRolloverAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceUponDisability: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPartialDistributionsAfterTermination: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPermissibleWithdrawal: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowQbad: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowSpecifiedAgeFromRothAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                childFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                correctiveFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                deathFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                disabilityFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                earlyRetirementAgeType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                generalFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                hardshipCriteria: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                hardshipFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                inServiceFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                inServiceSpecifiedAge: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                normalRetirementAge: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                normalRetirementAgeType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                participantTerminationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                permissibleTimeframe: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                permissiveFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                planTerminationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                qdroFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                rmdFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                rolloverFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        effectiveDate: faker.helpers.arrayElement([
            {
                blackoutEndDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                blackoutStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                liquidationDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                originalEffectivePlanDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planYearEnd: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                profitSharingStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                safeHarborEffectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                salaryRothDeferralEffectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                vestwellStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        eligibilityFeatures: faker.helpers.arrayElement([
            {
                eligibilityRules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequency: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequencyId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            ruleParameter: faker.helpers.arrayElement([
                                {
                                    age: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    failsafe: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    hours: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    months: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        })),
                    undefined
                ]),
                excludeLeasedEmployees: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                hasDualEligibility: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                matchEligibilityRules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequency: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequencyId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            ruleParameter: faker.helpers.arrayElement([
                                {
                                    age: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    failsafe: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    hours: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    months: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        })),
                    undefined
                ]),
                profitSharingEligibilityRules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequency: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequencyId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            ruleParameter: faker.helpers.arrayElement([
                                {
                                    age: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    failsafe: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    hours: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    months: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        })),
                    undefined
                ]),
                specialEntryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                specialParticipationDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        employeeContribution: faker.helpers.arrayElement([
            {
                allowAfterTaxContribution: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPretaxContribution: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                autoEnrollAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                autoEnrollEffectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                autoEscalate: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                autoEscalateAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                autoEscalateMaximum: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                deferInDollars: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                isSalaryRothDeferral: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ])
            },
            undefined
        ]),
        employerContribution: faker.helpers.arrayElement([
            {
                allowEmployerProfitSharing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowNonSafeHarborMatch: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPrevailingWage: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowRollover: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowSafeHarborNonElective: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                discretionaryMatchFundingIntent: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                documentMatchFrequency: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                earlyRetirementAge: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                formula: faker.helpers.arrayElement([
                    {
                        dollarCap: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        dollarCapId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        formulaDefined: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        tiers: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    tierCap: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    tierIndex: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    tierPercent: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ])
                                })),
                            undefined
                        ])
                    },
                    undefined
                ]),
                isSafeHarbor: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                matchFrequency: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                nonSafeHarborMatchType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                notes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                profitSharingStrategy: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                safeHarborMatchType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        forceOutPreferences: faker.helpers.arrayElement([
            {
                excludeRollover: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                isAllowed: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                isAutomated: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                maxAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                rolloverMin: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        forfeiturePreferences: faker.helpers.arrayElement([
            {
                offsetEmployerContribution: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                payPlanFees: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ])
            },
            undefined
        ]),
        loanFeatures: faker.helpers.arrayElement([
            {
                allowLoans: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowResidencePurchaseExtension: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                hasPriorLoans: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                maintenanceFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                maxOutstandingLoans: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                maxYearsResidencePurchase: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                originationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                overnightCheckFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                wireFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        offboardingInformation: faker.helpers.arrayElement([
            {
                blackoutEndDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                blackoutStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        overview: faker.helpers.arrayElement([
            {
                adminStatus: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                advisorFirstName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                advisorLastName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                clientSuccessManagerId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                clientSuccessManagerName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                companyName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                conversionType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                integrationLevel: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                integrationTypeId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                investmentProgram: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                investmentProgramId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                payroll: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planDesignTypeName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planTierId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                planTierName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tpaFiduciary: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tpaId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                trustee: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        recordkeeperAndCustodian: faker.helpers.arrayElement([
            {
                adoptionAgreementDocumentProvider: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                custodianAccountNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                externalHardDollarBillingAccountNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                externalPlanId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                opportunityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                partnerSystemName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                priorProvider: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                recordkeeperId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        vestingPreferences: faker.helpers.arrayElement([
            {
                excludeServicePriorTo18YearsOld: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                excludeServicePriorToPlanExistence: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                fundingSources: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            fundingSourceId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            fundingSourceName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            vestingScheduleId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            vestingScheduleName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        })),
                    undefined
                ]),
                hoursOfServiceRequired: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                vestingMethod: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            planDesignTemplate: {
                distributionFeatures: faker.helpers.arrayElement([
                    {
                        allowHardshipElective: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipFromPartialVestedAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipMatch: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipProfitSharing: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipRollover: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipSafeHarbor: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipTransfer: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipWithdrawals: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowHardshipWithdrawalsFromRothAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtEarlyAge: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtEarlyAgeFromAllAccounts: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtNormalAge: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtNormalAgeFromAllAccounts: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtSpecifiedAge: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowInServiceFromPartialVestedAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceFromRolloverAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceUponDisability: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPartialDistributionsAfterTermination: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPermissibleWithdrawal: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowQbad: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowSpecifiedAgeFromRothAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        childFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        correctiveFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        deathFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        disabilityFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        earlyRetirementAgeType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        generalFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        hardshipCriteria: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        hardshipFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        inServiceFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        inServiceSpecifiedAge: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        normalRetirementAge: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        normalRetirementAgeType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        participantTerminationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        permissibleTimeframe: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        permissiveFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        planTerminationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        qdroFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        rmdFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        rolloverFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                effectiveDate: faker.helpers.arrayElement([
                    {
                        blackoutEndDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        blackoutStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        liquidationDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        originalEffectivePlanDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planYearEnd: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        profitSharingStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        safeHarborEffectiveDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        salaryRothDeferralEffectiveDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        vestwellStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                eligibilityFeatures: faker.helpers.arrayElement([
                    {
                        eligibilityRules: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequency: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequencyId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    ruleParameter: faker.helpers.arrayElement([
                                        {
                                            age: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            failsafe: faker.helpers.arrayElement([
                                                faker.word.sample(),
                                                undefined
                                            ]),
                                            hours: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            months: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ])
                                        },
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        excludeLeasedEmployees: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        hasDualEligibility: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        matchEligibilityRules: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequency: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequencyId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    ruleParameter: faker.helpers.arrayElement([
                                        {
                                            age: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            failsafe: faker.helpers.arrayElement([
                                                faker.word.sample(),
                                                undefined
                                            ]),
                                            hours: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            months: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ])
                                        },
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        profitSharingEligibilityRules: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequency: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequencyId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    ruleParameter: faker.helpers.arrayElement([
                                        {
                                            age: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            failsafe: faker.helpers.arrayElement([
                                                faker.word.sample(),
                                                undefined
                                            ]),
                                            hours: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            months: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ])
                                        },
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        specialEntryDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        specialParticipationDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                employeeContribution: faker.helpers.arrayElement([
                    {
                        allowAfterTaxContribution: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPretaxContribution: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        autoEnrollAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        autoEnrollEffectiveDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        autoEscalate: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        autoEscalateAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        autoEscalateMaximum: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        deferInDollars: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        isSalaryRothDeferral: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                employerContribution: faker.helpers.arrayElement([
                    {
                        allowEmployerProfitSharing: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowNonSafeHarborMatch: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPrevailingWage: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowRollover: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowSafeHarborNonElective: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        discretionaryMatchFundingIntent: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        documentMatchFrequency: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        earlyRetirementAge: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        formula: faker.helpers.arrayElement([
                            {
                                dollarCap: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                dollarCapId: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                formulaDefined: faker.helpers.arrayElement([
                                    faker.datatype.boolean(),
                                    undefined
                                ]),
                                tiers: faker.helpers.arrayElement([
                                    Array.from({
                                        length: faker.number.int({
                                            max: 10,
                                            min: 1
                                        })
                                    }, (_, i)=>i + 1).map(()=>({
                                            tierCap: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            tierIndex: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            tierPercent: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ])
                                        })),
                                    undefined
                                ])
                            },
                            undefined
                        ]),
                        isSafeHarbor: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        matchFrequency: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        nonSafeHarborMatchType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        notes: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        profitSharingStrategy: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        safeHarborMatchType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                forceOutPreferences: faker.helpers.arrayElement([
                    {
                        excludeRollover: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        isAllowed: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        isAutomated: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        maxAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        rolloverMin: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                forfeiturePreferences: faker.helpers.arrayElement([
                    {
                        offsetEmployerContribution: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        payPlanFees: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                loanFeatures: faker.helpers.arrayElement([
                    {
                        allowLoans: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowResidencePurchaseExtension: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        hasPriorLoans: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        maintenanceFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        maxOutstandingLoans: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        maxYearsResidencePurchase: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        originationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        overnightCheckFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        wireFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                offboardingInformation: faker.helpers.arrayElement([
                    {
                        blackoutEndDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        blackoutStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                overview: faker.helpers.arrayElement([
                    {
                        adminStatus: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        advisorFirstName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        advisorLastName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        clientSuccessManagerId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        clientSuccessManagerName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        companyName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        conversionType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        integrationLevel: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        integrationTypeId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        investmentProgram: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        investmentProgramId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        payroll: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planDesignTypeName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planTierId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        planTierName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        tpaFiduciary: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        tpaId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        trustee: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                recordkeeperAndCustodian: faker.helpers.arrayElement([
                    {
                        adoptionAgreementDocumentProvider: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        custodianAccountNumber: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        externalHardDollarBillingAccountNumber: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        externalPlanId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        opportunityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        partnerSystemName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        priorProvider: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        recordkeeperId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                vestingPreferences: faker.helpers.arrayElement([
                    {
                        excludeServicePriorTo18YearsOld: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        excludeServicePriorToPlanExistence: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        fundingSources: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    fundingSourceId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    fundingSourceName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    vestingScheduleId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    vestingScheduleName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        hoursOfServiceRequired: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        vestingMethod: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ])
            },
            planDesignTileName: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanModelResponseMock = (overrideResponse = {})=>({
        asOfDate: faker.word.sample(),
        expenseRatioPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        fi360FactsheetPath: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        fiveYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        fiveYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        inceptionDate: faker.word.sample(),
        inceptionToDateReturn: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isDefault: faker.datatype.boolean(),
        itdBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        itdPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        metaAssetAllocations: {
            bondNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            cashNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            otherNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            stockNetPct: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        modelBoundaries: {
            riskLevel: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            targetRetireYearHigh: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            targetRetireYearLow: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            yearsToRetireHigh: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            yearsToRetireLow: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        modelDescription: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelType: faker.helpers.arrayElement([
            'target',
            'risk',
            'menu',
            'pmenu',
            'goal',
            'ms_ma',
            'ms_ma_menu',
            'nli'
        ]),
        name: faker.word.sample(),
        oneYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        oneYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        performanceUpdatedAt: faker.word.sample(),
        tenYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        tenYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        viewName: faker.word.sample(),
        ytdBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ytdPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock = (overrideResponse = {})=>({
        directDeposit: faker.datatype.boolean(),
        esaProgramId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        payrollDeduction: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                fi360FactsheetPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                inceptionDate: faker.word.sample(),
                isDefault: faker.datatype.boolean(),
                modelBoundaries: {
                    riskLevel: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                modelDescription: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modelType: faker.helpers.arrayElement([
                    'target',
                    'risk',
                    'menu',
                    'pmenu',
                    'goal',
                    'ms_ma',
                    'ms_ma_menu',
                    'nli'
                ]),
                name: faker.word.sample(),
                programId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                viewName: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            assetAllocations: {
                bondNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                cashNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                otherNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                stockNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            assetClass: faker.word.sample(),
            broadCategory: faker.word.sample(),
            category: faker.word.sample(),
            cusip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expenseRatioPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            fiveYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            fiveYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            id: faker.word.sample(),
            inceptionDate: faker.word.sample(),
            itdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            itdPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            oneYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            oneYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            performanceUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityType: faker.word.sample(),
            securityTypeName: faker.word.sample(),
            shareClass: faker.word.sample(),
            tenYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            tenYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            weightPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ytdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ytdPct: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetProgramModelsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            fi360FactsheetPath: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            inceptionDate: faker.word.sample(),
            isDefault: faker.datatype.boolean(),
            modelBoundaries: {
                riskLevel: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                targetRetireYearHigh: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                targetRetireYearLow: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                yearsToRetireHigh: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                yearsToRetireLow: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            modelDescription: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            modelType: faker.helpers.arrayElement([
                'target',
                'risk',
                'menu',
                'pmenu',
                'goal',
                'ms_ma',
                'ms_ma_menu',
                'nli'
            ]),
            name: faker.word.sample(),
            programId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            viewName: faker.word.sample()
        }));
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock = (overrideResponse = {})=>({
        postfix: faker.word.sample(),
        prefix: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            code: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            nonElectivePercent: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tierOneMatchMax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tierOneMatchPercent: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tierTwoMatchMax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tierTwoMatchMin: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tierTwoMatchPercent: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock = (overrideResponse = {})=>({
        cashBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        effectiveDate: faker.word.sample(),
        externalAccountNumber: faker.word.sample(),
        totalMarketValue: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock = (overrideResponse = {})=>({
        allowSdba: faker.datatype.boolean(),
        createdAt: faker.word.sample(),
        createdBy: {
            authRole: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            idType: faker.word.sample()
        },
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        maxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        minVestedBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participantFee: faker.number.int({
            max: undefined,
            min: undefined
        }),
        planAccessCode: faker.word.sample(),
        sdbaPlanId: faker.word.sample(),
        sdbaStatus: faker.word.sample(),
        sponsorPlanId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        updatedAt: faker.word.sample(),
        updatedBy: {
            authRole: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            idType: faker.word.sample()
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            externalTransferType: faker.word.sample(),
            status: faker.word.sample(),
            submissionTime: faker.word.sample(),
            transferId: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock = (overrideResponse = {})=>({
        hasActiveTransfers: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock = (overrideResponse = {})=>({
        autoEnroll: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        sponsorPlanId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock = (overrideResponse = {})=>({
        configurationId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        hasCompleted: faker.datatype.boolean(),
        hasOfficers: faker.datatype.boolean(),
        hasOwners: faker.datatype.boolean(),
        sponsorPlanId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecordsId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecorsdId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            grossCompensation: faker.number.int({
                max: undefined,
                min: undefined
            }),
            grosscompInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecordsId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isOfficer: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            officerInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isEmployee: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            ownerSince: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownersId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ownership: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            employee: {
                birthYear: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                censusRecordsId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                firstName: faker.word.sample(),
                hireDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                lastName: faker.word.sample(),
                ssn: faker.word.sample()
            },
            ownersFamilyId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            relationship: faker.word.sample()
        }));
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock = (overrideResponse = {})=>({
        isNew: faker.datatype.boolean(),
        ucid: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock = (overrideResponse = {})=>({
        adjustmentData: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                columnNames: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                contributionAmount: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                correctionType: faker.word.sample(),
                createdAt: faker.word.sample(),
                errorCode: faker.word.sample(),
                firstName: faker.word.sample(),
                lastName: faker.word.sample(),
                ssn: faker.word.sample(),
                unallowedAmount: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            })),
        fileTag: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            employeeClass: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            isExcluded: faker.datatype.boolean()
        }));
export const getPortalMiddlewareGetEmployeeDetailsResponseMock = (overrideResponse = {})=>({
        contributions: {
            contributionLimit: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            employeeYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            employerYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            stateEmployeeYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            totalDollars: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        editAccess: {
            isAllowedToUpdate: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            message: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            sponsorId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        employee: {
            accountId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            activationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            addressUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisorId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            afterTaxContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            afterTaxContributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            autorebalance: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            birthDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            cipStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contactInformation: {
                address: {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                mailingAddress: faker.helpers.arrayElement([
                    {
                        address1: faker.word.sample(),
                        address2: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        city: faker.word.sample(),
                        country: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        state: faker.word.sample(),
                        zip: faker.word.sample()
                    },
                    undefined
                ]),
                personalEmail: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                phoneNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                physicalSameAsMailing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                workEmail: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            contributesToRoth: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            contribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            contributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contributions: faker.helpers.arrayElement([
                {
                    irsLimit: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            createdAt: faker.word.sample(),
            dateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            deferralChanged: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            deferralElections: {
                afterTaxAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                afterTaxType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                preTaxAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                preTaxType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                rothAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                rothType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            eligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            emailUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employeeClass: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employeeStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employmentStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            esaGroupId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            esaGroupName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            externalId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gender: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            inRmdAge: faker.datatype.boolean(),
            isDeceased: faker.datatype.boolean(),
            isDisabled: faker.datatype.boolean(),
            isExcluded: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isVerified: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            lastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            maritalStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            matchEligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            middleName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            model: faker.helpers.arrayElement([
                {
                    modelId: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    modelName: faker.word.sample(),
                    modelType: faker.word.sample(),
                    modelViewName: faker.word.sample()
                },
                undefined
            ]),
            nameUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onboardingWizardCompletedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantChangedDeferralAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            password: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            psEligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            registeredOn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rehireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            riskValue: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            rothContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            rothContributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            savesForRetirement: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            sendEmailUpdate: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            sponsorId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraAccountStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraCipStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraPerEmployerStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            updatedAt: faker.word.sample(),
            updatedBy: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            yearsToRetire: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock = (overrideResponse = {})=>({
        data: {
            attributes: {
                isConvert: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            relationships: {
                firm: {
                    data: {
                        id: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    }
                }
            }
        },
        included: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                attributes: {
                    recordKeeperId: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                }
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        id: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        offsetEmployerContribution: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        payPlanFees: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        updatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock = (overrideResponse = {})=>({
        schemaState: {
            censusInfo: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            companyInfo: faker.helpers.arrayElement([
                {
                    mailingAddress: faker.helpers.arrayElement([
                        {},
                        undefined
                    ]),
                    physicalAddress: faker.helpers.arrayElement([
                        {},
                        undefined
                    ])
                },
                undefined
            ]),
            conversionInfo: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            employeeGroups: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        description: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        dollarCap: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        incentivesOptOut: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        initialBonusAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        initialBonusMinimum: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        lifetimeCap: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        localId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        milestoneBonusAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        milestoneBonusThreshold: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        name: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        percent: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    })),
                undefined
            ]),
            paymentSetup: faker.helpers.arrayElement([
                {
                    bankAccounts: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({})),
                        undefined
                    ]),
                    feePayment: faker.helpers.arrayElement([
                        {
                            bankAccountLocalId: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            isPayingWithCreditCard: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    forfeiturePreferences: faker.helpers.arrayElement([
                        {},
                        undefined
                    ]),
                    fundingMethods: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({})),
                        undefined
                    ]),
                    payrollSchedules: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                fundingMethodId: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                scheduleName: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ])
                            })),
                        undefined
                    ]),
                    payrollSystemId: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                undefined
            ]),
            payrollSetup: {
                payrollSchedules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({})),
                    undefined
                ]),
                payrollSystem: faker.helpers.arrayElement([
                    {},
                    undefined
                ])
            },
            planAdministration: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            planOptions: faker.helpers.arrayElement([
                {},
                undefined
            ])
        },
        status: faker.helpers.arrayElement([
            'completed_successfully',
            'completed_unsuccessfully',
            'in_progress',
            'needs_attention',
            'new',
            'ongoing'
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock = (overrideResponse = {})=>({
        fields: {
            above10M: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            address1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            address2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisorsFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisoryServiceId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            articlesOfIncorporationLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            assetBasedFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerAddress1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerAddress2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerCity: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerDateOfBirth: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerFirstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerLastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerResidenceCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerSSN: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerState: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerTitle: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authorizedSignerEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerWorkPhone: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerZip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            billingContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            censusLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            chargesOffPlatform: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            citizenshipType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            city: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            comment: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyEntityType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyPhoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            controlGroupBusinesses: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    business: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    ein: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            conversionParticipantDetailsLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dateSubmittedToRecordkeeper: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            disablePlanDesign: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            doingBusinessAs: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employerIdentificationNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanAssets: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanCustodian: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanParticipants: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanProvider: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expectedAnnualContributions: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            feePaymentMethod: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            feesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            first3M: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            fiscalYearEnd: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            form5500Link: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hasCensus: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasMultiplePayrollGroups: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasPdmp: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasUnion: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hqCountry: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            identificationCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationExpirationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationIssueDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationState: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            investmentProductId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            isActive: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isAuthorizedSigner: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isConvertedPlan: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            leasedEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            newOnboarding: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            next2M: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            next5M: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            offsetEmployerContribution: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownerForeignDignitaryCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownerIsForeignDignitary: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownersFamilyMembersEmployees: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    name: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    taxFormType: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            ownersOver5Percent: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            paaLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            partTimeEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            participationAgreementLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payPlanFees: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            perParticipantFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planTier: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            planType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planYear: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactFirstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactLastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactTitle: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            standardIndustrialClassification: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            state: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateOfIncorporation: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            summaryPlanDescriptionLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            teamMemberEmails: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            totalEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            tpaId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            updatedBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            wiredAtWork: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            zip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock = (overrideResponse = {})=>({
        createdAt: faker.word.sample(),
        documentKey: faker.word.sample(),
        entity: faker.word.sample(),
        entityId: faker.word.sample(),
        etag: faker.word.sample(),
        groupDetails: faker.helpers.arrayElement([
            {
                effectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                groupId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                uploadHistoryId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isDraft: faker.datatype.boolean(),
        isEnabled: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        originalFileName: faker.word.sample(),
        uploadPath: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock = (overrideResponse = {})=>({
        createdAt: faker.word.sample(),
        documentKey: faker.word.sample(),
        entity: faker.word.sample(),
        entityId: faker.word.sample(),
        etag: faker.word.sample(),
        groupDetails: faker.helpers.arrayElement([
            {
                effectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                groupId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                uploadHistoryId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isDraft: faker.datatype.boolean(),
        isEnabled: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        originalFileName: faker.word.sample(),
        uploadPath: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({})),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock = (overrideResponse = {})=>({
        allowInitialBonus: faker.datatype.boolean(),
        allowMatch: faker.datatype.boolean(),
        allowMilestoneBonus: faker.datatype.boolean(),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            dateFormat: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            defaultAdapterId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            instructionLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            integrationTypeId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            isApproved: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isPiIntegrated: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            level: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            subName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            useCatchupFields: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            useK1: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            useTiredMatch: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ])
        }));
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock = (overrideResponse = {})=>({
        calendlyUrl: faker.word.sample(),
        isConversion: faker.datatype.boolean(),
        isJpm: faker.datatype.boolean(),
        planDesignConsultType: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'Full Consultation',
                'Sales Consultation',
                'Partner Consultation',
                'Self Service Tiles',
                'Solo(K)',
                'Website Direct'
            ]),
            undefined
        ]),
        tpaId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock = (overrideResponse = {})=>({
        bookingLink: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            accessRoleIds: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>faker.number.int({
                    max: undefined,
                    min: undefined
                })),
            clientId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            entityId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            entityType: faker.word.sample(),
            isTemp: faker.datatype.boolean(),
            userId: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetPlanFeaturesResponseMock = (overrideResponse = {})=>({
        allowRollover: faker.word.sample(),
        autoEnrollAmountPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        autoEnrollEffectiveDate: faker.word.sample(),
        autoEscalateAmount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        blackoutEndDate: faker.word.sample(),
        blackoutStartDate: faker.word.sample(),
        hasDualEligibility: faker.datatype.boolean(),
        isAfterTaxContributionAllowed: faker.datatype.boolean(),
        isAutoEnroll: faker.datatype.boolean(),
        isAutoEscalate: faker.datatype.boolean(),
        isCalculateEmployerMatch: faker.datatype.boolean(),
        isDeferInDollars: faker.datatype.boolean(),
        isEarlyRetirementAllowed: faker.datatype.boolean(),
        isEmployerMatching: faker.datatype.boolean(),
        isHardshipDistributionAllowed: faker.datatype.boolean(),
        isHardshipProofRequired: faker.datatype.boolean(),
        isLoansAllowed: faker.datatype.boolean(),
        isPreTaxContributionAllowed: faker.datatype.boolean(),
        isProfitSharing: faker.datatype.boolean(),
        isSafeHarborMatchAllowed: faker.datatype.boolean(),
        isSafeHarborNonElectiveAllowed: faker.datatype.boolean(),
        isSalaryRothDeferral: faker.datatype.boolean(),
        profitSharingType: faker.word.sample(),
        safeHarborContributionType: faker.word.sample(),
        safeHarborMatchType: faker.word.sample(),
        safeHarborMatchTypeDescription: faker.word.sample(),
        vestingPeriod: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock = (overrideResponse = {})=>({
        data: {
            attributes: {
                accountBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                cashBalanceInterestRate: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                contributingAvgDeferralRatePct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                currentPositionsEmployee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                currentPositionsEmployer: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                currentPositionsLoan: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                currentPositionsRollover: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                eligibleParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                eligiblesAvgDeferralRatePct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                employedParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                modelAgeDistributions: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            ageRange: faker.helpers.arrayElement([
                                faker.helpers.arrayElement([
                                    '<=25',
                                    '26-35',
                                    '36-45',
                                    '46-55',
                                    '56-65',
                                    '>=66'
                                ]),
                                undefined
                            ]),
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            modelId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            modelName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelType: faker.helpers.arrayElement([
                                faker.helpers.arrayElement([
                                    'target',
                                    'risk',
                                    'menu',
                                    'pmenu',
                                    'goal',
                                    'ms_ma',
                                    'ms_ma_menu',
                                    'nli'
                                ]),
                                undefined
                            ]),
                            participantsInModel: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ])
                        })),
                    undefined
                ]),
                modelDistributions: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            factsheet: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            modelName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelType: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            participantsInModel: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            viewName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        })),
                    undefined
                ]),
                mostRecentEmployeeContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                mostRecentEmployerContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                mostRecentLoanContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                nextPayrollDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                participantsWithBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                participantsWithBeneficiary: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                participantsWithDeferrals: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                participationRate: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                readyToEnrollParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                registeredParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                terminatedParticipantsWithBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                totalContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                totalParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                totalPlanMarketValue: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock = (overrideResponse = {})=>({
        configurationId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        hasCompleted: faker.datatype.boolean(),
        hasOfficers: faker.datatype.boolean(),
        hasOwners: faker.datatype.boolean(),
        sponsorPlanId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecordsId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecorsdId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            grossCompensation: faker.number.int({
                max: undefined,
                min: undefined
            }),
            grosscompInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanOfficersResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecordsId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isOfficer: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            officerInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanOwnersResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isEmployee: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            ownerSince: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownersId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ownership: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            employee: {
                birthYear: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                censusRecordsId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                firstName: faker.word.sample(),
                hireDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                lastName: faker.word.sample(),
                ssn: faker.word.sample()
            },
            ownersFamilyId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            relationship: faker.word.sample()
        }));
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock = (overrideResponse = {})=>({
        onboarding: faker.helpers.arrayElement([
            {
                questionnaireSubmittedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock = (overrideResponse = {})=>({
        address: faker.helpers.arrayElement([
            {
                address1: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                address2: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                city: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                state: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                zip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        anticipatedHires: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        authSignerFirstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authSignerLastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authSignerWorkPhone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authorizedSignerEmail: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyEntityType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyPhoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contributionScenario: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        controlGroupBusinesses: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        currentComplianceIssues: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        dayToDayContactEmail: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactLastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        doingBusinessAs: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employerIdentificationNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        existingPlanProvider: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        existingPlanType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        fiscalYearEnd: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        hasOtherBusinesses: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        highlyCompensatedEmployees: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        industryGroup: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isConvert: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isPartOfControlGroup: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ownerEmployees: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        payrollProviderId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        payrollProviderOther: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        questionnaireSubmittedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        relativesOfOwnerEmployees: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        retirementObjectives: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sponsorPlan: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    pooledPlan: faker.helpers.arrayElement([
                        {
                            pooledPlanType: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    thirdPartyAdminPlan: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                thirdPartyAdminId: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ])
                            })),
                        undefined
                    ])
                })),
            undefined
        ]),
        stateOfIncorporation: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        totalEmployeesNumber: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        wiredAtWork: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock = (overrideResponse = {})=>({
        forfeituresBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        migrationDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                actionType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                amount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                createdAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                forfeitedBalance: faker.helpers.arrayElement([
                    {
                        participantFirstName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        participantId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        participantLastName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        withdrawalId: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    },
                    undefined
                ]),
                fundingContribution: faker.helpers.arrayElement([
                    {
                        expectedPayDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        ucid: faker.word.sample()
                    },
                    undefined
                ]),
                payingFees: faker.helpers.arrayElement([
                    {
                        billingPeriodId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        periodEndDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        periodStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        purpose: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                sourceTransactionId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                status: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tracerId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                transactionTypeCode: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            })),
        meta: {
            count: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthDate: faker.word.sample(),
            dateOfHire: faker.word.sample(),
            dateOfRehire: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employerDiscretionaryMatch: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            employerSafeHarborContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            firstName: faker.word.sample(),
            grossComp: faker.number.int({
                max: undefined,
                min: undefined
            }),
            lastName: faker.word.sample(),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            preTaxContribution: faker.number.int({
                max: undefined,
                min: undefined
            }),
            rothContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            secondDateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            sponsorPlanId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ssn: faker.word.sample(),
            ytdHours: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewarePostRefreshCensusResponseMock = (overrideResponse = {})=>({
        recordsAdded: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock = (overrideResponse = {})=>({
        started: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock = (overrideResponse = {})=>({
        areOfficersCompleted: faker.datatype.boolean(),
        areOwnerFamilyMembersCompleted: faker.datatype.boolean(),
        areOwnersCompleted: faker.datatype.boolean(),
        hasNoOfficers: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        hasNoOwners: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isCensusCompleted: faker.datatype.boolean(),
        isQuestionnaireCompleted: faker.datatype.boolean(),
        isYearEndItemComplete: faker.datatype.boolean(),
        isYearEndPackagingCompleted: faker.datatype.boolean(),
        planYear: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock = (overrideResponse = {})=>({
        areOfficersCompleted: faker.datatype.boolean(),
        areOwnerFamilyMembersCompleted: faker.datatype.boolean(),
        areOwnersCompleted: faker.datatype.boolean(),
        hasNoOfficers: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        hasNoOwners: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isCensusCompleted: faker.datatype.boolean(),
        isQuestionnaireCompleted: faker.datatype.boolean(),
        isYearEndItemComplete: faker.datatype.boolean(),
        isYearEndPackagingCompleted: faker.datatype.boolean(),
        planYear: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock = (overrideResponse = {})=>({
        shouldDisplayYearEndPlanToDo: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            documentKey: faker.word.sample(),
            entity: faker.word.sample(),
            entityId: faker.word.sample(),
            etag: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            isEnabled: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            originalFileName: faker.word.sample(),
            uploadPath: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanTestResultsResponseMock = (overrideResponse = {})=>({
        testExecution: {
            additionalData: {},
            document: faker.helpers.arrayElement([
                {
                    createdAt: faker.word.sample(),
                    documentKey: faker.word.sample(),
                    entity: faker.word.sample(),
                    entityId: faker.word.sample(),
                    etag: faker.word.sample(),
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    isEnabled: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    originalFileName: faker.word.sample(),
                    uploadPath: faker.word.sample()
                },
                undefined
            ]),
            documentTestResultId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            originalFileName: faker.word.sample(),
            result: faker.word.sample(),
            testId: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        yearEndContribution: {
            result: faker.word.sample(),
            resultDiscretionaryMatch: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            max: 10,
                                            min: 1
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                id: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                })
                            },
                            id: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            resultProfitSharing: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            max: 10,
                                            min: 1
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                id: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                })
                            },
                            id: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            resultSafeHarbor: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            max: 10,
                                            min: 1
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                id: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                })
                            },
                            id: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            resultYearEndContribution: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            max: 10,
                                            min: 1
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                id: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                })
                            },
                            id: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            testId: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock = (overrideResponse = {})=>({
        answers: {
            ASSETS_NOT_AT_LT_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BLACKOUT_PERIODS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BLACKOUT_PERIOD_NOTICE_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BOND_AMOUNT_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BUSINESS_CODE_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_PARTICIPATION_DOCUMENTS: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_PARTICIPATION_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            EMPLOYER_MATCH_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            EMPLOYER_MATCH_QUESTION_AMOUNT_AND_FORMULA: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            FEES_AND_COMMISSIONS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LATE_BENEFITS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LEASED_EMPLOYEES_DOCUMENTS: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LEASED_EMPLOYEES_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            MERGERS_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            MERGERS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            NONEXEMPT_TRANSACTIONS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_BUSINESS_EMPLOYEES_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_BUSINESS_OWNERSHIP_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_PLAN_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_PLAN_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PLAN_LOSS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PROFIT_SHARING_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PROFIT_SHARING_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            TAXED_AS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            TAX_EXTENSION_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            }
        },
        questionnaire: faker.word.sample(),
        sponsorId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        sponsorPlanId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        year: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock = (overrideResponse = {})=>({
        balanceAtRetirement: faker.number.int({
            max: undefined,
            min: undefined
        }),
        disclosure: faker.word.sample(),
        estimatedAnnualIncome: faker.number.int({
            max: undefined,
            min: undefined
        }),
        maxLoyaltyBonusPercentage: faker.number.int({
            max: undefined,
            min: undefined
        }),
        minLoyaltyBonusPercentage: faker.number.int({
            max: undefined,
            min: undefined
        }),
        retirementAge: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            address1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            address2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            allocationPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            beneficiaryId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            beneficiaryType: faker.helpers.arrayElement([
                'person',
                'trust',
                'organization'
            ]),
            businessName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            city: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ein: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            email: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            holdingFinancialInstitution: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isPrimary: faker.datatype.boolean(),
            lastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            phoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            relationship: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                    'spouse',
                    'child',
                    'parent',
                    'other'
                ]),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            state: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            trustId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            trustName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            zip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getPortalMiddlewareGetPlanByIdV2ResponseMock = (overrideResponse = {})=>({
        advisorId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        custodianAccountNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        effectiveDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        eligibleParticipants: faker.number.int({
            max: undefined,
            min: undefined
        }),
        employeeBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        employerBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        firmId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        forfeitureBalance: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        hasPriorLoans: faker.datatype.boolean(),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        inboundBlackoutEndDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        inboundBlackoutStartDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isActive: faker.datatype.boolean(),
        isBlackout: faker.datatype.boolean(),
        isOffboardingBlackoutActive: faker.datatype.boolean(),
        loanBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        name: faker.word.sample(),
        notes: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        offboardingBlackoutEndDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        offboardingBlackoutStartDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        participantsWithBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participantsWithDeferrals: faker.number.int({
            max: undefined,
            min: undefined
        }),
        programId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        readyToEnrollParticipants: faker.number.int({
            max: undefined,
            min: undefined
        }),
        recordkeeper: faker.word.sample(),
        recordkeeperId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        registeredParticipants: faker.number.int({
            max: undefined,
            min: undefined
        }),
        rolloverBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        sponsorCompanyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sponsorId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        statefulSchemaTrackingState: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        status: faker.word.sample(),
        totalBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        tpaIds: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>faker.number.int({
                    max: undefined,
                    min: undefined
                })),
            undefined
        ]),
        type: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock = (overrideResponse = {})=>({
        data: {
            gift: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            icon: faker.word.sample(),
            id: faker.word.sample(),
            legalName: faker.word.sample(),
            linkText: faker.word.sample(),
            logo: faker.word.sample(),
            name: faker.word.sample(),
            shortName: faker.word.sample(),
            siteUrl: faker.word.sample(),
            supportHoursPhone: faker.word.sample(),
            supportHoursTty: faker.word.sample(),
            supportPhone: faker.word.sample(),
            supportTty: faker.word.sample(),
            transactionLimits: {},
            type: faker.helpers.arrayElement([
                'able',
                'collegeSavings',
                'secureChoice'
            ]),
            urls: {}
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock = (overrideResponse = {})=>({
        data: {
            status: faker.helpers.arrayElement([
                'unknown',
                'none',
                'readOnly',
                'normal'
            ])
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock = (overrideResponse = {})=>({
        legal: {
            copyright: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            disclosures: faker.helpers.arrayElement([
                {
                    advisor: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    participant: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    sponsor: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                },
                undefined
            ]),
            links: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    text: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        links: {
            censusTemplate: faker.word.sample(),
            controlGroupHelpLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            csvInstructions: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            editEmployeeInfoAfterOnboardingLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gustoLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            notExpectingZero: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onPayLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payrollErrors: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            qboLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        login: {
            accountSetup: faker.helpers.arrayElement([
                {
                    infoBanner: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                description: faker.word.sample()
                            })),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        {
                            description: faker.word.sample(),
                            link: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            text: faker.word.sample()
                        },
                        undefined
                    ]),
                    page: faker.helpers.arrayElement([
                        {
                            selections: faker.helpers.arrayElement([
                                Array.from({
                                    length: faker.number.int({
                                        max: 10,
                                        min: 1
                                    })
                                }, (_, i)=>i + 1).map(()=>({
                                        description: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        link: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        title: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    })),
                                undefined
                            ]),
                            title: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            banner: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contacts: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            logo: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            resources: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        metadata: {
            favicon: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            title: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        mfa: {
            advisor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ])
        },
        navbar: {
            logo: {
                desktop: faker.word.sample(),
                mobile: faker.word.sample()
            }
        },
        registration: {
            documents: faker.helpers.arrayElement([
                {
                    esaSaverAgreement: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    terms: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            exemptionReasons: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    key: faker.word.sample(),
                    value: faker.word.sample()
                })),
            hasEIN: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasSDAT: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isState: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            link: faker.word.sample(),
            logo: faker.helpers.arrayElement([
                {
                    desktop: faker.word.sample(),
                    mobile: faker.word.sample()
                },
                undefined
            ]),
            name: faker.word.sample(),
            website: faker.word.sample()
        },
        sponsorOnboarding: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    items: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            details: faker.word.sample(),
                            item: faker.word.sample()
                        })),
                    title: faker.word.sample()
                })),
            undefined
        ]),
        subdomain: faker.word.sample(),
        support: {
            advisor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ])
        },
        theme: {
            palette: {
                primary: {
                    contrastText: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    dark: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    main: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                secondary: faker.helpers.arrayElement([
                    {
                        contrastText: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        dark: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        main: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ])
            }
        },
        whitelabelId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock = (overrideResponse = {})=>({
        legal: {
            copyright: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            disclosures: faker.helpers.arrayElement([
                {
                    advisor: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    participant: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    sponsor: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                },
                undefined
            ]),
            links: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    text: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        links: {
            censusTemplate: faker.word.sample(),
            controlGroupHelpLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            csvInstructions: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            editEmployeeInfoAfterOnboardingLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gustoLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            notExpectingZero: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onPayLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payrollErrors: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            qboLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        login: {
            accountSetup: faker.helpers.arrayElement([
                {
                    infoBanner: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                description: faker.word.sample()
                            })),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        {
                            description: faker.word.sample(),
                            link: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            text: faker.word.sample()
                        },
                        undefined
                    ]),
                    page: faker.helpers.arrayElement([
                        {
                            selections: faker.helpers.arrayElement([
                                Array.from({
                                    length: faker.number.int({
                                        max: 10,
                                        min: 1
                                    })
                                }, (_, i)=>i + 1).map(()=>({
                                        description: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        link: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        title: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    })),
                                undefined
                            ]),
                            title: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            banner: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contacts: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            logo: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            resources: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        metadata: {
            favicon: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            title: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        mfa: {
            advisor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ])
        },
        navbar: {
            logo: {
                desktop: faker.word.sample(),
                mobile: faker.word.sample()
            }
        },
        registration: {
            documents: faker.helpers.arrayElement([
                {
                    esaSaverAgreement: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    terms: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            exemptionReasons: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    key: faker.word.sample(),
                    value: faker.word.sample()
                })),
            hasEIN: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasSDAT: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isState: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            link: faker.word.sample(),
            logo: faker.helpers.arrayElement([
                {
                    desktop: faker.word.sample(),
                    mobile: faker.word.sample()
                },
                undefined
            ]),
            name: faker.word.sample(),
            website: faker.word.sample()
        },
        sponsorOnboarding: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    items: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            details: faker.word.sample(),
                            item: faker.word.sample()
                        })),
                    title: faker.word.sample()
                })),
            undefined
        ]),
        subdomain: faker.word.sample(),
        support: {
            advisor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ])
        },
        theme: {
            palette: {
                primary: {
                    contrastText: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    dark: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    main: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                secondary: faker.helpers.arrayElement([
                    {
                        contrastText: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        dark: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        main: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ])
            }
        },
        whitelabelId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock = ()=>faker.number.int();
export const getPortalMiddlewareGetRmdAmountResponseMock = (overrideResponse = {})=>({
        age1: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        age2: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        lifeExpectancy: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        requiredAmount: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        type: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        vestedBalance: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        withdrawalAmount: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        year: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock = (overrideResponse = {})=>({
        balance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        year: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    address: faker.helpers.arrayElement([
                        {
                            address1: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            zip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    mailType: faker.helpers.arrayElement([
                        faker.helpers.arrayElement([
                            'Express Mail',
                            'Normal Mail'
                        ]),
                        undefined
                    ]),
                    providerAlias: faker.word.sample(),
                    providerName: faker.word.sample(),
                    providerShort: faker.word.sample()
                })),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock = (overrideResponse = {})=>({
        data: {
            code1099: faker.word.sample(),
            federalWithholdingPercent: faker.word.sample(),
            qualifiedRoth: faker.word.sample(),
            rothInitialYear: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            stateWithholdingCode: faker.word.sample(),
            stateWithholdingPercent: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            taxType: faker.word.sample()
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                code1099: faker.word.sample(),
                federalWithholdingAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                federalWithholdingPercent: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                isQualifiedRoth: faker.datatype.boolean(),
                isRollover: faker.datatype.boolean(),
                rothInitialYear: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                stateWithholdingAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                stateWithholdingCode: faker.word.sample(),
                stateWithholdingPercent: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                taxType: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            code: faker.word.sample(),
            description: faker.word.sample(),
            naicsCodeId: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetZendeskJwtResponseMock = (overrideResponse = {})=>({
        conversationFields: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                id: faker.word.sample(),
                value: {}
            })),
        jwt: faker.word.sample(),
        key: faker.word.sample(),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock = (overrideResponse = {})=>({
        nestedProp: {
            ref: faker.datatype.boolean()
        },
        public: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getWentworthPostDemoSdkResponseMock = (overrideResponse = {})=>({
        demo: faker.datatype.boolean(),
        name: faker.word.sample(),
        nestedProp: {
            nested: faker.datatype.boolean()
        },
        ...overrideResponse
    });
export const getHealthGetConnectivityMockHandler = (overrideResponse)=>{
    return http.get('*/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetConnectivityResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getHealthPostDemoSDKMockHandler = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getHealthGetHealthMockHandler = (overrideResponse)=>{
    return http.get('*/health', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingHealthGetConnectivityMockHandler = (overrideResponse)=>{
    return http.get('*/ob/connectivity', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetConnectivityMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/connectivity', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getHealthGetPublicRouteMockHandler = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthGetConnectivityMockHandler = (overrideResponse)=>{
    return http.get('*/wt/connectivity', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getWentworthPostDemoSdkMockHandler = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthPostDemoSdkResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthGetHealthMockHandler = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getVestwellUnifiedApiHooksMock = ()=>[
        getHealthGetConnectivityMockHandler(),
        getHealthPostDemoSDKMockHandler(),
        getHealthGetHealthMockHandler(),
        getOnboardingHealthGetConnectivityMockHandler(),
        getOnboardingHealthPostDemoSdkMockHandler(),
        getOnboardingDocumentGetSigningMappingsMockHandler(),
        getOnboardingDocusignGetDocusignConnectivityMockHandler(),
        getOnboardingDocusignGetEnvelopesMockHandler(),
        getOnboardingDocusignGetEnvelopeMockHandler(),
        getOnboardingDocusignGetEnvelopeRecipientsMockHandler(),
        getOnboardingDocusignPostEnvelopeRecipientMockHandler(),
        getOnboardingDocusignGetAccessTokenMockHandler(),
        getOnboardingDocusignGetUserInfoMockHandler(),
        getOnboardingHealthGetHealthMockHandler(),
        getPortalMiddlewareGetAdvisorByIdMockHandler(),
        getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler(),
        getPortalMiddlewareGetAdvisorContactCardMockHandler(),
        getPortalMiddlewarePutAdvisorContactCardMockHandler(),
        getPortalMiddlewareGetPlansMockHandler(),
        getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler(),
        getPortalMiddlewareGetPlansTrackerMockHandler(),
        getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler(),
        getPortalMiddlewareGetPlanEmployeeMockHandler(),
        getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler(),
        getPortalMiddlewarePostLinkSponsorMockHandler(),
        getPortalMiddlewareGetAdvisorStatsMockHandler(),
        getPortalMiddlewareGetCarouselMockHandler(),
        getPortalMiddlewareGetConnectivityMockHandler(),
        getPortalMiddlewareGetCsmMockHandler(),
        getPortalMiddlewareGetLoginDisclosureMockHandler(),
        getPortalMiddlewarePutLoginDisclosureMockHandler(),
        getPortalMiddlewareGetLoginDisclosureAgreementMockHandler(),
        getPortalMiddlewareGetDocumentByIdMockHandler(),
        getPortalMiddlewarePatchDeleteDocumentByIdMockHandler(),
        getPortalMiddlewareGetAllDocumentsMockHandler(),
        getPortalMiddlewareGetDocumentAgreementMockHandler(),
        getPortalMiddlewarePostDocumentAgreementMockHandler(),
        getPortalMiddlewareGetDocumentDownloadByIdMockHandler(),
        getPortalMiddlewareGetDocumentDownloadByKeyMockHandler(),
        getPortalMiddlewareGetDocumentAsHtmlMockHandler(),
        getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler(),
        getPortalMiddlewarePostPdfMockHandler(),
        getPortalMiddlewarePostProcessDocumentMockHandler(),
        getPortalMiddlewarePostUploadDocumentMockHandler(),
        getPortalMiddlewarePostEmailMockHandler(),
        getPortalMiddlewarePostEmailPreviewRenderMockHandler(),
        getPortalMiddlewareGetEmailPreviewByIdMockHandler(),
        getPortalMiddlewareGetEmployeeHoldingsMockHandler(),
        getPortalMiddlewareGetEmployeeLoansMockHandler(),
        getPortalMiddlewareGetEmployeePerformanceMockHandler(),
        getPortalMiddlewareGetEmployeeTransactionsMockHandler(),
        getPortalMiddlewareGetEmployeePendingTransactionsMockHandler(),
        getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler(),
        getPortalMiddlewareGetProgramModelSecuritiesMockHandler(),
        getPortalMiddlewareGetEmployeesWithContributionsMockHandler(),
        getPortalMiddlewareGetEmployeeLoanDetailsMockHandler(),
        getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler(),
        getPortalMiddlewarePatchEsaParticipantGoalMockHandler(),
        getPortalMiddlewareGetEsaParticipantGoalsMockHandler(),
        getPortalMiddlewareGetEsaParticipantIncentivesMockHandler(),
        getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler(),
        getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler(),
        getPortalMiddlewareGetEsaPlanGroupStatsMockHandler(),
        getPortalMiddlewareGetEsaPlanGroupsMockHandler(),
        getPortalMiddlewareGetEsaPlanIncentivesMockHandler(),
        getPortalMiddlewarePatchEsaWithdrawalMockHandler(),
        getPortalMiddlewareGetFi360DownloadMockHandler(),
        getPortalMiddlewareGetFeatureTogglesMockHandler(),
        getPortalMiddlewareGetFeatureTogglesListMockHandler(),
        getPortalMiddlewareGetFirmByIdMockHandler(),
        getPortalMiddlewareGetGiftContributorRecurringMockHandler(),
        getPortalMiddlewareDeleteGiftContributorRecurringMockHandler(),
        getPortalMiddlewareGetGiftContributorBanksMockHandler(),
        getPortalMiddlewareGetGiftContributorPaymentsMockHandler(),
        getPortalMiddlewareGetGiftContributorRecipientsMockHandler(),
        getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler(),
        getPortalMiddlewareGetGiftingPageByIdMockHandler(),
        getPortalMiddlewarePostCreateGiftorProfileMockHandler(),
        getPortalMiddlewarePutValidateGiftorProfileMockHandler(),
        getPortalMiddlewarePostGiftSubmissionMockHandler(),
        getPortalMiddlewarePutValidateGiftSubmissionMockHandler(),
        getPortalMiddlewareGetHealthMockHandler(),
        getPortalMiddlewareGetLoanAmortizationPdfMockHandler(),
        getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler(),
        getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler(),
        getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler(),
        getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler(),
        getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler(),
        getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler(),
        getPortalMiddlewarePostMsManagedAccountsActivateMockHandler(),
        getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler(),
        getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler(),
        getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler(),
        getPortalMiddlewareGetDigitalOnboardingStateMockHandler(),
        getPortalMiddlewarePatchDigitalOnboardingStateMockHandler(),
        getPortalMiddlewarePutDigitalOnboardingStateMockHandler(),
        getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler(),
        getPortalMiddlewareGetParticipantByIdMockHandler(),
        getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler(),
        getPortalMiddlewarePostParticipantLoanMockHandler(),
        getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler(),
        getPortalMiddlewareGetParticipantPlaidLinksMockHandler(),
        getPortalMiddlewarePostParticipantPlaidLinksMockHandler(),
        getPortalMiddlewareGetParticipantLoanCreateMockHandler(),
        getPortalMiddlewarePatchParticipantLoanMockHandler(),
        getPortalMiddlewarePostLoanManualRepaymentMockHandler(),
        getPortalMiddlewareGetParticipantAccountsMockHandler(),
        getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler(),
        getPortalMiddlewarePutArchiveBankAccountMockHandler(),
        getPortalMiddlewareGetParticipantBankAccountsMockHandler(),
        getPortalMiddlewareGetParticipantDepositsMockHandler(),
        getPortalMiddlewarePostDepositDataMockHandler(),
        getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler(),
        getPortalMiddlewarePutRecurringScheduleMockHandler(),
        getPortalMiddlewareGetDepositMockHandler(),
        getPortalMiddlewareGetRecentParticipantDocumentsMockHandler(),
        getPortalMiddlewarePostParticipantEligibilityMockHandler(),
        getPortalMiddlewarePostEsaGoalMockHandler(),
        getPortalMiddlewareGetParticipantIdentityVerificationMockHandler(),
        getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler(),
        getPortalMiddlewareGetGoalFeedbackMockHandler(),
        getPortalMiddlewarePostElectionAgeSuggestionMockHandler(),
        getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler(),
        getPortalMiddlewareGetElectionsSetupMockHandler(),
        getPortalMiddlewarePostElectionsSetupMockHandler(),
        getPortalMiddlewareGetInvestmentsModelDisplayMockHandler(),
        getPortalMiddlewareGetPlanParticipantStatsMockHandler(),
        getPortalMiddlewarePostRebalanceRequestMockHandler(),
        getPortalMiddlewareGetRebalanceSettingsMockHandler(),
        getPortalMiddlewarePutRebalanceSettingsMockHandler(),
        getPortalMiddlewareGetStrategiesIndexMockHandler(),
        getPortalMiddlewareGetAgeBasedMockHandler(),
        getPortalMiddlewarePutAgeBasedMockHandler(),
        getPortalMiddlewarePutCustomAllocationMockHandler(),
        getPortalMiddlewareGetRiskBasedMockHandler(),
        getPortalMiddlewarePutRiskBasedMockHandler(),
        getPortalMiddlewareGetRiskModelQuestionnaireMockHandler(),
        getPortalMiddlewareGetMailPreferencesMockHandler(),
        getPortalMiddlewarePutMailPreferencesMockHandler(),
        getPortalMiddlewareGetParticipantOnboardingMockHandler(),
        getPortalMiddlewareGetParticipantOverviewMockHandler(),
        getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler(),
        getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler(),
        getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler(),
        getPortalMiddlewareGetPositionsMockHandler(),
        getPortalMiddlewareGetQboadWithdrawalsMockHandler(),
        getPortalMiddlewarePatchParticipantRolloverMockHandler(),
        getPortalMiddlewareGetRolloverInstructionsMockHandler(),
        getPortalMiddlewareGetRolloverEligibilityMockHandler(),
        getPortalMiddlewarePostParticipantRolloverMockHandler(),
        getPortalMiddlewareGetParticipantRolloverMockHandler(),
        getPortalMiddlewareGetGenerateRolloverLetterMockHandler(),
        getPortalMiddlewareGetSavingsDisplayMockHandler(),
        getPortalMiddlewarePutSavingsMockHandler(),
        getPortalMiddlewareGetSurveyLinkMockHandler(),
        getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler(),
        getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler(),
        getPortalMiddlewarePostWithdrawalMockHandler(),
        getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler(),
        getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler(),
        getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler(),
        getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler(),
        getPortalMiddlewareGetUnregisteredParticipantsMockHandler(),
        getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler(),
        getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler(),
        getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler(),
        getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler(),
        getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler(),
        getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler(),
        getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler(),
        getPortalMiddlewareGetPlanDesignMockHandler(),
        getPortalMiddlewarePatchUpdatePlanDesignMockHandler(),
        getPortalMiddlewareGetPlanDesignTilesMockHandler(),
        getPortalMiddlewareGetPlanParticipantsMockHandler(),
        getPortalMiddlewareGetPlanModelMockHandler(),
        getPortalMiddlewarePatchPlanMockHandler(),
        getPortalMiddlewareGetEsaProgramMockHandler(),
        getPortalMiddlewareGetPlanInvestmentsMockHandler(),
        getPortalMiddlewareGetPlanModelSecuritiesMockHandler(),
        getPortalMiddlewareGetProgramModelsMockHandler(),
        getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler(),
        getPortalMiddlewareGetProspectusUrlPartsMockHandler(),
        getPortalMiddlewareGetAdvisorReportMockHandler(),
        getPortalMiddlewareGetEmployeeReportMockHandler(),
        getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler(),
        getPortalMiddlewareGetPlanReportMockHandler(),
        getPortalMiddlewareGetSponsorReportMockHandler(),
        getPortalMiddlewareGetSubaTransactionsReportMockHandler(),
        getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler(),
        getPortalMiddlewareGetSubaExternalMarketValueMockHandler(),
        getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler(),
        getPortalMiddlewareGetSdbaSetupMockHandler(),
        getPortalMiddlewareGetSdbaTransfersInfoMockHandler(),
        getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler(),
        getPortalMiddlewareGetSessionMockHandler(),
        getPortalMiddlewareGetSponsorAbilitiesMockHandler(),
        getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler(),
        getPortalMiddlewareGetCensusParticipantsMockHandler(),
        getPortalMiddlewareGetBankAccountMockHandler(),
        getPortalMiddlewarePostBankAccountMockHandler(),
        getPortalMiddlewarePutBankAccountMockHandler(),
        getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler(),
        getPortalMiddlewarePutFeePaymentMethodMockHandler(),
        getPortalMiddlewarePatchSponsorMockHandler(),
        getPortalMiddlewareGetSponsorTeammatesMockHandler(),
        getPortalMiddlewarePatchDeleteTeammateMockHandler(),
        getPortalMiddlewarePostSendUserInviteMockHandler(),
        getPortalMiddlewareGetPlanConfigurationV2MockHandler(),
        getPortalMiddlewarePutPlanConfigurationV2MockHandler(),
        getPortalMiddlewareGetPlanEmployeesV2MockHandler(),
        getPortalMiddlewareGetPlanGrossCompensationV2MockHandler(),
        getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler(),
        getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler(),
        getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler(),
        getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler(),
        getPortalMiddlewareGetPlanOfficersV2MockHandler(),
        getPortalMiddlewarePutPlanOfficerStatusV2MockHandler(),
        getPortalMiddlewareDeletePlanOwnerV2MockHandler(),
        getPortalMiddlewareGetPlanOwnersV2MockHandler(),
        getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler(),
        getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler(),
        getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler(),
        getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler(),
        getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler(),
        getPortalMiddlewarePostFileHeadersUpdateMockHandler(),
        getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler(),
        getPortalMiddlewarePostContributionMockHandler(),
        getPortalMiddlewarePostCancelSubmissionMockHandler(),
        getPortalMiddlewarePostCancellationSubmissionMockHandler(),
        getPortalMiddlewareGetParticipantsLoansMockHandler(),
        getPortalMiddlewarePostMatchRemediationContributionMockHandler(),
        getPortalMiddlewarePostOffCycleContributionMockHandler(),
        getPortalMiddlewarePostResumeSubmissionMockHandler(),
        getPortalMiddlewarePostIngestionFlowValidationMockHandler(),
        getPortalMiddlewarePostContributionValidationMockHandler(),
        getPortalMiddlewareGetContributionSubmissionDisplayMockHandler(),
        getPortalMiddlewareGetContributionAdjustmentsMockHandler(),
        getPortalMiddlewarePostContributionConfirmationMockHandler(),
        getPortalMiddlewareGetContributionConfirmationDisplayMockHandler(),
        getPortalMiddlewarePostContributionCorrectionMockHandler(),
        getPortalMiddlewareGetContributionCorrectionsMockHandler(),
        getPortalMiddlewareGetContributionDetailsMockHandler(),
        getPortalMiddlewareGetContributionDisplayMockHandler(),
        getPortalMiddlewarePostContributionUploadMockHandler(),
        getPortalMiddlewareGetDownloadContributionFileMockHandler(),
        getPortalMiddlewareGetForfeitureMockHandler(),
        getPortalMiddlewarePostForfeitureMockHandler(),
        getPortalMiddlewareGetContributionHeaderValidationsMockHandler(),
        getPortalMiddlewareGetNormalizedContributionDataMockHandler(),
        getPortalMiddlewarePostIngestionFlowStartMockHandler(),
        getPortalMiddlewareGetDownloadContributionTemplateMockHandler(),
        getPortalMiddlewareGetContributionValidationPageDisplayMockHandler(),
        getPortalMiddlewareGetContributionValidationMockHandler(),
        getPortalMiddlewareGetDeferralChangesMockHandler(),
        getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler(),
        getPortalMiddlewarePutParticipantMockHandler(),
        getPortalMiddlewareGetEmployeeClassesMockHandler(),
        getPortalMiddlewareGetEmployeesMockHandler(),
        getPortalMiddlewarePutParticipantsMockHandler(),
        getPortalMiddlewarePostUploadCensusOriginalMockHandler(),
        getPortalMiddlewarePostValidateEmployeeMockHandler(),
        getPortalMiddlewareGetEmployeeDetailsMockHandler(),
        getPortalMiddlewarePostContactInfoMockHandler(),
        getPortalMiddlewarePutParticipantContributionsMockHandler(),
        getPortalMiddlewareGetSponsorEntityMockHandler(),
        getPortalMiddlewareGetForfeiturePreferenceMockHandler(),
        getPortalMiddlewarePutForfeiturePreferenceMockHandler(),
        getPortalMiddlewareGetHeapDataMockHandler(),
        getPortalMiddlewareGetOnboardingMockHandler(),
        getPortalMiddlewarePostOnboardingMockHandler(),
        getPortalMiddlewarePutOnboardingMockHandler(),
        getPortalMiddlewareGetSponsorOnboardingInformationMockHandler(),
        getPortalMiddlewarePutSponsorOnboardingInformationMockHandler(),
        getPortalMiddlewarePostUploadCensusMockHandler(),
        getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler(),
        getPortalMiddlewareGetInitialCensusMockHandler(),
        getPortalMiddlewareDeleteCensusCacheMockHandler(),
        getPortalMiddlewareGetCensusCacheMockHandler(),
        getPortalMiddlewarePostCensusCacheMockHandler(),
        getPortalMiddlewareGetSponsorEsaProgramMockHandler(),
        getPortalMiddlewarePostFinishOnboardingMockHandler(),
        getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler(),
        getPortalMiddlewarePostSendOnboardingUserInviteMockHandler(),
        getPortalMiddlewareGetNextPayrollDatesMockHandler(),
        getPortalMiddlewareGetPayrollProvidersMockHandler(),
        getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler(),
        getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler(),
        getPortalMiddlewareGetPlanDesignConsultStateMockHandler(),
        getPortalMiddlewareGetPlanLaunchCallUrlMockHandler(),
        getPortalMiddlewareGetUserRolesMockHandler(),
        getPortalMiddlewareGetPayrollConnectionStatusMockHandler(),
        getPortalMiddlewareGetPayrollDatesMockHandler(),
        getPortalMiddlewareGetPayrollInfoMockHandler(),
        getPortalMiddlewareGetPayrollSetupsMockHandler(),
        getPortalMiddlewarePostPayrollSetupMockHandler(),
        getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler(),
        getPortalMiddlewareGetPayrollFundingSetupsMockHandler(),
        getPortalMiddlewarePutPayrollProviderMockHandler(),
        getPortalMiddlewarePutPayrollSkipStatusMockHandler(),
        getPortalMiddlewarePutSkipSubmissionMockHandler(),
        getPortalMiddlewareDeletePayrollSetupMockHandler(),
        getPortalMiddlewarePutPayrollDatesMockHandler(),
        getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler(),
        getPortalMiddlewarePutPayrollSetupInfoMockHandler(),
        getPortalMiddlewarePostPayrollValidationsMockHandler(),
        getPortalMiddlewareGetPlanFeaturesMockHandler(),
        getPortalMiddlewareGetPlanOnboardingStatusMockHandler(),
        getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler(),
        getPortalMiddlewareGetPlanStatisticsMockHandler(),
        getPortalMiddlewareGetPlanConfigurationMockHandler(),
        getPortalMiddlewarePutPlanConfigurationMockHandler(),
        getPortalMiddlewareGetPlanEmployeesMockHandler(),
        getPortalMiddlewareGetPlanGrossCompensationMockHandler(),
        getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler(),
        getPortalMiddlewareGetGrossCompensationTemplateMockHandler(),
        getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler(),
        getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler(),
        getPortalMiddlewareGetPlanOfficersMockHandler(),
        getPortalMiddlewarePutPlanOfficerStatusMockHandler(),
        getPortalMiddlewareDeletePlanOwnerMockHandler(),
        getPortalMiddlewareGetPlanOwnersMockHandler(),
        getPortalMiddlewarePostPlanEmployeeOwnerMockHandler(),
        getPortalMiddlewarePutPlanEmployeeOwnerMockHandler(),
        getPortalMiddlewareDeletePlanOwnersFamilyMockHandler(),
        getPortalMiddlewareGetPlanOwnersFamilyMockHandler(),
        getPortalMiddlewarePutPlanOwnersFamilyMockHandler(),
        getPortalMiddlewareGetTrackerDetailsMockHandler(),
        getPortalMiddlewarePostPriorProviderMockHandler(),
        getPortalMiddlewareGetPriorProvidersMockHandler(),
        getPortalMiddlewareGetSponsorQuestionnaireMockHandler(),
        getPortalMiddlewarePatchSponsorQuestionnaireMockHandler(),
        getPortalMiddlewareGetQuestionnaireInformationMockHandler(),
        getPortalMiddlewareGetContributionsMockHandler(),
        getPortalMiddlewareGetSubaPlanDetailsMockHandler(),
        getPortalMiddlewareGetSubaTransactionsMockHandler(),
        getPortalMiddlewarePostYetCensusAutosaveMockHandler(),
        getPortalMiddlewareGetYetCensusDataDownloadMockHandler(),
        getPortalMiddlewareGetYetCensusDataPagedMockHandler(),
        getPortalMiddlewarePostRefreshCensusMockHandler(),
        getPortalMiddlewarePostRestartCensusMockHandler(),
        getPortalMiddlewarePostYetCensusStartMockHandler(),
        getPortalMiddlewareGetCensusStatusMockHandler(),
        getPortalMiddlewarePostYetCensusSubmitMockHandler(),
        getPortalMiddlewarePostYetCensusUploadMockHandler(),
        getPortalMiddlewareGetYetChecklistMockHandler(),
        getPortalMiddlewarePatchYetChecklistMockHandler(),
        getPortalMiddlewareGetYetConfigMockHandler(),
        getPortalMiddlewarePostContributionsFundMockHandler(),
        getPortalMiddlewarePostContributionsRefundMockHandler(),
        getPortalMiddlewareGetYetDocumentsMockHandler(),
        getPortalMiddlewarePostStartOfPackagingMockHandler(),
        getPortalMiddlewareGetPlanTestResultsMockHandler(),
        getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler(),
        getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler(),
        getPortalMiddlewarePostRestartTestingProcessMockHandler(),
        getPortalMiddlewareGetYetStatusMockHandler(),
        getPortalMiddlewareGetYtdContributionsMockHandler(),
        getPortalMiddlewareGetTiaaIncomeProjectionMockHandler(),
        getPortalMiddlewarePatchParticipantByIdMockHandler(),
        getPortalMiddlewareGetParticipantBeneficiariesMockHandler(),
        getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler(),
        getPortalMiddlewareGetPlanByIdV2MockHandler(),
        getPortalMiddlewareGetVssPlanByIdMockHandler(),
        getPortalMiddlewareGetVssStatusMockHandler(),
        getPortalMiddlewarePostLobLetterEventsWebhookMockHandler(),
        getPortalMiddlewareGetWhiteLabelMockHandler(),
        getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler(),
        getPortalMiddlewarePostCreateWithdrawalMockHandler(),
        getPortalMiddlewareGetRmdAmountMockHandler(),
        getPortalMiddlewareGetRmdBalanceMockHandler(),
        getPortalMiddlewareGetRolloverProvidersMockHandler(),
        getPortalMiddlewareGetWithholdingMockHandler(),
        getPortalMiddlewareGetWithholdingDetailMockHandler(),
        getPortalMiddlewareGetYetNaicsMockHandler(),
        getPortalMiddlewareGetZendeskJwtMockHandler(),
        getPortalMiddlewareGetEntitySessionMockHandler(),
        getHealthGetPublicRouteMockHandler(),
        getWentworthGetConnectivityMockHandler(),
        getWentworthPostDemoSdkMockHandler(),
        getWentworthGetHealthMockHandler()
    ];

//# sourceMappingURL=index.js.map